import { useState, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, RadarChart, Radar, PolarGrid, PolarAngleAxis } from "recharts";

const LOGO_LUMEN = 'data:image/png;base64,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';

// ─── TEMA ────────────────────────────────────────────────────────────────────
const T = {
  laranja: "#F44D19", laranjaM: "#EF8220", azul: "#0075EA",
  marinho: "#12273D", bg: "#0A1628", card: "#0F2035", cardL: "#162B45",
  border: "#1C3550", text: "#E8F4FF", muted: "#6A90B8",
  success: "#22c55e", warning: "#f59e0b", danger: "#ef4444",
};

// ─── PERGUNTAS DMG ───────────────────────────────────────────────────────────
const DMG_PERGUNTAS = {
  lideranca: { label: "Liderança", icon: "👑", cor: T.laranja, perguntas: ["A liderança define e comunica claramente a visão e os objetivos estratégicos?", "Os líderes tomam decisões com base em dados e indicadores de desempenho?", "Existe processo estruturado de desenvolvimento e sucessão de lideranças?", "Os líderes praticam feedback regular e construtivo com suas equipes?", "A liderança promove cultura de melhoria contínua e inovação?", "Os valores organizacionais são vivenciados no dia a dia pela liderança?", "Existe alinhamento entre os líderes sobre prioridades e direcionamento estratégico?"] },
  estrategia: { label: "Estratégias e Planos", icon: "🎯", cor: T.laranjaM, perguntas: ["A empresa possui planejamento estratégico formal com metas e prazos?", "Os objetivos estratégicos são desdobrados em planos de ação para todas as áreas?", "Existe acompanhamento periódico do cumprimento das metas estratégicas?", "A empresa realiza análise de mercado e concorrência regularmente?", "Os planos são revisados e ajustados quando o cenário muda?", "Todos os colaboradores conhecem e entendem a estratégia da empresa?", "Existe orçamento (budget) anual alinhado às prioridades estratégicas?"] },
  clientes: { label: "Clientes", icon: "🤝", cor: T.azul, perguntas: ["A empresa possui processos formais para medir a satisfação dos clientes?", "Existe política clara de atendimento e resolução de reclamações?", "Os dados de clientes são utilizados para tomada de decisão comercial?", "A empresa monitora taxa de retenção e reativação de clientes?", "Há processo estruturado de prospecção e desenvolvimento de novos clientes?", "O pós-venda é tratado como parte estratégica do negócio?", "A empresa segmenta sua carteira e personaliza o atendimento?"] },
  sociedade: { label: "Sociedade", icon: "🌱", cor: T.success, perguntas: ["A empresa possui práticas de responsabilidade social e ambiental formalizadas?", "Existe preocupação com o impacto das operações no meio ambiente?", "A empresa contribui para o desenvolvimento da comunidade local?", "Há políticas de diversidade, equidade e inclusão implementadas?", "A empresa cumpre todas as obrigações legais e regulatórias?", "Existem práticas de governança corporativa formalizadas?", "A empresa comunica suas ações socioambientais para stakeholders?"] },
  informacao: { label: "Informação e Conhecimento", icon: "📊", cor: "#8b5cf6", perguntas: ["A empresa possui sistema de gestão que centraliza informações do negócio?", "Os dados financeiros são confiáveis, atualizados e acessíveis?", "Existem KPIs definidos e monitorados regularmente?", "O conhecimento crítico está documentado e não fica só na memória das pessoas?", "As informações chegam às pessoas certas no momento certo?", "A empresa usa dados para identificar problemas e oportunidades?", "Existe cultura de registro e aprendizado com erros e acertos?"] },
  pessoas: { label: "Pessoas", icon: "👥", cor: T.warning, perguntas: ["A empresa possui descrições de cargo e estrutura organizacional clara?", "Existe processo formal de recrutamento, seleção e integração?", "Há plano de desenvolvimento e capacitação para os colaboradores?", "A empresa pratica avaliação de desempenho com critérios claros?", "O clima organizacional é monitorado e existem ações sobre os resultados?", "A política de remuneração e benefícios é competitiva e transparente?", "Existe gestão ativa da rotatividade e plano de retenção de talentos?"] },
  processos: { label: "Processos", icon: "⚙️", cor: "#06b6d4", perguntas: ["Os principais processos estão documentados e padronizados (POPs)?", "Existe monitoramento de indicadores de qualidade e produtividade?", "As não conformidades são registradas e tratadas sistematicamente?", "A empresa realiza melhorias contínuas nos processos operacionais?", "Os processos de compras, estoque e logística são gerenciados com indicadores?", "Existe controle financeiro integrado com os processos operacionais?", "A empresa possui processos de auditoria interna para verificar conformidade?"] },
};

const DMG_ESCALA = [
  { val: 0, label: "Não existe", cor: T.danger },
  { val: 25, label: "Inicial", cor: "#f97316" },
  { val: 50, label: "Em desenvolvimento", cor: T.warning },
  { val: 75, label: "Implantado", cor: "#84cc16" },
  { val: 100, label: "Consolidado", cor: T.success },
];

const SEGMENTOS = ["Indústria", "E-commerce", "Transporte", "Cooperativa", "Saúde", "Agronegócio", "Manufatura", "Importadora", "Automotivo"];
const TIPOS_VISITA = ["Consultoria", "Mentoria", "Auditoria", "Workshop", "Estratégica", "Diagnóstico"];
const DMG_PILARES = Object.keys(DMG_PERGUNTAS);

// ─── MENUS POR PERFIL ────────────────────────────────────────────────────────
const MENUS_ADMIN = [
  { id: "dashboard", label: "Dashboard", icon: "◈" },
  { id: "prospects", label: "Prospects", icon: "🎯" },
  { id: "projetos", label: "Projetos", icon: "◉" },
  { id: "tiposProjeto", label: "Tipos de Projeto", icon: "🗂️" },
  { id: "calendario", label: "Calendário", icon: "📅" },
  { id: "visitas", label: "Atendimentos", icon: "◎" },
  { id: "planoacao", label: "Plano de Ação", icon: "✅" },
  { id: "marcos", label: "Marcos", icon: "◆" },
  { id: "dmg", label: "DMG", icon: "▣" },
  { id: "dps", label: "DPS", icon: "◈" },
  { id: "especialistas", label: "Especialistas", icon: "👤" },
  { id: "consultores", label: "Consultores", icon: "🤝" },
  { id: "relatorios", label: "Relatórios", icon: "◐" },
];
const MENUS_ESPECIALISTA = [
  { id: "dashboard", label: "Meu Dashboard", icon: "◈" },
  { id: "calendario", label: "Meu Calendário", icon: "📅" },
  { id: "visitas", label: "Meus Atendimentos", icon: "◎" },
  { id: "planoacao", label: "Plano de Ação", icon: "✅" },
  { id: "marcos", label: "Marcos", icon: "◆" },
  { id: "dmg", label: "DMG", icon: "▣" },
  { id: "dps", label: "DPS", icon: "◈" },
];

// ─── PIPELINE DE PROSPECTS ───────────────────────────────────────────────────
const FASES_PIPELINE = ["CONTRATANDO", "FECHANDO", "INTEGRANDO"];
const CHECKLIST_FASES = {
  CONTRATANDO: [
    "Envio de portfólio e materiais",
    "Confecção da proposta",
    "Reunião de apresentação da proposta",
    "Envio de materiais sobre o Lumen",
  ],
  FECHANDO: [
    "Levantamento de dados do cliente",
    "E-mail de boas-vindas",
    "Manual do cliente Lumen",
    "Assinatura do contrato",
  ],
  INTEGRANDO: [
    "Reunião de apresentação do time",
    "Agenda de primeiros atendimentos",
    "Acesso no Lumen Academy",
    "Reunião de abertura",
  ],
};
const COR_FASE = { CONTRATANDO: "#0075EA", FECHANDO: "#EF8220", INTEGRANDO: "#22c55e" };

// ─── UTILITÁRIOS ─────────────────────────────────────────────────────────────
const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "-";
const fmtMoeda = (v) => `R$ ${Number(v).toLocaleString("pt-BR")}`;
const calcMat = (dmg) => { if (!dmg) return 0; const v = Object.entries(dmg).filter(([k,val]) => k !== 'analiseIA' && k !== 'clienteId' && typeof val === 'number').map(([,val]) => val); if (!v.length) return 0; return Math.round(v.reduce((a, b) => a + b, 0) / v.length); };
const statusColor = (s) => { if (["Ativo", "Concluído", "Realizada"].includes(s)) return T.success; if (["Em andamento", "Agendada", "Iniciado"].includes(s)) return T.laranjaM; if (["Novo", "Pendente", "A Iniciar"].includes(s)) return T.azul; if (s === "Confirmada") return "#8b5cf6"; if (s === "Atrasado") return T.danger; if (s === "Inativo") return T.danger; if (s === "Parceiro externo") return "#8b5cf6"; return T.muted; };
const prioColor = (p) => p === "Alta" ? T.danger : p === "Média" ? T.warning : T.muted;
const iniciais = (nome) => nome ? nome.split(" ").slice(0, 2).map(n => n[0]).join("").toUpperCase() : "?";

// ─── COMPONENTES BASE ─────────────────────────────────────────────────────────
const Card = ({ children, style = {} }) => <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 22, ...style }}>{children}</div>;
const Badge = ({ label, color }) => <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: `${color}22`, color, border: `1px solid ${color}44` }}>{label}</span>;
const Btn = ({ children, onClick, variant = "primary", small = false, disabled = false, style = {} }) => (
  <button onClick={onClick} disabled={disabled} style={{ background: variant === "primary" ? `linear-gradient(135deg,${T.laranja},${T.laranjaM})` : variant === "secondary" ? T.cardL : "transparent", border: variant === "ghost" ? `1px solid ${T.border}` : "none", borderRadius: 8, color: "#fff", padding: small ? "6px 12px" : "9px 18px", fontSize: small ? 11 : 13, fontWeight: 700, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, ...style }}>{children}</button>
);
const Field = ({ label, value, onChange, type = "text", options, required, placeholder }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
    <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>{label}{required && " *"}</label>
    {options ? (
      <select value={value} onChange={e => onChange(e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: value ? T.text : T.muted, padding: "9px 12px", fontSize: 13, outline: "none" }}>
        <option value="">Selecionar...</option>
        {options.map(o => <option key={o.val || o} value={o.val || o}>{o.label || o}</option>)}
      </select>
    ) : (
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }} />
    )}
  </div>
);
const ModalWrap = ({ title, onClose, children, maxWidth = 560 }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
    <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, width: "100%", maxWidth, maxHeight: "90vh", overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: `1px solid ${T.border}`, position: "sticky", top: 0, background: T.card, zIndex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 800 }}>{title}</div>
        <button onClick={onClose} style={{ background: "none", border: "none", color: T.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
      </div>
      <div style={{ padding: 24 }}>{children}</div>
    </div>
  </div>
);

// ─── TELA DE LOGIN ────────────────────────────────────────────────────────────
function TelaLogin({ especialistas, clientes, consultores, onLogin }) {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSenha, setShowSenha] = useState(false);

  const handleLogin = () => {
    setErro(""); setLoading(true);
    setTimeout(() => {
      // Tenta login como especialista
      const esp = especialistas.find(e => e.email.toLowerCase() === email.toLowerCase() && e.senha === senha && e.status !== "Inativo");
      if (esp) {
        if (esp.status === "Inativo") { setErro("Usuário inativo. Contate o administrador."); setLoading(false); return; }
        onLogin({ ...esp, perfil: esp.perfil }); setLoading(false); return;
      }
      // Tenta login como consultor
      const con = (consultores || []).find(c => c.consultorEmail?.toLowerCase() === email.toLowerCase() && c.consultorSenha === senha && c.status === "Ativo");
      if (con) { onLogin({ ...con, perfil: "Consultor" }); setLoading(false); return; }
      // Tenta login como cliente
      const cli = clientes.find(c => c.clienteEmail?.toLowerCase() === email.toLowerCase() && c.clienteSenha === senha);
      if (cli) { onLogin({ id: cli.id, nome: cli.nome, email: cli.clienteEmail, perfil: "Cliente", clienteId: cli.id }); setLoading(false); return; }
      setErro("E-mail ou senha incorretos."); setLoading(false);
    }, 600);
  };

  return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Segoe UI',system-ui,sans-serif" }}>
      <style>{`*{box-sizing:border-box}input::placeholder{color:${T.muted}}`}</style>
      <div style={{ width: "100%", maxWidth: 420, padding: 24 }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ display: "inline-block", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, borderRadius: 16, padding: "16px 28px", marginBottom: 14 }}>
            <img src={LOGO_LUMEN} alt="Lumen Instituto" style={{ height: 64, display: "block" }} />
          </div>
          <div style={{ fontSize: 14, color: T.muted }}>Plataforma de Gestão de Projetos</div>
        </div>

        {/* Card de login */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 18, padding: 32 }}>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>Acesse sua conta</div>
          <div style={{ fontSize: 12, color: T.muted, marginBottom: 26 }}>Entre com seu e-mail e senha institucional</div>

          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Field label="E-mail" value={email} onChange={setEmail} type="email" placeholder="seu@lumeninstituto.com.br" required />
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Senha *</label>
              <div style={{ position: "relative" }}>
                <input type={showSenha ? "text" : "password"} value={senha} onChange={e => setSenha(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} placeholder="••••••••" style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 40px 9px 12px", fontSize: 13, outline: "none" }} />
                <button onClick={() => setShowSenha(s => !s)} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 16 }}>{showSenha ? "🙈" : "👁️"}</button>
              </div>
            </div>
          </div>

          {erro && <div style={{ marginTop: 14, padding: "10px 14px", background: `${T.danger}22`, border: `1px solid ${T.danger}44`, borderRadius: 8, fontSize: 12, color: T.danger }}>{erro}</div>}

          <button onClick={handleLogin} disabled={!email || !senha || loading} style={{ width: "100%", marginTop: 22, padding: "12px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 10, color: "#fff", fontSize: 14, fontWeight: 800, cursor: !email || !senha ? "not-allowed" : "pointer", opacity: !email || !senha ? 0.6 : 1 }}>
            {loading ? "Entrando..." : "Entrar →"}
          </button>

          <div style={{ marginTop: 18, padding: "12px 14px", background: T.cardL, borderRadius: 10, fontSize: 11, color: T.muted }}>
            <div style={{ fontWeight: 600, marginBottom: 4, color: T.text }}>💡 Credenciais de demonstração:</div>
            <div>Admin: leandro@lumeninstituto.com.br · lumen2026</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── APP PRINCIPAL ────────────────────────────────────────────────────────────
export default function LumenSistema({ dadosIniciais, api }) {
  const [usuarioLogado, setUsuarioLogado] = useState(null);
  const [menu, setMenu] = useState("dashboard");
  const [clientes, setClientes] = useState(dadosIniciais?.clientes || []);
  const [visitas, setVisitas] = useState(dadosIniciais?.visitas || []);
  const [marcos, setMarcos] = useState(dadosIniciais?.marcos || []);
  const [dmgData, setDmgData] = useState(dadosIniciais?.dmgData || {});
  const [especialistas, setEspecialistas] = useState(dadosIniciais?.especialistas || []);
  const [tarefas, setTarefas] = useState(dadosIniciais?.tarefas || []);
  const [tiposProjeto, setTiposProjeto] = useState(dadosIniciais?.tiposProjeto || []);
  const [prospects, setProspects] = useState(dadosIniciais?.prospects || []);
  const [consultores, setConsultores] = useState(dadosIniciais?.consultores || []);
  const [dpsData, setDpsData] = useState(dadosIniciais?.dpsData || []);
  const [modal, setModal] = useState(null);
  const [relDtIni, setRelDtIni] = useState("");
  const [relDtFim, setRelDtFim] = useState("");
  const [relConsultorSel, setRelConsultorSel] = useState("todos");
  // Filtros do dashboard
  const [dashFiltroEmpresa, setDashFiltroEmpresa] = useState("");
  const [dashFiltroPeriodo, setDashFiltroPeriodo] = useState("");
  const [dashFiltroDataCustom, setDashFiltroDataCustom] = useState({ de: "", ate: "" });
  const [dashFiltroStatus, setDashFiltroStatus] = useState("");
  const [dashFiltroEmpresaM, setDashFiltroEmpresaM] = useState("");
  const [dashFiltroPeriodoM, setDashFiltroPeriodoM] = useState("");
  const [dashFiltroDataCustomM, setDashFiltroDataCustomM] = useState({ de: "", ate: "" });
  const [dashFiltroStatusM, setDashFiltroStatusM] = useState("");
  // Filtros da tela de Atendimentos
  const [vFiltroPeriodo, setVFiltroPeriodo] = useState("");
  const [vFiltroDataCustom, setVFiltroDataCustom] = useState({ de: "", ate: "" });
  const [vFiltroCliente, setVFiltroCliente] = useState("");
  const [vFiltroEsp, setVFiltroEsp] = useState("");
  const [vFiltroTipo, setVFiltroTipo] = useState("");
  const [vFiltroStatus, setVFiltroStatus] = useState("");

  const calcPeriodo = (periodo, custom) => {
    const hoje = new Date();
    if (periodo === "7") { const d = new Date(hoje); d.setDate(d.getDate() - 7); return { de: d.toISOString().split("T")[0], ate: hoje.toISOString().split("T")[0] }; }
    if (periodo === "15") { const d = new Date(hoje); d.setDate(d.getDate() - 15); return { de: d.toISOString().split("T")[0], ate: hoje.toISOString().split("T")[0] }; }
    if (periodo === "30") { const d = new Date(hoje); d.setDate(d.getDate() - 30); return { de: d.toISOString().split("T")[0], ate: hoje.toISOString().split("T")[0] }; }
    if (periodo === "custom") return custom;
    return { de: "", ate: "" };
  };
  const [toast, setToast] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  // Sessão via localStorage (não precisa de banco para isso)
  useEffect(() => {
    const sess = localStorage.getItem("lumen:sessao");
    if (sess) {
      try { setUsuarioLogado(JSON.parse(sess)); } catch {}
    }
  }, []);

  const handleLogin = (user) => {
    setUsuarioLogado(user);
    localStorage.setItem("lumen:sessao", JSON.stringify(user));
    setMenu("dashboard");
  };

  const handleLogout = () => {
    setUsuarioLogado(null);
    localStorage.removeItem("lumen:sessao");
  };

  const showToast = (msg, type = "success") => { setToast({ msg, type }); setTimeout(() => setToast(null), 3000); };

  // CRUD — agora usa Supabase via api prop
  const saveCliente = async (data) => {
    try {
      const saved = await api.clientes.upsert(data);
      const isNew = !data.id;
      setClientes(prev => isNew ? [...prev, saved] : prev.map(c => c.id === saved.id ? saved : c));
      showToast(isNew ? "Cliente cadastrado!" : "Cliente atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteCliente = async (id) => {
    try {
      await api.clientes.delete(id);
      setClientes(prev => prev.filter(c => c.id !== id));
      showToast("Cliente removido.", "warning"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const saveVisita = async (data) => {
    try {
      const saved = await api.visitas.upsert(data);
      const isNew = !data.id;
      setVisitas(prev => isNew ? [...prev, saved] : prev.map(v => v.id === saved.id ? saved : v));
      showToast(isNew ? "Atendimento lançado!" : "Atendimento atualizado!");
      return saved.id;
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteVisita = async (id) => {
    try {
      await api.visitas.delete(id);
      setVisitas(prev => prev.filter(v => v.id !== id));
      showToast("Atendimento removido.", "warning"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteDmg = async (clienteId) => {
    try {
      await api.dmg.delete(clienteId);
      setDmgData(prev => { const n = { ...prev }; delete n[clienteId]; return n; });
      showToast("Diagnóstico removido.", "warning");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const saveMarco = async (data) => {
    try {
      const saved = await api.marcos.upsert(data);
      const isNew = !data.id;
      setMarcos(prev => isNew ? [...prev, saved] : prev.map(m => m.id === saved.id ? saved : m));
      showToast(isNew ? "Marco criado!" : "Marco atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const saveProspect = async (data) => {
    try {
      const saved = await api.prospects.upsert(data);
      const isNew = !data.id || data.id.startsWith('p_');
      setProspects(prev => isNew ? [...prev, saved] : prev.map(p => p.id === saved.id ? saved : p));
      showToast(isNew ? "Prospect cadastrado!" : "Prospect atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const deleteProspect = async (id) => {
    try {
      await api.prospects.delete(id);
      setProspects(prev => prev.filter(p => p.id !== id));
      showToast("Prospect removido.", "warning"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const toggleCheckProspect = async (prospectId, fase, idx) => {
    const prospect = prospects.find(p => p.id === prospectId);
    if (!prospect) return;
    const checklist = { ...(prospect.checklist || {}) };
    const key = `${fase}_${idx}`;
    checklist[key] = !checklist[key];
    const updated = { ...prospect, checklist };
    try {
      await api.prospects.upsert(updated);
      setProspects(prev => prev.map(p => p.id === prospectId ? updated : p));
    } catch (e) { showToast("Erro ao salvar: " + e.message, "error"); }
  };

  const exportarProspectParaProjeto = (prospect) => {
    const novoCliente = {
      nome: prospect.nome,
      segmento: prospect.segmento || "",
      telefone: prospect.telefone || "",
      cidade: prospect.cidade || "",
      email: prospect.emailResponsavel || "",
      status: "Novo",
      especialistaId: null,
      mentorId: null,
      tipoProjetoId: null,
      marcosDoProjetoIds: [],
      clienteEmail: "",
      clienteSenha: "",
    };
    setModal({ type: "cliente", data: novoCliente });
    showToast("Dados do prospect carregados! Complete o cadastro do projeto.");
  };

  const saveConsultor = async (data) => {
    try {
      const saved = await api.consultores.upsert(data);
      const isNew = !data.id;
      setConsultores(prev => isNew ? [...prev, saved] : prev.map(c => c.id === saved.id ? saved : c));
      showToast(isNew ? "Consultor cadastrado!" : "Consultor atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteConsultor = async (id) => {
    try {
      await api.consultores.delete(id);
      setConsultores(prev => prev.filter(c => c.id !== id));
      showToast("Consultor removido.", "warning"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const saveTipoProjeto = async (data) => {
    try {
      const saved = await api.tiposProjeto.upsert(data);
      const isNew = !data.id;
      setTiposProjeto(prev => isNew ? [...prev, saved] : prev.map(t => t.id === saved.id ? saved : t));
      showToast(isNew ? "Tipo criado!" : "Tipo atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteTipoProjeto = async (id) => {
    try {
      await api.tiposProjeto.delete(id);
      setTiposProjeto(prev => prev.filter(t => t.id !== id));
      showToast("Tipo removido!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const saveTarefa = async (data, closeModal = true) => {
    try {
      const saved = await api.tarefas.upsert(data);
      const isNew = !data.id;
      setTarefas(prev => isNew ? [...prev, saved] : prev.map(t => t.id === saved.id ? saved : t));
      if (closeModal) { showToast(isNew ? "Tarefa criada!" : "Tarefa atualizada!"); setModal(null); }
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const updateTarefaStatus = async (id, status) => {
    try {
      await api.tarefas.updateStatus(id, status);
      const concluidaEm = status === "Concluída" ? new Date().toISOString().split("T")[0] : null;
      setTarefas(prev => prev.map(t => t.id === id ? { ...t, status, concluidaEm } : t));
      showToast("Tarefa atualizada!");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const deleteTarefa = async (id) => {
    try {
      await api.tarefas.delete(id);
      setTarefas(prev => prev.filter(t => t.id !== id));
      showToast("Tarefa removida.", "warning");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const saveDps = async (data) => {
    try {
      const saved = await api.dps.upsert(data);
      const isNew = !data.id;
      setDpsData(prev => isNew ? [...prev, saved] : prev.map(d => d.id === saved.id ? saved : d));
      showToast(isNew ? "DPS aplicado com sucesso!" : "DPS atualizado!");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const deleteDps = async (id) => {
    try {
      await api.dps.delete(id);
      setDpsData(prev => prev.filter(d => d.id !== id));
      showToast("Aplicação removida.", "warning");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };

  const saveDmg = async (clienteId, scores, analiseIA) => {
    try {
      await api.dmg.upsert(clienteId, scores, analiseIA);
      setDmgData(prev => ({ ...prev, [clienteId]: { ...scores, analiseIA } }));
      showToast("DMG salvo com sucesso!");
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  const saveEspecialista = async (data) => {
    try {
      const saved = await api.especialistas.upsert(data);
      const isNew = !data.id;
      setEspecialistas(prev => isNew ? [...prev, saved] : prev.map(e => e.id === saved.id ? saved : e));
      if (usuarioLogado && data.id === usuarioLogado.id) {
        setUsuarioLogado(saved);
        localStorage.setItem("lumen:sessao", JSON.stringify(saved));
      }
      showToast(isNew ? "Especialista cadastrado!" : "Especialista atualizado!"); setModal(null);
    } catch (e) { showToast("Erro: " + e.message, "error"); }
  };
  // FILTROS POR PERFIL
  // ── PORTAL DO CLIENTE ──
  if (usuarioLogado?.perfil === "Cliente") {
    const meuCliente = clientes.find(c => c.id === usuarioLogado.clienteId);
    const confirmarVisita = async (visitaId, confirmar) => {
      try {
        const visita = visitas.find(v => v.id === visitaId);
        if (!visita) return;
        const novoStatus = confirmar ? "Confirmada" : "Agendada";
        await api.visitas.upsert({ ...visita, confirmadoCliente: confirmar, status: novoStatus });
        setVisitas(prev => prev.map(v => v.id === visitaId ? { ...v, confirmadoCliente: confirmar, status: novoStatus } : v));
        showToast(confirmar ? "Presença confirmada! ✅" : "Confirmação cancelada.");
      } catch (e) { showToast("Erro ao atualizar", "error"); }
    };
    // eslint-disable-next-line no-use-before-define
    const gerarPDFDmgRef = gerarPDFDmg; // eslint-disable-line
    return <PortalCliente
      cliente={meuCliente}
      visitas={visitas.filter(v => v.clienteId === usuarioLogado.clienteId)}
      marcos={marcos.filter(m => m.clienteId === usuarioLogado.clienteId)}
      tarefas={tarefas.filter(t => t.clienteId === usuarioLogado.clienteId)}
      dmg={dmgData[usuarioLogado.clienteId]}
      especialistas={especialistas}
      api={api}
      usuarioLogado={usuarioLogado}
      onLogout={handleLogout}
      onUpdateTarefaStatus={updateTarefaStatus}
      onConfirmarVisita={confirmarVisita}
      gerarPDFDmg={gerarPDFDmgRef}
      showToast={showToast}
    />;
  }

  const _perfil = (usuarioLogado?.perfil || "").toLowerCase().trim();
  const isAdmin = _perfil === "admin";
  const isGestor = isAdmin || _perfil === "gestor";
  const isGestorPuro = _perfil === "gestor"; // Gestor sem ser Admin — para bloqueio financeiro
  const isConsultor = _perfil === "consultor";

  if (isConsultor) {
    const meuConsultor = consultores.find(c => c.id === usuarioLogado.id);
    const meusClientes = clientes.filter(c =>
      c.especialistaId === usuarioLogado.id ||
      visitas.some(v => v.consultorId === usuarioLogado.id && v.clienteId === c.id)
    );
    const minhasVisitas = visitas.filter(v =>
      v.especialistaId === usuarioLogado.id || v.consultorId === usuarioLogado.id
    );
    const todasVisitasClientes = visitas.filter(v => meusClientes.some(c => c.id === v.clienteId));
    return <PortalConsultor
      consultor={meuConsultor}
      visitas={minhasVisitas}
      todasVisitasClientes={todasVisitasClientes}
      clientes={meusClientes}
      tarefas={tarefas.filter(t => meusClientes.some(c => c.id === t.clienteId))}
      especialistas={especialistas}
      consultores={consultores}
      usuarioLogado={usuarioLogado}
      onLogout={handleLogout}
      showToast={showToast}
      onSaveVisita={saveVisita}
      onSaveTarefa={saveTarefa}
      onDeleteVisita={deleteVisita}
      setVisitas={setVisitas}
    />;
  }

  const clientesFiltrados = isGestor ? clientes : clientes.filter(c => c.especialistaId === usuarioLogado?.id);
  const visitasFiltradas = isGestor ? visitas : visitas.filter(v => v.especialistaId === usuarioLogado?.id);
  
  // Marcos "flat" — expande marcosDoProjetoIds de cada cliente em uma lista única
  const marcosFlat = clientes.flatMap(c => (c.marcosDoProjetoIds || []).map(m => ({
    ...m,
    clienteId: c.id,
    clienteNomeVal: c.nome,
    status: m.status || "A Iniciar",
  })));
  const marcosFiltrados = isGestor ? marcosFlat : marcosFlat.filter(m => clientesFiltrados.some(c => c.id === m.clienteId));
  
  const MENUS = isGestor ? MENUS_ADMIN : MENUS_ESPECIALISTA;
  const tarefasFiltradas = isGestor ? tarefas : tarefas.filter(t => clientesFiltrados.some(c => c.id === t.clienteId));
  const tarefasAbertas = tarefasFiltradas.filter(t => t.status !== "Concluída").length;
  const marcosAbertos = marcosFiltrados.filter(m => m.status !== "Concluído").length;

  const especialistaNome = (id) => especialistas.find(e => e.id === id)?.nome || "—";
  const clienteNome = (id) => clientes.find(c => c.id === id)?.nome || "—";
  const horasRealizadas = visitasFiltradas.filter(v => v.status === "Realizada").reduce((s, v) => s + (Number(v.duracao) || 0), 0);
  const _mesAtual = new Date().toISOString().slice(0, 7); // "YYYY-MM"
  const horasMesAtual = visitasFiltradas.filter(v => v.status === "Realizada" && v.data?.startsWith(_mesAtual)).reduce((s, v) => s + (Number(v.duracao) || 0), 0);
  const receitaTotal = clientesFiltrados.filter(c => c.status !== "Encerrado").reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const matMedia = Math.round(clientesFiltrados.reduce((s, c) => s + calcMat(dmgData[c.id]), 0) / Math.max(clientesFiltrados.length, 1));

  if (!usuarioLogado) return <TelaLogin especialistas={especialistas} clientes={clientes} consultores={consultores} onLogin={handleLogin} />;

  return (
    <div style={{ fontFamily: "'Segoe UI',system-ui,sans-serif", background: T.bg, minHeight: "100vh", color: T.text, display: "flex" }}>
      <style>{`*{box-sizing:border-box;color-scheme:dark}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:${T.bg}}::-webkit-scrollbar-thumb{background:${T.border};border-radius:4px}input,textarea,select{color-scheme:dark;background-color:${T.cardL};color:${T.text}}input::placeholder,textarea::placeholder{color:${T.muted}}select{-webkit-appearance:none;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236A90B8' d='M6 8L0 0h12z'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 10px center;padding-right:28px!important}select option{background:${T.card};color:${T.text}}@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}.fade{animation:fadeUp .25s ease}@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      {/* SIDEBAR */}
      <div style={{ width: 230, background: T.marinho, borderRight: `1px solid ${T.border}`, display: "flex", flexDirection: "column", flexShrink: 0, position: "sticky", top: 0, height: "100vh" }}>
        <div style={{ padding: "20px 18px 16px", borderBottom: `1px solid ${T.border}` }}>
          <div style={{ background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, borderRadius: 12, padding: "11px 16px", marginBottom: 8 }}>
            <img src={LOGO_LUMEN} alt="Lumen Instituto" style={{ height: 44, display: "block" }} />
          </div>
          <div style={{ fontSize: 10, color: T.muted }}>Gestão de Projetos · v1.0</div>
        </div>

        <nav style={{ padding: "10px 0", flex: 1 }}>
          {MENUS.map(m => (
            <button key={m.id} onClick={() => setMenu(m.id)} style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "11px 18px", background: menu === m.id ? `${T.laranja}18` : "transparent", border: "none", borderLeft: `3px solid ${menu === m.id ? T.laranja : "transparent"}`, color: menu === m.id ? T.laranja : T.muted, cursor: "pointer", fontSize: 13, fontWeight: menu === m.id ? 700 : 400, textAlign: "left" }}>
              <span>{m.icon}</span>{m.label}
              {m.id === "marcos" && marcosAbertos > 0 && <span style={{ marginLeft: "auto", background: T.danger, color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 10, fontWeight: 700 }}>{marcosAbertos}</span>}
              {m.id === "planoacao" && tarefasAbertas > 0 && <span style={{ marginLeft: "auto", background: T.warning, color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 10, fontWeight: 700 }}>{tarefasAbertas}</span>}
              {m.id === "calendario" && (() => { const hoje = new Date().toISOString().split("T")[0]; const prox = (isAdmin ? visitas : visitasFiltradas).filter(v => v.data >= hoje && v.status === "Agendada").length; return prox > 0 ? <span style={{ marginLeft: "auto", background: T.azul, color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 10, fontWeight: 700 }}>{prox}</span> : null; })()}
            </button>
          ))}
        </nav>

        {/* Usuário logado */}
        <div style={{ padding: "14px 16px", borderTop: `1px solid ${T.border}` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 13, flexShrink: 0 }}>{iniciais(usuarioLogado.nome)}</div>
            <div style={{ overflow: "hidden" }}>
              <div style={{ fontSize: 12, fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{usuarioLogado.nome.split(" ")[0]} {usuarioLogado.nome.split(" ").slice(-1)}</div>
              <div style={{ fontSize: 10, color: T.muted }}>{usuarioLogado.perfil} · {usuarioLogado.especialidade?.split(" ")[0]}</div>
            </div>
          </div>
          <button onClick={handleLogout} style={{ width: "100%", padding: "7px", background: "transparent", border: `1px solid ${T.border}`, borderRadius: 8, color: T.muted, fontSize: 11, cursor: "pointer", fontWeight: 600 }}>Sair →</button>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ flex: 1, overflow: "auto", maxHeight: "100vh" }}>
        {/* Header */}
        <div style={{ padding: "14px 26px", borderBottom: `1px solid ${T.border}`, background: T.marinho, display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 800 }}>{MENUS.find(m => m.id === menu)?.label}</div>
            <div style={{ fontSize: 11, color: T.muted }}>
              {isAdmin ? "Visão completa" : `Seus projetos · ${clientesFiltrados.length} clientes`} · Abril 2026
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {menu === "projetos" && isGestor && <Btn onClick={() => setModal({ type: "cliente" })}>+ Novo Cliente</Btn>}
            {menu === "visitas" && <Btn onClick={() => setModal({ type: "visita", data: { especialistaId: usuarioLogado.id } })}>+ Lançar Atendimento</Btn>}
            {menu === "marcos" && <Btn onClick={() => setModal({ type: "marco" })}>+ Novo Marco</Btn>}
            {menu === "tiposProjeto" && isGestor && <Btn onClick={() => setModal({ type: "tipoProjeto" })}>+ Novo Tipo</Btn>}
            {menu === "prospects" && isGestor && <Btn onClick={() => setModal({ type: "prospect" })}>+ Novo Prospect</Btn>}
            {menu === "planoacao" && isGestor && <Btn onClick={() => setModal({ type: "tarefa" })}>+ Nova Tarefa</Btn>}
            {menu === "planoacao" && !isAdmin && <Btn onClick={() => setModal({ type: "tarefa" })}>+ Nova Tarefa</Btn>}
            {menu === "especialistas" && isGestor && <Btn onClick={() => setModal({ type: "especialista" })}>+ Novo Especialista</Btn>}
            {menu === "consultores" && isGestor && <Btn onClick={() => setModal({ type: "consultor" })}>+ Novo Consultor</Btn>}
          </div>
        </div>

        <div style={{ padding: "22px 26px" }}>

          {/* ═══ PLANO DE AÇÃO ═══ */}
          {menu === "planoacao" && (
            <PlanoAcaoModule
              tarefas={tarefasFiltradas}
              clientes={clientesFiltrados}
              visitas={visitasFiltradas}
              especialistas={especialistas}
              isAdmin={isGestor}
              onSave={saveTarefa}
              onUpdateStatus={updateTarefaStatus}
              onDelete={deleteTarefa}
              onEdit={(t) => setModal({ type: "tarefa", data: t })}
            />
          )}

          {/* ═══ CALENDÁRIO ═══ */}
          {menu === "calendario" && (
            <CalendarioModule
              visitas={isGestor ? visitas : visitasFiltradas}
              tarefas={tarefasFiltradas}
              clientes={clientes}
              especialistas={especialistas}
              isAdmin={isGestor}
              usuarioLogado={usuarioLogado}
              onNovaVisita={(data) => setModal({ type: "visita", data: { especialistaId: usuarioLogado.id, data } })}
              onEditVisita={(v) => {
                // Enriquece tarefasGeradas com IDs do banco
                const tarefasDaVisita = tarefas.filter(t => t.visitaId === v.id);
                const tarefasComId = (v.tarefasGeradas || []).map((tg, idx) => {
                  const match = tarefasDaVisita.find(t => t.titulo === tg.titulo) || tarefasDaVisita[idx];
                  return match ? { ...tg, id: match.id } : tg;
                });
                setModal({ type: "visita", data: { ...v, tarefasGeradas: tarefasComId } });
              }}
            />
          )}

          {/* ═══ DASHBOARD ═══ */}
          {menu === "dashboard" && (
            <div className="fade">
              {!isAdmin && (
                <div style={{ marginBottom: 18, padding: "14px 18px", background: `${T.azul}18`, border: `1px solid ${T.azul}44`, borderRadius: 12, fontSize: 13 }}>
                  👋 Olá, <b>{usuarioLogado.nome.split(" ")[0]}!</b> Você está vendo apenas seus projetos e visitas.
                </div>
              )}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 20 }}>
                {[
                  { label: isAdmin ? "Projetos Ativos" : "Meus Projetos", val: clientesFiltrados.filter(c => c.status === "Ativo").length, sub: `${clientesFiltrados.length} na carteira`, icon: "📊", cor: T.laranja },
                  { label: isAdmin ? "Receita Mensal" : "Valor dos Projetos", val: fmtMoeda(receitaTotal), sub: "Contratos ativos", icon: "💰", cor: T.success },
                  { label: "Maturidade Média", val: `${matMedia}%`, sub: "DMG da carteira", icon: "📈", cor: T.laranjaM },
                ].map((k, i) => (
                  <Card key={i} style={{ position: "relative", overflow: "hidden" }}>
                    <div style={{ position: "absolute", top: -20, right: -20, width: 80, height: 80, borderRadius: "50%", background: `${k.cor}12` }} />
                    <div style={{ fontSize: 22, marginBottom: 8 }}>{k.icon}</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.1 }}>{k.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>{k.label}</div>
                    <div style={{ fontSize: 10, color: k.cor, marginTop: 4, fontWeight: 600 }}>{k.sub}</div>
                  </Card>
                ))}
                {/* Card Horas Entregues — layout customizado */}
                {(() => {
                  const visitasMes = visitasFiltradas.filter(v => v.status === "Realizada" && v.data?.startsWith(_mesAtual));
                  const visitasTotal = visitasFiltradas.filter(v => v.status === "Realizada");
                  return (
                    <Card style={{ position: "relative", overflow: "hidden", order: -2 }}>
                      <div style={{ position: "absolute", top: -20, right: -20, width: 80, height: 80, borderRadius: "50%", background: `${T.azul}12` }} />
                      <div style={{ fontSize: 22, marginBottom: 8 }}>⏱️</div>
                      <div style={{ fontSize: 22, fontWeight: 900, color: "#fff", lineHeight: 1.1 }}>{horasMesAtual}h · {visitasMes.length}v</div>
                      <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>Horas Entregues — mês atual</div>
                      <div style={{ fontSize: 10, color: T.azul, marginTop: 4, fontWeight: 600 }}>{horasRealizadas}h · {visitasTotal.length}v total geral</div>
                    </Card>
                  );
                })()}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                {/* ÚLTIMOS ATENDIMENTOS COM FILTROS */}
                <Card>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Últimos Atendimentos</div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
                    <select value={dashFiltroEmpresa} onChange={e => setDashFiltroEmpresa(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroEmpresa ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroEmpresa ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Empresa</option>
                      {clientesFiltrados.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                    </select>
                    <select value={dashFiltroPeriodo} onChange={e => setDashFiltroPeriodo(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroPeriodo ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroPeriodo ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Período</option>
                      <option value="7">Últimos 7 dias</option>
                      <option value="15">Últimos 15 dias</option>
                      <option value="30">Últimos 30 dias</option>
                      <option value="custom">Personalizado</option>
                    </select>
                    <select value={dashFiltroStatus} onChange={e => setDashFiltroStatus(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroStatus ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroStatus ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Status</option>
                      {["Agendada","Confirmada","Realizada","Cancelada"].map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  {dashFiltroPeriodo === "custom" && (
                    <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                      <input type="date" value={dashFiltroDataCustom.de} onChange={e => setDashFiltroDataCustom(p => ({ ...p, de: e.target.value }))} style={{ flex: 1, background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 6, color: T.text, padding: "5px 8px", fontSize: 11, outline: "none" }} />
                      <span style={{ color: T.muted, fontSize: 11, alignSelf: "center" }}>até</span>
                      <input type="date" value={dashFiltroDataCustom.ate} onChange={e => setDashFiltroDataCustom(p => ({ ...p, ate: e.target.value }))} style={{ flex: 1, background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 6, color: T.text, padding: "5px 8px", fontSize: 11, outline: "none" }} />
                    </div>
                  )}
                  {(dashFiltroEmpresa || dashFiltroPeriodo || dashFiltroStatus) && (
                    <button onClick={() => { setDashFiltroEmpresa(""); setDashFiltroPeriodo(""); setDashFiltroDataCustom({ de: "", ate: "" }); setDashFiltroStatus(""); }} style={{ fontSize: 10, color: T.muted, background: "none", border: "none", cursor: "pointer", marginBottom: 8, textDecoration: "underline" }}>✕ Limpar filtros</button>
                  )}
                  {(() => {
                    const periodo = calcPeriodo(dashFiltroPeriodo, dashFiltroDataCustom);
                    const lista = [...visitasFiltradas]
                      .filter(v => !dashFiltroEmpresa || v.clienteId === dashFiltroEmpresa)
                      .filter(v => !periodo.de || v.data >= periodo.de)
                      .filter(v => !periodo.ate || v.data <= periodo.ate)
                      .filter(v => !dashFiltroStatus || v.status === dashFiltroStatus)
                      .sort((a, b) => b.data?.localeCompare(a.data))
                      .slice(0, 8);
                    if (lista.length === 0) return <div style={{ color: T.muted, fontSize: 13 }}>Nenhuma visita encontrada.</div>;
                    return lista.map((v, i, arr) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 0", borderBottom: i < arr.length - 1 ? `1px solid ${T.border}` : "none" }}>
                        <div style={{ width: 34, height: 34, borderRadius: 8, background: `${T.laranja}22`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: T.laranja, flexShrink: 0 }}>{clienteNome(v.clienteId).substring(0, 2).toUpperCase()}</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 600 }}>{clienteNome(v.clienteId)}</div>
                          <div style={{ fontSize: 10, color: T.muted }}>{v.tipo} · {especialistaNome(v.especialistaId).split(" ")[0]}</div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: 10, color: T.muted }}>{fmtDate(v.data)}</div>
                          <Badge label={v.status} color={statusColor(v.status)} />
                        </div>
                      </div>
                    ));
                  })()}
                </Card>

                {/* MARCOS EM ABERTO COM FILTROS */}
                <Card>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Marcos em Aberto</div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 8, flexWrap: "wrap" }}>
                    <select value={dashFiltroEmpresaM} onChange={e => setDashFiltroEmpresaM(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroEmpresaM ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroEmpresaM ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Empresa</option>
                      {clientesFiltrados.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                    </select>
                    <select value={dashFiltroPeriodoM} onChange={e => setDashFiltroPeriodoM(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroPeriodoM ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroPeriodoM ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Prazo até</option>
                      <option value="7">Próximos 7 dias</option>
                      <option value="15">Próximos 15 dias</option>
                      <option value="30">Próximos 30 dias</option>
                      <option value="custom">Personalizado</option>
                    </select>
                    <select value={dashFiltroStatusM} onChange={e => setDashFiltroStatusM(e.target.value)} style={{ flex: 1, background: T.cardL, border: `1px solid ${dashFiltroStatusM ? T.laranja : T.border}`, borderRadius: 6, color: dashFiltroStatusM ? T.laranja : T.muted, padding: "5px 8px", fontSize: 11, outline: "none" }}>
                      <option value="">Status</option>
                      {["A Iniciar","Iniciado","Atrasado"].map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>
                  {dashFiltroPeriodoM === "custom" && (
                    <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                      <input type="date" value={dashFiltroDataCustomM.de} onChange={e => setDashFiltroDataCustomM(p => ({ ...p, de: e.target.value }))} style={{ flex: 1, background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 6, color: T.text, padding: "5px 8px", fontSize: 11, outline: "none" }} />
                      <span style={{ color: T.muted, fontSize: 11, alignSelf: "center" }}>até</span>
                      <input type="date" value={dashFiltroDataCustomM.ate} onChange={e => setDashFiltroDataCustomM(p => ({ ...p, ate: e.target.value }))} style={{ flex: 1, background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 6, color: T.text, padding: "5px 8px", fontSize: 11, outline: "none" }} />
                    </div>
                  )}
                  {(dashFiltroEmpresaM || dashFiltroPeriodoM || dashFiltroStatusM) && (
                    <button onClick={() => { setDashFiltroEmpresaM(""); setDashFiltroPeriodoM(""); setDashFiltroDataCustomM({ de: "", ate: "" }); setDashFiltroStatusM(""); }} style={{ fontSize: 10, color: T.muted, background: "none", border: "none", cursor: "pointer", marginBottom: 8, textDecoration: "underline" }}>✕ Limpar filtros</button>
                  )}
                  {(() => {
                    const fimPeriodo = dashFiltroPeriodoM && dashFiltroPeriodoM !== "custom" ? (() => { const d = new Date(); d.setDate(d.getDate() + Number(dashFiltroPeriodoM)); return d.toISOString().split("T")[0]; })() : dashFiltroDataCustomM.ate;
                    const lista = marcosFiltrados
                      .filter(m => m.status !== "Concluído")
                      .filter(m => !dashFiltroEmpresaM || m.clienteId === dashFiltroEmpresaM)
                      .filter(m => !fimPeriodo || (m.prazo && m.prazo <= fimPeriodo))
                      .filter(m => !dashFiltroDataCustomM.de || (m.prazo && m.prazo >= dashFiltroDataCustomM.de))
                      .filter(m => !dashFiltroStatusM || m.status === dashFiltroStatusM)
                      .slice(0, 8);
                    if (lista.length === 0) return <div style={{ color: T.muted, fontSize: 13 }}>Nenhum marco encontrado.</div>;
                    return lista.map((m, i, arr) => {
                      const corM = m.status === "Atrasado" ? T.danger : m.status === "Iniciado" ? T.laranjaM : T.azul;
                      return (
                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 0", borderBottom: i < arr.length - 1 ? `1px solid ${T.border}` : "none" }}>
                          <div style={{ width: 6, height: 6, borderRadius: "50%", background: corM, flexShrink: 0 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 12, fontWeight: 600 }}>{m.titulo}</div>
                            <div style={{ fontSize: 10, color: T.muted }}>{m.clienteNomeVal}</div>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontSize: 10, color: T.muted }}>{fmtDate(m.prazo)}</div>
                            <Badge label={m.status} color={corM} />
                          </div>
                        </div>
                      );
                    });
                  })()}
                </Card>
              </div>
            </div>
          )}

          {/* ═══ PROJETOS (admin only) ═══ */}
          {menu === "projetos" && (
            <div className="fade">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
                {[
                  { label: "Total", val: clientes.length, cor: T.azul },
                  { label: "Ativos", val: clientes.filter(c => c.status === "Ativo").length, cor: T.success },
                  { label: "Em andamento", val: clientes.filter(c => c.status === "Em andamento").length, cor: T.laranjaM },
                  { label: "Receita total", val: fmtMoeda(receitaTotal), cor: T.laranja },
                ].map((s, i) => (
                  <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                    <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                  </Card>
                ))}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 14 }}>
                {clientes.map(c => {
                  const mat = calcMat(dmgData[c.id]);
                  const vCount = visitas.filter(v => v.clienteId === c.id).length;
                  const mCount = (c.marcosDoProjetoIds || []).length;
                  const mConcluidos = (c.marcosDoProjetoIds || []).filter(m => m.status === "Concluído").length;
                  const esp = especialistas.find(e => e.id === c.especialistaId);
                  const isSelected = selectedId === c.id;
                  return (
                    <div key={c.id} onClick={() => setSelectedId(isSelected ? null : c.id)} style={{ background: T.card, border: `1px solid ${isSelected ? T.laranja : T.border}`, borderRadius: 14, padding: "18px 20px", cursor: "pointer", borderLeft: `4px solid ${statusColor(c.status)}` }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                        <div>
                          <div style={{ fontSize: 15, fontWeight: 800, color: "#dce4f5" }}>{c.nome}</div>
                          <div style={{ fontSize: 11, color: T.muted, display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
                            {c.segmento}
                            {esp && <span style={{ display: "flex", alignItems: "center", gap: 4 }}>· <span style={{ width: 16, height: 16, borderRadius: "50%", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 8, fontWeight: 800, color: "#fff" }}>{iniciais(esp.nome)}</span> {esp.nome.split(" ")[0]}</span>}
                            {c.mentorId && (() => { const mentor = especialistas.find(e => e.id === c.mentorId); return mentor ? <span style={{ color: "#8b5cf6", fontSize: 10 }}>· 🎯 {mentor.nome.split(" ")[0]}</span> : null; })()}
                          </div>
                        </div>
                        <Badge label={c.status} color={statusColor(c.status)} />
                      </div>
                      {mat > 0 && (
                        <div style={{ marginBottom: 10 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                            <span style={{ fontSize: 10, color: T.muted }}>Maturidade DMG</span>
                            <span style={{ fontSize: 10, fontWeight: 700, color: mat > 70 ? T.success : mat > 50 ? T.laranjaM : T.danger }}>{mat}%</span>
                          </div>
                          <div style={{ height: 4, background: T.border, borderRadius: 4 }}><div style={{ height: "100%", width: `${mat}%`, background: mat > 70 ? T.success : mat > 50 ? T.laranjaM : T.danger, borderRadius: 4 }} /></div>
                        </div>
                      )}
                      <div style={{ display: "flex", gap: 14 }}>
                        <span style={{ fontSize: 11, color: T.muted }}>📅 <b style={{ color: T.text }}>{vCount}</b> visitas</span>
                        <span style={{ fontSize: 11, color: T.muted }}>🎯 <b style={{ color: T.laranjaM }}>{mConcluidos}/{mCount}</b> marcos</span>
                        <span style={{ fontSize: 11, color: T.muted }}>💰 <b style={{ color: T.text }}>{fmtMoeda(c.valor)}/mês</b></span>
                      </div>
                      {isSelected && (
                        <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${T.border}` }}>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginBottom: 12 }}>
                            {[{ label: "Contrato desde", val: fmtDate(c.contrato) }, { label: "Horas contratadas", val: `${c.horasContratadas}h` }, { label: "Cidade", val: c.cidade }].map((item, i) => (
                              <div key={i} style={{ background: T.cardL, borderRadius: 8, padding: "8px 10px", textAlign: "center" }}>
                                <div style={{ fontSize: 12, fontWeight: 800, color: T.laranja }}>{item.val}</div>
                                <div style={{ fontSize: 9, color: T.muted, marginTop: 2 }}>{item.label}</div>
                              </div>
                            ))}
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <Btn small onClick={e => { e.stopPropagation(); setModal({ type: "cliente", data: c }); }}>✏️ Editar</Btn>
                            <Btn small variant="ghost" onClick={e => { e.stopPropagation(); setModal({ type: "visita", data: { clienteId: c.id, especialistaId: usuarioLogado.id } }); }}>+ Atendimento</Btn>
                            <Btn small variant="ghost" onClick={e => { e.stopPropagation(); setModal({ type: "marcosProj", data: c }); }}>📋 Atualizar Marcos</Btn>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ═══ ATENDIMENTOS ═══ */}
          {menu === "visitas" && (
            <div className="fade">
              {/* KPIs — baseados nos filtros */}
              {(() => {
                // Calcula período
                const hoje = new Date();
                const toISO = (d) => d.toISOString().split("T")[0];
                let dataIni = "", dataFim = "";
                if (vFiltroPeriodo === "7") { const d = new Date(hoje); d.setDate(d.getDate() - 7); dataIni = toISO(d); dataFim = toISO(hoje); }
                else if (vFiltroPeriodo === "15") { const d = new Date(hoje); d.setDate(d.getDate() - 15); dataIni = toISO(d); dataFim = toISO(hoje); }
                else if (vFiltroPeriodo === "mes") { dataIni = toISO(new Date(hoje.getFullYear(), hoje.getMonth(), 1)); dataFim = toISO(new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)); }
                else if (vFiltroPeriodo === "custom") { dataIni = vFiltroDataCustom.de; dataFim = vFiltroDataCustom.ate; }

                const vFilt = [...visitasFiltradas]
                  .filter(v => !dataIni || v.data >= dataIni)
                  .filter(v => !dataFim || v.data <= dataFim)
                  .filter(v => !vFiltroCliente || v.clienteId === vFiltroCliente)
                  .filter(v => !vFiltroEsp || v.especialistaId === vFiltroEsp)
                  .filter(v => !vFiltroTipo || v.tipo === vFiltroTipo)
                  .filter(v => !vFiltroStatus || v.status === vFiltroStatus);

                return (
                  <>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 16 }}>
                      {[
                        { label: "Total registradas", val: vFilt.length, cor: T.azul },
                        { label: "Realizadas", val: vFilt.filter(v => v.status === "Realizada").length, cor: T.success },
                        { label: "Agendadas", val: vFilt.filter(v => v.status === "Agendada").length, cor: T.laranjaM },
                        { label: "Horas totais", val: `${vFilt.reduce((s, v) => s + (Number(v.duracao) || 0), 0)}h`, cor: T.laranja },
                      ].map((s, i) => (
                        <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: s.cor }}>{s.val}</div>
                          <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                        </Card>
                      ))}
                    </div>

                    {/* Filtros */}
                    <Card style={{ marginBottom: 16, padding: "14px 18px" }}>
                      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
                        {/* Período */}
                        <select value={vFiltroPeriodo} onChange={e => setVFiltroPeriodo(e.target.value)}
                          style={{ background: T.cardL, border: `1px solid ${vFiltroPeriodo ? T.laranja : T.border}`, borderRadius: 8, color: vFiltroPeriodo ? T.laranja : T.muted, padding: "7px 12px", fontSize: 12, outline: "none" }}>
                          <option value="">Período</option>
                          <option value="7">Última semana</option>
                          <option value="15">Últimos 15 dias</option>
                          <option value="mes">Mês atual</option>
                          <option value="custom">Escolher período</option>
                        </select>

                        {/* Datas personalizadas */}
                        {vFiltroPeriodo === "custom" && (
                          <>
                            <input type="date" value={vFiltroDataCustom.de} onChange={e => setVFiltroDataCustom(p => ({ ...p, de: e.target.value }))}
                              style={{ background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 8, color: T.text, padding: "7px 12px", fontSize: 12, outline: "none" }} />
                            <span style={{ color: T.muted, fontSize: 12 }}>até</span>
                            <input type="date" value={vFiltroDataCustom.ate} onChange={e => setVFiltroDataCustom(p => ({ ...p, ate: e.target.value }))}
                              style={{ background: T.cardL, border: `1px solid ${T.laranja}`, borderRadius: 8, color: T.text, padding: "7px 12px", fontSize: 12, outline: "none" }} />
                          </>
                        )}

                        <select value={vFiltroCliente} onChange={e => setVFiltroCliente(e.target.value)}
                          style={{ background: T.cardL, border: `1px solid ${vFiltroCliente ? T.laranja : T.border}`, borderRadius: 8, color: vFiltroCliente ? T.laranja : T.muted, padding: "7px 12px", fontSize: 12, outline: "none" }}>
                          <option value="">Todos os clientes</option>
                          {clientesFiltrados.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                        </select>

                        {isAdmin && (
                          <select value={vFiltroEsp} onChange={e => setVFiltroEsp(e.target.value)}
                            style={{ background: T.cardL, border: `1px solid ${vFiltroEsp ? T.laranja : T.border}`, borderRadius: 8, color: vFiltroEsp ? T.laranja : T.muted, padding: "7px 12px", fontSize: 12, outline: "none" }}>
                            <option value="">Todos os especialistas</option>
                            {especialistas.filter(e => e.status !== "Inativo").map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
                          </select>
                        )}

                        <select value={vFiltroTipo} onChange={e => setVFiltroTipo(e.target.value)}
                          style={{ background: T.cardL, border: `1px solid ${vFiltroTipo ? T.laranja : T.border}`, borderRadius: 8, color: vFiltroTipo ? T.laranja : T.muted, padding: "7px 12px", fontSize: 12, outline: "none" }}>
                          <option value="">Todos os tipos</option>
                          {TIPOS_VISITA.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>

                        <select value={vFiltroStatus} onChange={e => setVFiltroStatus(e.target.value)}
                          style={{ background: T.cardL, border: `1px solid ${vFiltroStatus ? T.laranja : T.border}`, borderRadius: 8, color: vFiltroStatus ? T.laranja : T.muted, padding: "7px 12px", fontSize: 12, outline: "none" }}>
                          <option value="">Todos os status</option>
                          {["Agendada","Confirmada","Realizada","Cancelada"].map(s => <option key={s} value={s}>{s}</option>)}
                        </select>

                        {(vFiltroPeriodo || vFiltroCliente || vFiltroEsp || vFiltroTipo || vFiltroStatus) && (
                          <button onClick={() => { setVFiltroPeriodo(""); setVFiltroDataCustom({ de: "", ate: "" }); setVFiltroCliente(""); setVFiltroEsp(""); setVFiltroTipo(""); setVFiltroStatus(""); }}
                            style={{ padding: "7px 12px", background: "none", border: `1px solid ${T.border}`, borderRadius: 8, color: T.muted, fontSize: 12, cursor: "pointer" }}>✕ Limpar</button>
                        )}
                      </div>
                    </Card>

                    <Card>
                      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 16 }}>Histórico de Atendimentos {!isAdmin && "· Minhas visitas"}</div>
                      {vFilt.length === 0 ? <div style={{ color: T.muted, fontSize: 13 }}>Nenhum atendimento encontrado.</div> : (
                        <div style={{ overflowX: "auto" }}>
                          <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                              <tr style={{ borderBottom: `1px solid ${T.border}` }}>
                                {["Data", "Cliente", "Especialista", "Agenda", "Tipo", "Dur.", "Descrição", "Status", "Ganhos", ""].map(h => (
                                  <th key={h} style={{ padding: "8px 10px", textAlign: "left", fontSize: 10, color: T.muted, fontWeight: 700, whiteSpace: "nowrap" }}>{h}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {[...vFilt].sort((a, b) => b.data?.localeCompare(a.data)).map((v) => (
                                <tr key={v.id} style={{ borderBottom: `1px solid ${T.border}22` }}>
                                  <td style={{ padding: "10px 10px", fontSize: 12, whiteSpace: "nowrap" }}>{fmtDate(v.data)}</td>
                                  <td style={{ padding: "10px 10px", fontSize: 12, fontWeight: 700, color: T.laranja }}>{clienteNome(v.clienteId)}</td>
                                  <td style={{ padding: "10px 10px", fontSize: 11, color: T.muted }}>{especialistaNome(v.especialistaId).split(" ")[0]}</td>
                                  <td style={{ padding: "10px 10px" }}><Badge label={v.tipoAgenda || "Projeto"} color={v.tipoAgenda === "Estratégia" ? T.laranja : T.azul} /></td>
                                  <td style={{ padding: "10px 10px" }}><Badge label={v.tipo} color={T.muted} /></td>
                                  <td style={{ padding: "10px 10px", fontSize: 12 }}>{v.duracao}h</td>
                                  <td style={{ padding: "10px 10px", fontSize: 11, color: T.muted, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{v.descricao}</td>
                                  <td style={{ padding: "10px 10px" }}><Badge label={v.status} color={statusColor(v.status)} /></td>
                                  <td style={{ padding: "10px 10px" }}>
                                    {v.ganhos?.length > 0 && (
                                      <span style={{ fontSize: 10, color: T.success, fontWeight: 700 }}>
                                        🏆 {v.ganhos.length} ganho{v.ganhos.length > 1 ? "s" : ""}
                                      </span>
                                    )}
                                  </td>
                                  <td style={{ padding: "10px 10px", display: "flex", gap: 6, alignItems: "center" }}>
                                    <Btn small variant="ghost" onClick={() => {
                                      const tarefasDaVisita = tarefas.filter(t => t.visitaId === v.id);
                                      const tarefasComId = (v.tarefasGeradas || []).map((tg, idx) => {
                                        const match = tarefasDaVisita.find(t => t.titulo === tg.titulo) || tarefasDaVisita[idx];
                                        return match ? { ...tg, id: match.id } : tg;
                                      });
                                      setModal({ type: "visita", data: { ...v, tarefasGeradas: tarefasComId } });
                                    }}>✏️</Btn>
                                    {v.status === "Realizada" && (
                                      <Btn small variant="ghost" style={{ color: T.laranja, borderColor: T.laranja }}
                                        onClick={() => {
                                          const cli = clientes.find(c => c.id === v.clienteId);
                                          const tVisita = tarefas.filter(t => t.visitaId === v.id);
                                          gerarPDFVisita(v, cli, especialistas, tVisita);
                                        }}>📄</Btn>
                                    )}
                                    <Btn small variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => deleteVisita(v.id)}>🗑️</Btn>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </Card>
                  </>
                );
              })()}
            </div>
          )}

          {/* ═══ PROSPECTS / PIPELINE ═══ */}
          {menu === "prospects" && isGestor && (
            <div className="fade">
              {/* KPIs */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
                {[
                  { label: "Total", val: prospects.length, cor: T.azul },
                  ...FASES_PIPELINE.map(f => ({ label: f, val: prospects.filter(p => p.fase === f).length, cor: COR_FASE[f] }))
                ].map((s, i) => (
                  <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                    <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                  </Card>
                ))}
              </div>

              {/* PIPELINE — 3 colunas */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
                {FASES_PIPELINE.map(fase => {
                  const cor = COR_FASE[fase];
                  const prospectsF = prospects.filter(p => p.fase === fase);
                  return (
                    <div key={fase}>
                      {/* Header da coluna */}
                      <div style={{ padding: "10px 14px", background: `${cor}22`, borderRadius: "10px 10px 0 0", border: `1px solid ${cor}44`, borderBottom: "none", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ fontSize: 12, fontWeight: 800, color: cor }}>{fase}</div>
                        <span style={{ background: cor, color: "#fff", borderRadius: 10, padding: "1px 8px", fontSize: 11, fontWeight: 700 }}>{prospectsF.length}</span>
                      </div>

                      {/* Cards de prospect */}
                      <div style={{ background: T.card, border: `1px solid ${cor}44`, borderRadius: "0 0 10px 10px", padding: 10, minHeight: 120, display: "flex", flexDirection: "column", gap: 10 }}>
                        {prospectsF.length === 0 && <div style={{ color: T.muted, fontSize: 12, textAlign: "center", padding: "16px 0" }}>Nenhum prospect</div>}
                        {prospectsF.map(p => {
                          const tarefas = CHECKLIST_FASES[fase];
                          const concluidas = tarefas.filter((_, i) => p.checklist?.[`${fase}_${i}`]).length;
                          const pct = Math.round((concluidas / tarefas.length) * 100);
                          return (
                            <div key={p.id} style={{ background: T.cardL, borderRadius: 10, padding: "12px 14px", border: `1px solid ${T.border}` }}>
                              {/* Header do card */}
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontSize: 13, fontWeight: 800 }}>{p.nome}</div>
                                  <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>{p.responsavel} · {p.segmento}</div>
                                  {p.cidade && <div style={{ fontSize: 10, color: T.muted }}>📍 {p.cidade}</div>}
                                </div>
                                <button onClick={() => setModal({ type: "prospect", data: p })} style={{ background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 14, flexShrink: 0 }}>✏️</button>
                              </div>

                              {/* Barra de progresso */}
                              <div style={{ marginBottom: 8 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: T.muted, marginBottom: 3 }}>
                                  <span>Progresso</span><span style={{ color: cor, fontWeight: 700 }}>{pct}%</span>
                                </div>
                                <div style={{ height: 4, background: T.border, borderRadius: 4 }}>
                                  <div style={{ height: "100%", width: `${pct}%`, background: cor, borderRadius: 4, transition: "width 0.3s" }} />
                                </div>
                              </div>

                              {/* Checklist */}
                              <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 10 }}>
                                {tarefas.map((t, i) => {
                                  const feita = p.checklist?.[`${fase}_${i}`];
                                  return (
                                    <div key={i} onClick={() => toggleCheckProspect(p.id, fase, i)} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", padding: "3px 0" }}>
                                      <div style={{ width: 16, height: 16, borderRadius: 4, border: `2px solid ${feita ? cor : T.border}`, background: feita ? cor : "transparent", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 10, color: "#fff", transition: "all 0.15s" }}>
                                        {feita ? "✓" : ""}
                                      </div>
                                      <span style={{ fontSize: 11, color: feita ? T.muted : T.text, textDecoration: feita ? "line-through" : "none" }}>{t}</span>
                                    </div>
                                  );
                                })}
                              </div>

                              {/* Ações */}
                              <div style={{ display: "flex", gap: 6, borderTop: `1px solid ${T.border}`, paddingTop: 8 }}>
                                {/* Avançar fase */}
                                {fase !== "INTEGRANDO" && (
                                  <button onClick={async () => {
                                    const proxFase = FASES_PIPELINE[FASES_PIPELINE.indexOf(fase) + 1];
                                    const updated = { ...p, fase: proxFase, checklist: {} };
                                    try {
                                      await api.prospects.upsert(updated);
                                      setProspects(prev => prev.map(x => x.id === p.id ? updated : x));
                                      showToast(`${p.nome} avançou para ${proxFase}!`);
                                    } catch (e) { showToast("Erro: " + e.message, "error"); }
                                  }} style={{ flex: 1, padding: "5px", background: `${cor}22`, border: `1px solid ${cor}44`, borderRadius: 6, color: cor, fontSize: 10, fontWeight: 700, cursor: "pointer" }}>
                                    Avançar →
                                  </button>
                                )}
                                {/* Exportar para Projeto */}
                                {fase === "INTEGRANDO" && pct === 100 && (
                                  <button onClick={() => exportarProspectParaProjeto(p)} style={{ flex: 1, padding: "5px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 6, color: "#fff", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>
                                    🚀 Exportar para Projeto
                                  </button>
                                )}
                                {fase === "INTEGRANDO" && pct < 100 && (
                                  <div style={{ flex: 1, padding: "5px", textAlign: "center", fontSize: 10, color: T.muted }}>Complete o checklist para exportar</div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                        {/* Botão adicionar */}
                        <button onClick={() => setModal({ type: "prospect", data: { fase } })} style={{ padding: "8px", background: "transparent", border: `1px dashed ${T.border}`, borderRadius: 8, color: T.muted, fontSize: 12, cursor: "pointer", textAlign: "center" }}>
                          + Adicionar prospect
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ═══ TIPOS DE PROJETO ═══ */}
          {menu === "tiposProjeto" && isGestor && (
            <div className="fade">
              <Card>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 16 }}>🗂️ Tipos de Projeto</div>
                {tiposProjeto.length === 0 && <div style={{ color: T.muted, fontSize: 13, marginBottom: 12 }}>Nenhum tipo cadastrado ainda.</div>}
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {tiposProjeto.map(t => (
                    <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 16px", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}`, borderLeft: `4px solid ${T.laranja}` }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{t.tipo}</div>
                        {t.descricao && <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{t.descricao}</div>}
                      </div>
                      <Btn small variant="ghost" onClick={() => setModal({ type: "tipoProjeto", data: t })}>✏️</Btn>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          )}

          {/* ═══ MARCOS ═══ */}
          {menu === "marcos" && (
            <div className="fade">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
                {[
                  { label: "Globais", val: marcos.filter(m => m.tipoMarco === "Global" || !m.tipoMarco).length, cor: T.azul },
                  { label: "Específicos", val: marcos.filter(m => m.tipoMarco === "Específico").length, cor: "#8b5cf6" },
                  { label: "Total", val: marcos.length, cor: T.laranja },
                ].map((s, i) => (
                  <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                    <div style={{ fontSize: 24, fontWeight: 900, color: s.cor }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                  </Card>
                ))}
              </div>
              <Card>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 16 }}>Marcos Cadastrados</div>
                {marcos.length === 0 && <div style={{ color: T.muted, fontSize: 13 }}>Nenhum marco cadastrado.</div>}
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {[...marcos].sort((a,b) => (a.titulo||"").localeCompare(b.titulo||"")).map(m => {
                    const tp = tiposProjeto.find(t => t.id === m.tipoProjetoId);
                    return (
                      <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px 16px", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}`, borderLeft: `4px solid ${m.tipoMarco === "Específico" ? "#8b5cf6" : T.azul}` }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 700 }}>{m.titulo}</div>
                          <div style={{ fontSize: 11, color: T.muted, marginTop: 2, display: "flex", gap: 8 }}>
                            <span style={{ padding: "1px 8px", borderRadius: 10, background: m.tipoMarco === "Específico" ? "#8b5cf622" : `${T.azul}22`, color: m.tipoMarco === "Específico" ? "#8b5cf6" : T.azul, fontWeight: 700 }}>{m.tipoMarco || "Global"}</span>
                            {tp && <span>📁 {tp.tipo}</span>}
                            {m.descricao && <span>{m.descricao}</span>}
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <Badge label={m.prioridade || "Média"} color={prioColor(m.prioridade || "Média")} />
                          {isGestor && <Btn small variant="ghost" onClick={() => setModal({ type: "marco", data: m })}>✏️</Btn>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            </div>
          )}

          {/* ═══ DMG ═══ */}
          {menu === "dmg" && (
            <DMGModule clientes={clientesFiltrados} dmgData={dmgData} onSaveDmg={saveDmg} onDeleteDmg={deleteDmg} isAdmin={isGestor} />
          )}
          {menu === "dps" && (
            <DPSModule
              clientes={clientesFiltrados}
              dpsData={dpsData}
              especialistas={especialistas}
              consultores={consultores}
              usuarioLogado={usuarioLogado}
              onSave={saveDps}
              onDelete={deleteDps}
              isGestor={isGestor}
            />
          )}

          {/* ═══ ESPECIALISTAS (admin only) ═══ */}
          {menu === "especialistas" && isGestor && (
            <div className="fade">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
                {[
                  { label: "Total", val: especialistas.length, cor: T.azul },
                  { label: "Ativos", val: especialistas.filter(e => e.status === "Ativo").length, cor: T.success },
                  { label: "Parceiros externos", val: especialistas.filter(e => e.status === "Parceiro externo").length, cor: "#8b5cf6" },
                  { label: "Inativos", val: especialistas.filter(e => e.status === "Inativo").length, cor: T.danger },
                ].map((s, i) => (
                  <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                    <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                  </Card>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
                {especialistas.map(e => {
                  const projetos = clientes.filter(c => c.especialistaId === e.id).length;
                  const horasE = visitas.filter(v => v.especialistaId === e.id && v.status === "Realizada").reduce((s, v) => s + (Number(v.duracao) || 0), 0);
                  return (
                    <Card key={e.id} style={{ position: "relative" }}>
                      {e.status === "Inativo" && <div style={{ position: "absolute", top: 12, right: 12 }}><Badge label="Inativo" color={T.danger} /></div>}
                      {e.status === "Parceiro externo" && <div style={{ position: "absolute", top: 12, right: 12 }}><Badge label="Parceiro" color="#8b5cf6" /></div>}

                      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
                        <div style={{ width: 48, height: 48, borderRadius: "50%", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 16, flexShrink: 0 }}>{iniciais(e.nome)}</div>
                        <div>
                          <div style={{ fontSize: 14, fontWeight: 800 }}>{e.nome}</div>
                          <div style={{ fontSize: 11, color: T.muted }}>{e.especialidade}</div>
                          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 4 }}>
                            <Badge label={e.perfil} color={e.perfil === "Admin" ? T.laranja : e.perfil === "Gestor" ? "#8b5cf6" : T.azul} />
                            {(e.tipoAtuacao || []).map(t => (
                              <Badge key={t} label={t} color={t === "Estratégico" ? "#8b5cf6" : T.success} />
                            ))}
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span style={{ fontSize: 11, color: T.muted }}>E-mail</span>
                          <span style={{ fontSize: 11, fontWeight: 600 }}>{e.email}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span style={{ fontSize: 11, color: T.muted }}>Projetos</span>
                          <span style={{ fontSize: 11, fontWeight: 700, color: T.laranja }}>{projetos}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span style={{ fontSize: 11, color: T.muted }}>Horas entregues</span>
                          <span style={{ fontSize: 11, fontWeight: 700, color: T.azul }}>{horasE}h</span>
                        </div>
                      </div>

                      {e.bio && <div style={{ fontSize: 11, color: T.muted, fontStyle: "italic", marginBottom: 12, paddingTop: 10, borderTop: `1px solid ${T.border}` }}>{e.bio}</div>}

                      <Btn small variant="ghost" style={{ width: "100%" }} onClick={() => setModal({ type: "especialista", data: e })}>✏️ Editar</Btn>
                    </Card>
                  );
                })}
              </div>
            </div>
          )}

          {/* ═══ CONSULTORES ═══ */}
          {menu === "consultores" && isGestor && (
            <div className="fade">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
                {[
                  { label: "Total", val: consultores.length, cor: T.azul },
                  { label: "Ativos", val: consultores.filter(c => c.status === "Ativo").length, cor: T.success },
                  { label: "Inativos", val: consultores.filter(c => c.status === "Inativo").length, cor: T.muted },
                ].map((s, i) => (
                  <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                    <div style={{ fontSize: 24, fontWeight: 900, color: s.cor }}>{s.val}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                  </Card>
                ))}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {consultores.length === 0 && <Card><div style={{ color: T.muted, fontSize: 13 }}>Nenhum consultor cadastrado.</div></Card>}
                {consultores.map(c => {
                  const visitasC = visitas.filter(v => v.consultorId === c.id && v.status === "Realizada");
                  const totalHoras = visitasC.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
                  const totalAtend = c.valorHoraAtendimento * totalHoras;
                  const totalHDeslocamento = visitasC.reduce((s, v) => {
                    return s + (v.horarios || []).filter(h => h.deslocamento).reduce((a, h) => {
                      if (!h.inicio || !h.fim) return a;
                      const [ih, im] = h.inicio.split(":").map(Number);
                      const [fh, fm] = h.fim.split(":").map(Number);
                      const mins = (fh * 60 + fm) - (ih * 60 + im);
                      return a + (mins > 60 ? mins / 60 : 0);
                    }, 0);
                  }, 0);
                  const totalDesloc = c.valorHoraDeslocamento * totalHDeslocamento;
                  const totalDespesas = visitasC.reduce((s, v) => s + (v.despesaViagem || []).reduce((a, d) => a + (Number(d.valor) || 0), 0), 0);
                  const totalPagar = totalAtend + totalDesloc + totalDespesas;
                  return (
                    <Card key={c.id}>
                      <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
                        <div style={{ width: 48, height: 48, borderRadius: "50%", background: `linear-gradient(135deg,${T.azul},#8b5cf6)`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 16, color: "#fff", flexShrink: 0 }}>
                          {c.nome.split(" ").slice(0,2).map(n => n[0]).join("")}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div>
                              <div style={{ fontSize: 14, fontWeight: 800 }}>{c.nome}</div>
                              <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{c.especialidade} · {c.email}</div>
                            </div>
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                              <Badge label={c.status} color={c.status === "Ativo" ? T.success : T.muted} />
                              <Btn small variant="ghost" onClick={() => setModal({ type: "consultor", data: c })}>✏️</Btn>
                            </div>
                          </div>
                          <div style={{ display: "grid", gridTemplateColumns: isGestorPuro ? "repeat(4,1fr)" : "repeat(2,1fr)", gap: 10, marginTop: 14 }}>
                            {[
                              { label: "Atendimentos", val: visitasC.length, cor: T.azul, sempreVisivel: true },
                              { label: "Horas realizadas", val: `${totalHoras}h`, cor: T.laranjaM, sempreVisivel: true },
                              { label: "Valor hora atend.", val: fmtMoeda(c.valorHoraAtendimento), cor: T.laranja, sempreVisivel: false },
                              { label: "Total a pagar", val: fmtMoeda(totalPagar), cor: T.success, sempreVisivel: false },
                            ].filter(k => k.sempreVisivel || isGestorPuro).map((k, i) => (
                              <div key={i} style={{ background: T.cardL, borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
                                <div style={{ fontSize: 14, fontWeight: 800, color: k.cor }}>{k.val}</div>
                                <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>{k.label}</div>
                              </div>
                            ))}
                          </div>
                          {isGestorPuro && (totalDesloc > 0 || totalDespesas > 0) && (
                            <div style={{ display: "flex", gap: 8, marginTop: 8, fontSize: 11, color: T.muted }}>
                              {totalDesloc > 0 && <span>🚗 Deslocamento: {fmtMoeda(totalDesloc)}</span>}
                              {totalDespesas > 0 && <span>🧾 Despesas: {fmtMoeda(totalDespesas)}</span>}
                            </div>
                          )}
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            </div>
          )}

          {/* ═══ RELATÓRIOS (admin only) ═══ */}
          {menu === "relatorios" && isGestor && (
            <div className="fade">
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14, marginBottom: 22 }}>
                {[
                  { titulo: "Relatório Mensal", sub: "Visitas, horas e marcos do período", icon: "📋", cor: T.laranja, fn: () => gerarRelatorioMensal(visitas, clientes, especialistas, marcosFiltrados) },
                  { titulo: "Performance por Especialista", sub: "Visitas e horas individuais", icon: "👥", cor: T.azul, fn: () => gerarRelatorioEspecialistas(visitas, especialistas, clientes) },
                  { titulo: "Maturidade da Carteira", sub: "Ranking DMG de todos os clientes", icon: "📈", cor: T.laranjaM, fn: () => gerarRelatorioMaturidade(clientes, dmgData) },
                  { titulo: "Receita e Contratos", sub: "Faturamento mensal consolidado", icon: "💰", cor: T.success, fn: () => gerarRelatorioReceita(clientes), visivel: true },
                  { titulo: "Marcos por Período", sub: "Status e prazos dos projetos", icon: "🎯", cor: T.laranja, fn: () => gerarRelatorioMarcos(clientes, marcosFiltrados), visivel: true },
                  { titulo: "Pipeline de Renovações", sub: "Contratos e vencimentos", icon: "🔄", cor: T.azul, fn: () => gerarRelatorioPipeline(clientes), visivel: true },
                  { titulo: "Fechamento Consultores", sub: "Horas, deslocamento e pagamentos", icon: "🤝", cor: "#8b5cf6", fn: () => setModal({ type: "relConsultor" }), visivel: isGestorPuro },
                ].filter(r => r.visivel).map((r, i) => (
                  <Card key={i} style={{ cursor: "pointer" }} onClick={r.fn}>
                    <div style={{ fontSize: 28, marginBottom: 10 }}>{r.icon}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{r.titulo}</div>
                    <div style={{ fontSize: 11, color: T.muted, marginBottom: 14 }}>{r.sub}</div>
                    <Btn small style={{ width: "100%", background: `${r.cor}22`, color: r.cor }} onClick={e => { e.stopPropagation(); r.fn(); }}>Gerar →</Btn>
                  </Card>
                ))}
              </div>

              {/* ── GANHOS POR PROJETO ── */}
              {(() => {
                // Monta dados de ganhos por cliente
                const ganhosPorCliente = clientes.map(c => {
                  const visitasCliente = visitas.filter(v => v.clienteId === c.id && v.status === "Realizada");
                  // Deduplica visitas pelo id antes de fazer flatMap
                  const visitasUnicas = visitasCliente.filter((v, i, arr) => arr.findIndex(x => x.id === v.id) === i);
                  const todosGanhos = visitasUnicas.flatMap(v => (v.ganhos || []).map(g => ({ ...g, visitaData: v.data, visitaTipo: v.tipo })));
                  const totalReais = todosGanhos.filter(g => g.unidade === "R$" && g.valor).reduce((s, g) => s + Number(g.valor), 0);
                  const totalHoras = todosGanhos.filter(g => g.unidade === "hrs" && g.valor).reduce((s, g) => s + Number(g.valor), 0);
                  const totalPct = todosGanhos.filter(g => g.unidade === "%" && g.valor).reduce((s, g) => s + Number(g.valor), 0);
                  return { cliente: c, ganhos: todosGanhos, totalReais, totalHoras, totalPct, qtdVisitas: visitasCliente.length };
                }).filter(g => g.ganhos.length > 0).sort((a, b) => b.totalReais - a.totalReais);

                const totalGeralReais = ganhosPorCliente.reduce((s, g) => s + g.totalReais, 0);
                const totalGeralHoras = ganhosPorCliente.reduce((s, g) => s + g.totalHoras, 0);
                const totalGeralGanhos = ganhosPorCliente.reduce((s, g) => s + g.ganhos.length, 0);

                return (
                  <Card style={{ marginBottom: 18 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 800 }}>🏆 Ganhos por Projeto</div>
                        <div style={{ fontSize: 11, color: T.muted, marginTop: 3 }}>Resultados e entregas registrados nas visitas realizadas</div>
                      </div>
                      <div style={{ display: "flex", gap: 10 }}>
                        {[
                          { label: "Total em R$", val: fmtMoeda(totalGeralReais), cor: T.success },
                          { label: "Horas economizadas", val: `${totalGeralHoras}h`, cor: T.azul },
                          { label: "Ganhos registrados", val: totalGeralGanhos, cor: T.laranjaM },
                        ].map((s, i) => (
                          <div key={i} style={{ padding: "8px 14px", background: `${s.cor}18`, border: `1px solid ${s.cor}33`, borderRadius: 10, textAlign: "center" }}>
                            <div style={{ fontSize: 14, fontWeight: 900, color: s.cor }}>{s.val}</div>
                            <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>{s.label}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {ganhosPorCliente.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "32px 0", color: T.muted, fontSize: 13 }}>
                        <div style={{ fontSize: 32, marginBottom: 8 }}>📭</div>
                        Nenhum ganho registrado ainda. Adicione ganhos ao lançar visitas realizadas.
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                        {ganhosPorCliente.map((gp, idx) => (
                          <div key={gp.cliente.id} style={{ background: T.cardL, borderRadius: 12, overflow: "hidden", border: `1px solid ${T.border}` }}>
                            {/* Header cliente */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: `1px solid ${T.border}` }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <div style={{ width: 10, height: 10, borderRadius: "50%", background: idx === 0 ? T.laranja : idx === 1 ? T.laranjaM : T.azul, flexShrink: 0 }} />
                                <div style={{ fontSize: 13, fontWeight: 800 }}>{gp.cliente.nome}</div>
                                <Badge label={gp.cliente.segmento} color={T.muted} />
                                <span style={{ fontSize: 11, color: T.muted }}>{gp.qtdVisitas} visita{gp.qtdVisitas > 1 ? "s" : ""} com ganhos</span>
                              </div>
                              <div style={{ display: "flex", gap: 8 }}>
                                {gp.totalReais > 0 && <span style={{ fontSize: 12, fontWeight: 800, color: T.success }}>{fmtMoeda(gp.totalReais)}</span>}
                                {gp.totalHoras > 0 && <span style={{ fontSize: 12, fontWeight: 800, color: T.azul }}>{gp.totalHoras}h</span>}
                                {gp.totalPct > 0 && <span style={{ fontSize: 12, fontWeight: 800, color: T.laranjaM }}>{gp.totalPct}%</span>}
                              </div>
                            </div>

                            {/* Lista de ganhos */}
                            <div style={{ padding: "8px 0" }}>
                              {gp.ganhos.map((g, i) => (
                                <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 16px", borderBottom: i < gp.ganhos.length - 1 ? `1px solid ${T.border}22` : "none" }}>
                                  <div style={{ width: 6, height: 6, borderRadius: "50%", background: g.unidade === "R$" ? T.success : g.unidade === "hrs" ? T.azul : T.laranjaM, flexShrink: 0 }} />
                                  <div style={{ flex: 1, fontSize: 12 }}>{g.tipo || "Ganho registrado"}</div>
                                  <div style={{ fontSize: 11, color: T.muted }}>{g.visitaTipo} · {fmtDate(g.visitaData)}</div>
                                  <div style={{ fontSize: 13, fontWeight: 800, color: g.unidade === "R$" ? T.success : g.unidade === "hrs" ? T.azul : T.laranjaM, minWidth: 80, textAlign: "right" }}>
                                    {g.unidade === "R$" ? fmtMoeda(Number(g.valor)) : `${g.valor} ${g.unidade}`}
                                  </div>
                                </div>
                              ))}
                            </div>

                            {/* Barra proporcional vs total geral */}
                            {totalGeralReais > 0 && gp.totalReais > 0 && (
                              <div style={{ padding: "8px 16px 12px", borderTop: `1px solid ${T.border}22` }}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                                  <span style={{ fontSize: 10, color: T.muted }}>Participação no total de R$ da carteira</span>
                                  <span style={{ fontSize: 10, fontWeight: 700, color: T.laranjaM }}>{Math.round((gp.totalReais / totalGeralReais) * 100)}%</span>
                                </div>
                                <div style={{ height: 4, background: T.border, borderRadius: 3 }}>
                                  <div style={{ height: "100%", width: `${Math.round((gp.totalReais / totalGeralReais) * 100)}%`, background: `linear-gradient(90deg,${T.laranja},${T.laranjaM})`, borderRadius: 3 }} />
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Card>
                );
              })()}

              {/* Performance por especialista */}
              <Card style={{ marginBottom: 18 }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 18 }}>Performance por Especialista</div>
                <ResponsiveContainer width="100%" height={200}>
                  <BarChart data={especialistas.filter(e => e.status !== "Inativo").map(e => ({ nome: e.nome.split(" ")[0], visitas: visitas.filter(v => v.especialistaId === e.id).length, horas: visitas.filter(v => v.especialistaId === e.id).reduce((s, v) => s + (Number(v.duracao) || 0), 0), projetos: clientes.filter(c => c.especialistaId === e.id).length })).filter(e => e.visitas > 0)}>
                    <CartesianGrid strokeDasharray="3 3" stroke={T.border} />
                    <XAxis dataKey="nome" tick={{ fill: T.muted, fontSize: 11 }} axisLine={false} tickLine={false} />
                    <YAxis tick={{ fill: T.muted, fontSize: 11 }} axisLine={false} tickLine={false} />
                    <Tooltip contentStyle={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, fontSize: 11 }} />
                    <Bar dataKey="visitas" name="Atendimentos" fill={T.laranja} radius={[4, 4, 0, 0]} />
                    <Bar dataKey="horas" name="Horas" fill={T.azul} radius={[4, 4, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </Card>

              <Card>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 18 }}>Ranking DMG — Carteira Completa</div>
                {[...clientes].map(c => ({ ...c, mat: calcMat(dmgData[c.id]) })).sort((a, b) => b.mat - a.mat).map((c, i) => (
                  <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 10 }}>
                    <div style={{ width: 22, fontSize: 12, fontWeight: 800, color: i < 3 ? T.laranjaM : T.muted, textAlign: "right", flexShrink: 0 }}>#{i + 1}</div>
                    <div style={{ width: 130, fontSize: 12, fontWeight: 600, flexShrink: 0 }}>{c.nome}</div>
                    <div style={{ flex: 1, height: 8, background: T.border, borderRadius: 4 }}><div style={{ height: "100%", width: c.mat > 0 ? `${c.mat}%` : "2%", background: c.mat > 70 ? T.success : c.mat > 50 ? T.laranjaM : c.mat > 0 ? T.danger : T.border, borderRadius: 4 }} /></div>
                    <div style={{ width: 44, fontSize: 12, fontWeight: 800, color: c.mat > 70 ? T.success : c.mat > 50 ? T.laranjaM : c.mat > 0 ? T.danger : T.muted, textAlign: "right", flexShrink: 0 }}>{c.mat > 0 ? `${c.mat}%` : "—"}</div>
                  </div>
                ))}
              </Card>
            </div>
          )}
        </div>
      </div>

      {/* MODAIS */}
      {modal?.type === "cliente" && <ModalWrap title={modal.data?.id ? `Editar — ${modal.data.nome}` : "Novo Cliente"} onClose={() => setModal(null)}><FormCliente data={modal.data} especialistas={especialistas.filter(e => e.status !== "Inativo")} tiposProjeto={tiposProjeto} marcosBase={marcos} onSave={saveCliente} onDelete={deleteCliente} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "tarefa" && <ModalWrap title={modal.data?.id ? "Editar Tarefa" : "Nova Tarefa"} onClose={() => setModal(null)}><FormTarefa data={modal.data} clientes={clientesFiltrados} visitas={visitasFiltradas} especialistas={especialistas} onSave={saveTarefa} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "visita" && <ModalWrap title={modal.data?.id ? "Editar Atendimento" : "Novo Atendimento"} onClose={() => setModal(null)} maxWidth={680}><FormVisita data={modal.data} clientes={clientesFiltrados} especialistas={especialistas.filter(e => e.status !== "Inativo")} consultores={consultores} isAdmin={isGestor} usuarioLogado={usuarioLogado} onDelete={modal.data?.id ? deleteVisita : null} onSave={async (visitaData) => {
        const visitaId = await saveVisita(visitaData);
        // Só cria tarefas que ainda não existem no banco para esta visita
        if (visitaData.tarefasGeradas?.length > 0) {
          const tarefasJaExistem = tarefas.filter(t => t.visitaId === visitaId).map(t => t.titulo?.trim().toLowerCase());
          for (const t of visitaData.tarefasGeradas) {
            if (!t.titulo?.trim()) continue;
            const jaExiste = tarefasJaExistem.includes(t.titulo.trim().toLowerCase());
            if (!jaExiste) {
              await saveTarefa({ ...t, id: undefined, visitaId, clienteId: visitaData.clienteId }, false);
            }
          }
        }
        setModal(null);
      }} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "marco" && <ModalWrap title={modal.data?.id ? "Editar Marco" : "Novo Marco"} onClose={() => setModal(null)}><FormMarco data={modal.data} tiposProjeto={tiposProjeto} onSave={saveMarco} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "marcosProj" && <ModalWrap title={`🎯 Marcos — ${modal.data?.nome}`} onClose={() => setModal(null)} maxWidth={700}><MarcosProjetoModal cliente={modal.data} onSave={saveCliente} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "tipoProjeto" && <ModalWrap title={modal.data?.id ? "Editar Tipo de Projeto" : "Novo Tipo de Projeto"} onClose={() => setModal(null)}><FormTipoProjeto data={modal.data} onSave={saveTipoProjeto} onDelete={deleteTipoProjeto} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "relConsultor" && (() => {
        const dtIni = relDtIni, setDtIni = setRelDtIni;
        const dtFim = relDtFim, setDtFim = setRelDtFim;
        const consultorSel = relConsultorSel, setConsultorSel = setRelConsultorSel;
        const visitasFiltradas_ = visitas.filter(v => {
          if (v.status !== "Realizada") return false;
          if (dtIni && v.data < dtIni) return false;
          if (dtFim && v.data > dtFim) return false;
          return true;
        });
        const consultoresAtivos = consultores.filter(c => c.status === "Ativo");
        return (
          <ModalWrap title="Fechamento de Consultores" onClose={() => setModal(null)}>
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>

              {/* Filtros de data */}
              <div style={{ background: T.cardL, borderRadius: 10, padding: "14px 16px", border: `1px solid ${T.border}` }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: T.muted, marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.5px" }}>Período</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <div>
                    <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 5 }}>Data início</label>
                    <input type="date" value={dtIni} onChange={e => setDtIni(e.target.value)}
                      style={{ width: "100%", background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 5 }}>Data fim</label>
                    <input type="date" value={dtFim} onChange={e => setDtFim(e.target.value)}
                      style={{ width: "100%", background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
                  </div>
                </div>
                {(dtIni || dtFim) && (
                  <div style={{ marginTop: 8, fontSize: 11, color: T.laranja }}>
                    📋 {visitasFiltradas_.length} atendimento(s) no período
                    {dtIni && ` · De ${new Date(dtIni + "T12:00:00").toLocaleDateString("pt-BR")}`}
                    {dtFim && ` até ${new Date(dtFim + "T12:00:00").toLocaleDateString("pt-BR")}`}
                    <button onClick={() => { setDtIni(""); setDtFim(""); }}
                      style={{ marginLeft: 10, background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 11, textDecoration: "underline" }}>
                      Limpar
                    </button>
                  </div>
                )}
              </div>

              {/* Seleção de consultor */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: T.muted, marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.5px" }}>Consultor</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {consultoresAtivos.map(c => {
                    const visitasC = visitasFiltradas_.filter(v => v.consultorId === c.id);
                    const totalH = visitasC.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
                    const ativo = consultorSel === c.id;
                    return (
                      <button key={c.id} onClick={() => setConsultorSel(ativo ? "todos" : c.id)}
                        style={{ padding: "12px 16px", background: ativo ? `${T.laranja}18` : T.cardL, border: `1px solid ${ativo ? T.laranja + "55" : T.border}`, borderRadius: 10, textAlign: "left", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", transition: "all .15s" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ width: 32, height: 32, borderRadius: "50%", background: ativo ? T.laranja : `${T.azul}33`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, color: ativo ? "#fff" : T.azul }}>
                            {c.nome.split(" ").slice(0,2).map(n => n[0]).join("").toUpperCase()}
                          </div>
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: ativo ? T.laranja : T.text }}>{c.nome}</div>
                            <div style={{ fontSize: 11, color: T.muted }}>{c.especialidade}</div>
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: 13, fontWeight: 800, color: ativo ? T.laranja : T.azul }}>{visitasC.length} atend.</div>
                          <div style={{ fontSize: 11, color: T.muted }}>{Math.round(totalH * 10) / 10}h</div>
                        </div>
                      </button>
                    );
                  })}
                  {consultoresAtivos.length === 0 && (
                    <div style={{ color: T.muted, fontSize: 13, textAlign: "center", padding: 16 }}>Nenhum consultor ativo cadastrado.</div>
                  )}
                </div>
              </div>

              {/* Botões de gerar */}
              <div style={{ display: "flex", gap: 10, borderTop: `1px solid ${T.border}`, paddingTop: 14 }}>
                {consultorSel !== "todos" && (
                  <Btn style={{ flex: 1 }} onClick={() => {
                    const c = consultores.find(x => x.id === consultorSel);
                    gerarRelatorioConsultores([c], visitasFiltradas_, clientes);
                    setModal(null);
                  }}>
                    📄 Gerar — {consultores.find(x => x.id === consultorSel)?.nome?.split(" ")[0]}
                  </Btn>
                )}
                <Btn variant="secondary" style={{ flex: consultorSel !== "todos" ? "0 0 auto" : 1 }} onClick={() => {
                  gerarRelatorioConsultores(consultoresAtivos, visitasFiltradas_, clientes);
                  setModal(null);
                }}>
                  📊 Gerar Todos
                </Btn>
              </div>
            </div>
          </ModalWrap>
        );
      })()}
      {modal?.type === "prospect" && <ModalWrap title={modal.data?.id ? `Editar — ${modal.data.nome}` : "Novo Prospect"} onClose={() => setModal(null)}><FormProspect data={modal.data} onSave={saveProspect} onDelete={deleteProspect} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "especialista" && <ModalWrap title={modal.data?.id ? `Editar — ${modal.data.nome}` : "Novo Especialista"} onClose={() => setModal(null)}><FormEspecialista data={modal.data} onSave={saveEspecialista} onClose={() => setModal(null)} /></ModalWrap>}
      {modal?.type === "consultor" && <ModalWrap title={modal.data?.id ? `Editar — ${modal.data.nome}` : "Novo Consultor"} onClose={() => setModal(null)}><FormConsultor data={modal.data} isAdmin={isGestorPuro} usuarioLogado={usuarioLogado} onSave={saveConsultor} onDelete={deleteConsultor} onClose={() => setModal(null)} /></ModalWrap>}

      {toast && <div style={{ position: "fixed", bottom: 24, right: 24, background: toast.type === "success" ? T.success : T.warning, color: "#fff", padding: "12px 20px", borderRadius: 10, fontSize: 13, fontWeight: 700, zIndex: 2000, boxShadow: "0 4px 20px rgba(0,0,0,.4)", animation: "fadeUp .3s ease" }}>{toast.msg}</div>}
    </div>
  );
}

// ─── GERADOR DE PDF DE VISITA ─────────────────────────────────────────────────
function gerarPDFVisita(visita, cliente, especialistas, tarefasVisita = []) {
  const esp = especialistas.find(e => e.id === visita.especialistaId);
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";

  const html = `
    <!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="UTF-8">
      <title>Relatório de Atendimento — ${cliente?.nome || ""}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Segoe UI', Arial, sans-serif; color: #212121; background: #fff; }
        .header { background: linear-gradient(135deg, #F44D19, #EF8220); padding: 24px 40px; color: white; display: flex; align-items: center; gap: 24px; }
        .header-right { flex: 1; }
        .header-title { font-size: 20px; font-weight: 700; margin-bottom: 4px; }
        .header-sub { font-size: 13px; opacity: 0.9; }
        .content { padding: 32px 40px; }
        .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; margin-bottom: 28px; }
        .info-box { background: #f8f9fa; border-radius: 8px; padding: 14px 16px; border-left: 3px solid #F44D19; }
        .info-label { font-size: 10px; color: #6c757d; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px; }
        .info-value { font-size: 14px; font-weight: 700; color: #212121; }
        .section { margin-bottom: 28px; }
        .section-title { font-size: 13px; font-weight: 800; color: #F44D19; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 2px solid #F44D1922; }
        .section-text { font-size: 13px; line-height: 1.8; color: #333; white-space: pre-wrap; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        th { background: #F44D19; color: white; padding: 8px 12px; text-align: left; font-size: 11px; font-weight: 700; }
        td { padding: 8px 12px; border-bottom: 1px solid #f0f0f0; color: #333; }
        tr:nth-child(even) td { background: #fafafa; }
        .ganho-value { font-weight: 700; color: #22c55e; }
        .tarefa-ok { color: #22c55e; }
        .tarefa-pendente { color: #f59e0b; }
        .badge { display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 11px; font-weight: 700; }
        .badge-laranja { background: #F44D1922; color: #F44D19; }
        .badge-azul { background: #0075EA22; color: #0075EA; }
        .footer { margin-top: 40px; padding: 20px 40px; background: #f8f9fa; border-top: 2px solid #F44D1922; display: flex; justify-content: space-between; align-items: center; }
        .footer-lema { font-size: 12px; color: #F44D19; font-weight: 700; }
        .footer-info { font-size: 11px; color: #6c757d; }
        .assinatura { margin-top: 48px; display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
        .assin-box { border-top: 1px solid #333; padding-top: 8px; text-align: center; font-size: 11px; color: #6c757d; }
        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
      </style>
    </head>
    <body>
      <div class="header">
        <img src="${LOGO_LUMEN}" alt="Lumen Instituto" style="height:58px;display:block"/>
        <div class="header-right">
          <div class="header-title">Relatório de Atendimento</div>
          <div class="header-sub">${cliente?.nome || ""} · ${fmtDate(visita.data)}</div>
        </div>
      </div>

      <div class="content">
        <!-- Informações gerais -->
        <div class="info-grid">
          <div class="info-box">
            <div class="info-label">Cliente</div>
            <div class="info-value">${cliente?.nome || "—"}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Data do atendimento</div>
            <div class="info-value">${fmtDate(visita.data)}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Duração</div>
            <div class="info-value">${visita.duracao || "—"}h</div>
          </div>
          <div class="info-box">
            <div class="info-label">Tipo de atividade</div>
            <div class="info-value">${visita.tipo || "—"}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Tipo de agenda</div>
            <div class="info-value">${visita.tipoAgenda || "—"}</div>
          </div>
          <div class="info-box">
            <div class="info-label">Especialista</div>
            <div class="info-value">${esp?.nome || "—"}</div>
          </div>
        </div>

        ${visita.descricao ? `
        <div class="section">
          <div class="section-title">Descrição Geral</div>
          <div class="section-text">${visita.descricao}</div>
        </div>` : ""}

        ${(visita.itensPauta || []).length > 0 ? `
        <div class="section">
          <div class="section-title">Itens de Pauta</div>
          <table>
            <thead><tr><th>#</th><th>Item / Assunto</th><th>Stakeholder</th></tr></thead>
            <tbody>
              ${visita.itensPauta.map((item, i) => `
                <tr><td>${i + 1}</td><td>${item.item || "—"}</td><td>${item.stakeholder || "—"}</td></tr>
              `).join("")}
            </tbody>
          </table>
        </div>` : ""}

        ${visita.ata ? `
        <div class="section">
          <div class="section-title">Ata do Atendimento</div>
          <div class="section-text">${visita.ata}</div>
        </div>` : ""}

        ${tarefasVisita.length > 0 ? `
        <div class="section">
          <div class="section-title">Tarefas Geradas</div>
          <table>
            <thead><tr><th>Tarefa</th><th>Responsável</th><th>Prazo</th><th>Status</th></tr></thead>
            <tbody>
              ${tarefasVisita.map(t => `
                <tr>
                  <td>${t.titulo || "—"}</td>
                  <td>${t.responsavel || "—"}</td>
                  <td>${fmtDate(t.prazo)}</td>
                  <td class="${t.status === "Concluída" ? "tarefa-ok" : "tarefa-pendente"}">${t.status || "—"}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        </div>` : ""}

        ${(visita.ganhos || []).length > 0 ? `
        <div class="section">
          <div class="section-title">Ganhos deste Atendimento</div>
          <table>
            <thead><tr><th>Descrição</th><th>Valor</th><th>Unidade</th></tr></thead>
            <tbody>
              ${visita.ganhos.map(g => `
                <tr>
                  <td>${g.tipo || "—"}</td>
                  <td class="ganho-value">${g.valor || "—"}</td>
                  <td>${g.unidade || "—"}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        </div>` : ""}

        <!-- Assinaturas -->
        <div class="assinatura">
          <div class="assin-box">
            ${cliente?.nome || "Cliente"}<br>
            <span style="font-size:10px">Assinatura do cliente</span>
          </div>
          <div class="assin-box">
            ${esp?.nome || "Especialista"}<br>
            <span style="font-size:10px">Assinatura do especialista Lumen</span>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="footer-lema">Movidos pelo Resultado</div>
        <div class="footer-info">Lumen Instituto · lumeninstituto.com.br · Gerado em ${new Date().toLocaleDateString("pt-BR")}</div>
      </div>

      <script>window.onload = () => window.print();</script>
    </body>
    </html>
  `;

  const win = window.open("", "_blank");
  if (win) { win.document.write(html); win.document.close(); }
}

// ─── FUNÇÕES DE RELATÓRIO ────────────────────────────────────────────────────
function abrirRelatorio(titulo, html) {
  const win = window.open("", "_blank");
  if (!win) return;
  win.document.write(`<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"><title>${titulo}</title>
  <style>*{margin:0;padding:0;box-sizing:border-box}body{font-family:'Segoe UI',Arial,sans-serif;color:#212121;background:#fff}
  .header{background:linear-gradient(135deg,#F44D19,#EF8220);padding:24px 40px;color:white;display:flex;align-items:center;gap:24px}
  .header-info{flex:1}
  .header-title{font-size:18px;font-weight:700;margin-bottom:3px}.header-sub{font-size:12px;opacity:.9}
  .content{padding:28px 40px}
  table{width:100%;border-collapse:collapse;font-size:12px;margin-bottom:20px}
  th{background:#F44D19;color:white;padding:8px 10px;text-align:left;font-size:11px;font-weight:700}
  td{padding:7px 10px;border-bottom:1px solid #f0f0f0}tr:nth-child(even) td{background:#fafafa}
  .section-title{font-size:13px;font-weight:800;color:#F44D19;text-transform:uppercase;letter-spacing:1px;margin:20px 0 10px;padding-bottom:6px;border-bottom:2px solid #F44D1922}
  .kpi{display:inline-block;padding:10px 18px;border-radius:8px;margin:0 8px 8px 0;text-align:center}
  .kpi-val{font-size:22px;font-weight:900}.kpi-lab{font-size:10px;color:#6c757d;margin-top:2px}
  .footer{margin-top:32px;padding:16px 40px;background:#f8f9fa;border-top:2px solid #F44D1922;display:flex;justify-content:space-between;font-size:11px;color:#6c757d}
  .lema{color:#F44D19;font-weight:700}
  @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}</style></head><body>
  <div class="header"><img src="${LOGO_LUMEN}" alt="Lumen Instituto" style="height:62px;display:block"/>
  <div class="header-title">${titulo}</div><div class="header-sub">Gerado em ${new Date().toLocaleDateString("pt-BR")} · Lumen Instituto</div></div>
  <div class="content">${html}</div>
  <div class="footer"><span class="lema">Movidos pelo Resultado</span><span>lumeninstituto.com.br</span></div>
  <script>window.onload=()=>window.print();</script></body></html>`);
  win.document.close();
}

function gerarRelatorioMensal(visitas, clientes, especialistas, marcos) {
  const realizadas = visitas.filter(v => v.status === "Realizada");
  const horas = realizadas.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const html = `
    <div style="margin-bottom:20px">
      <span class="kpi" style="background:#F44D1922"><div class="kpi-val" style="color:#F44D19">${realizadas.length}</div><div class="kpi-lab">Atendimentos realizados</div></span>
      <span class="kpi" style="background:#0075EA22"><div class="kpi-val" style="color:#0075EA">${horas}h</div><div class="kpi-lab">Horas entregues</div></span>
      <span class="kpi" style="background:#22c55e22"><div class="kpi-val" style="color:#22c55e">${marcos.filter(m => m.status === "Concluído").length}</div><div class="kpi-lab">Marcos concluídos</div></span>
    </div>
    <div class="section-title">Visitas do Período</div>
    <table><thead><tr><th>Data</th><th>Cliente</th><th>Especialista</th><th>Tipo</th><th>Horas</th><th>Status</th></tr></thead><tbody>
    ${realizadas.sort((a,b) => b.data?.localeCompare(a.data)).map(v => `
      <tr><td>${fmtDate(v.data)}</td><td>${clientes.find(c => c.id === v.clienteId)?.nome || "—"}</td>
      <td>${especialistas.find(e => e.id === v.especialistaId)?.nome?.split(" ")[0] || "—"}</td>
      <td>${v.tipo}</td><td>${v.duracao}h</td><td>${v.status}</td></tr>`).join("")}
    </tbody></table>`;
  abrirRelatorio("Relatório Mensal", html);
}

function gerarRelatorioEspecialistas(visitas, especialistas, clientes) {
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const html = `
    <div class="section-title">Performance por Especialista</div>
    <table><thead><tr><th>Especialista</th><th>Visitas</th><th>Horas</th><th>Clientes atendidos</th></tr></thead><tbody>
    ${especialistas.filter(e => e.status === "Ativo").map(e => {
      const vs = visitas.filter(v => v.especialistaId === e.id && v.status === "Realizada");
      const hs = vs.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
      const cls = [...new Set(vs.map(v => v.clienteId))].length;
      return `<tr><td>${e.nome}</td><td>${vs.length}</td><td>${hs}h</td><td>${cls}</td></tr>`;
    }).join("")}
    </tbody></table>
    <div class="section-title">Detalhe das Visitas</div>
    <table><thead><tr><th>Data</th><th>Especialista</th><th>Cliente</th><th>Tipo</th><th>Horas</th></tr></thead><tbody>
    ${visitas.filter(v => v.status === "Realizada").sort((a,b) => b.data?.localeCompare(a.data)).map(v => `
      <tr><td>${fmtDate(v.data)}</td>
      <td>${especialistas.find(e => e.id === v.especialistaId)?.nome || "—"}</td>
      <td>${clientes.find(c => c.id === v.clienteId)?.nome || "—"}</td>
      <td>${v.tipo}</td><td>${v.duracao}h</td></tr>`).join("")}
    </tbody></table>`;
  abrirRelatorio("Performance por Especialista", html);
}

function gerarRelatorioMaturidade(clientes, dmgData) {
  const nivelLabel = (s) => s >= 75 ? "AVANÇADO" : s >= 60 ? "BOM" : s >= 40 ? "REGULAR" : "CRÍTICO";
  const nivelCor = (s) => s >= 75 ? "#22c55e" : s >= 60 ? "#EF8220" : s >= 40 ? "#f59e0b" : "#ef4444";
  const calcMat = (dmg) => { if (!dmg) return 0; const v = Object.entries(dmg).filter(([k,val]) => k !== 'analiseIA' && k !== 'clienteId' && typeof val === 'number').map(([,val]) => val); if (!v.length) return 0; return Math.round(v.reduce((a, b) => a + b, 0) / v.length); };
  const ranking = clientes.filter(c => dmgData[c.id]).map(c => ({ ...c, mat: calcMat(dmgData[c.id]) })).sort((a,b) => b.mat - a.mat);
  const html = `
    <div class="section-title">Ranking de Maturidade da Carteira</div>
    <table><thead><tr><th>#</th><th>Cliente</th><th>Segmento</th><th>Score</th><th>Nível</th><th>Liderança</th><th>Estratégia</th><th>Processos</th></tr></thead><tbody>
    ${ranking.map((c, i) => {
      const d = dmgData[c.id];
      return `<tr><td>${i+1}</td><td>${c.nome}</td><td>${c.segmento}</td>
        <td><b style="color:${nivelCor(c.mat)}">${c.mat}%</b></td>
        <td style="color:${nivelCor(c.mat)};font-weight:700">${nivelLabel(c.mat)}</td>
        <td>${d?.lideranca || 0}%</td><td>${d?.estrategia || 0}%</td><td>${d?.processos || 0}%</td></tr>`;
    }).join("")}
    </tbody></table>`;
  abrirRelatorio("Maturidade da Carteira", html);
}

function gerarRelatorioReceita(clientes) {
  const ativos = clientes.filter(c => c.status !== "Encerrado");
  const total = ativos.reduce((s, c) => s + (Number(c.valor) || 0), 0);
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const html = `
    <div style="margin-bottom:20px">
      <span class="kpi" style="background:#22c55e22"><div class="kpi-val" style="color:#22c55e">${fmtMoeda(total)}</div><div class="kpi-lab">Receita mensal total</div></span>
      <span class="kpi" style="background:#0075EA22"><div class="kpi-val" style="color:#0075EA">${ativos.length}</div><div class="kpi-lab">Contratos ativos</div></span>
    </div>
    <div class="section-title">Contratos Ativos</div>
    <table><thead><tr><th>Cliente</th><th>Segmento</th><th>Status</th><th>Valor/mês</th><th>Horas</th><th>Início</th></tr></thead><tbody>
    ${ativos.sort((a,b) => (Number(b.valor)||0) - (Number(a.valor)||0)).map(c => `
      <tr><td>${c.nome}</td><td>${c.segmento}</td><td>${c.status}</td>
      <td><b>${c.valor ? fmtMoeda(c.valor) : "—"}</b></td>
      <td>${c.horasContratadas || "—"}h</td><td>${fmtDate(c.contrato)}</td></tr>`).join("")}
    </tbody></table>`;
  abrirRelatorio("Receita e Contratos", html);
}

function gerarRelatorioMarcos(clientes, marcos) {
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const corSt = (s) => s === "Concluído" ? "#22c55e" : s === "Atrasado" ? "#ef4444" : s === "Iniciado" ? "#EF8220" : "#0075EA";
  const html = `
    <div style="margin-bottom:20px">
      <span class="kpi" style="background:#0075EA22"><div class="kpi-val" style="color:#0075EA">${marcos.filter(m => m.status === "A Iniciar").length}</div><div class="kpi-lab">A Iniciar</div></span>
      <span class="kpi" style="background:#EF822022"><div class="kpi-val" style="color:#EF8220">${marcos.filter(m => m.status === "Iniciado").length}</div><div class="kpi-lab">Iniciados</div></span>
      <span class="kpi" style="background:#ef444422"><div class="kpi-val" style="color:#ef4444">${marcos.filter(m => m.status === "Atrasado").length}</div><div class="kpi-lab">Atrasados</div></span>
      <span class="kpi" style="background:#22c55e22"><div class="kpi-val" style="color:#22c55e">${marcos.filter(m => m.status === "Concluído").length}</div><div class="kpi-lab">Concluídos</div></span>
    </div>
    <div class="section-title">Marcos por Projeto</div>
    <table><thead><tr><th>Marco</th><th>Projeto</th><th>Prazo</th><th>Prioridade</th><th>Status</th></tr></thead><tbody>
    ${[...marcos].sort((a,b) => (a.prazo||"9").localeCompare(b.prazo||"9")).map(m => `
      <tr><td>${m.titulo}</td>
      <td>${m.clienteNomeVal || clientes.find(c => c.id === m.clienteId)?.nome || "—"}</td>
      <td>${fmtDate(m.prazo)}</td><td>${m.prioridade || "Média"}</td>
      <td style="color:${corSt(m.status)};font-weight:700">${m.status || "A Iniciar"}</td></tr>`).join("")}
    </tbody></table>`;
  abrirRelatorio("Marcos por Período", html);
}

function gerarRelatorioPipeline(clientes) {
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const hoje = new Date();
  const com12meses = clientes.filter(c => c.contrato).map(c => {
    const inicio = new Date(c.contrato + "T12:00:00");
    const renovacao = new Date(inicio);
    renovacao.setFullYear(renovacao.getFullYear() + 1);
    const diasRest = Math.ceil((renovacao - hoje) / (1000 * 60 * 60 * 24));
    return { ...c, renovacao, diasRest };
  }).sort((a,b) => a.diasRest - b.diasRest);
  const html = `
    <div class="section-title">Pipeline de Renovações</div>
    <table><thead><tr><th>Cliente</th><th>Status</th><th>Valor/mês</th><th>Início contrato</th><th>Renovação estimada</th><th>Dias restantes</th></tr></thead><tbody>
    ${com12meses.map(c => {
      const cor = c.diasRest < 30 ? "#ef4444" : c.diasRest < 90 ? "#f59e0b" : "#22c55e";
      return `<tr><td>${c.nome}</td><td>${c.status}</td>
        <td>${c.valor ? fmtMoeda(c.valor) : "—"}</td>
        <td>${fmtDate(c.contrato)}</td>
        <td>${fmtDate(c.renovacao.toISOString().split("T")[0])}</td>
        <td style="color:${cor};font-weight:700">${c.diasRest > 0 ? `${c.diasRest} dias` : "Vencido"}</td></tr>`;
    }).join("")}
    </tbody></table>`;
  abrirRelatorio("Pipeline de Renovações", html);
}

function gerarRelatorioConsultores(consultores, visitas, clientes) {
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const html = `
    <div class="section-title">Fechamento de Consultores</div>
    ${(consultores || []).filter(c => c.status === "Ativo").map(c => {
      const visitasC = visitas.filter(v => v.consultorId === c.id && v.status === "Realizada");
      const totalHoras = visitasC.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
      const totalAtend = c.valorHoraAtendimento * totalHoras;
      const totalHDesloc = visitasC.reduce((s, v) => {
        return s + (v.horarios || []).filter(h => h.deslocamento).reduce((a, h) => {
          if (!h.inicio || !h.fim) return a;
          const [ih,im] = h.inicio.split(":").map(Number);
          const [fh,fm] = h.fim.split(":").map(Number);
          const mins = (fh*60+fm)-(ih*60+im);
          return a + (mins > 60 ? mins/60 : 0);
        }, 0);
      }, 0);
      const totalDesloc = c.valorHoraDeslocamento * totalHDesloc;
      const totalDespesas = visitasC.reduce((s, v) => s + (v.despesaViagem || []).reduce((a, d) => a + (Number(d.valor) || 0), 0), 0);
      const totalPagar = totalAtend + totalDesloc + totalDespesas;
      if (visitasC.length === 0) return "";
      return `
        <div style="margin-bottom:24px;padding:16px;border:1px solid #eee;border-radius:8px">
          <h3 style="color:#F44D19;margin-bottom:12px">${c.nome} — ${c.especialidade || ""}</h3>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:14px">
            <div class="kpi" style="background:#0075EA22"><div class="kpi-val" style="color:#0075EA">${visitasC.length}</div><div class="kpi-lab">Atendimentos</div></div>
            <div class="kpi" style="background:#EF822022"><div class="kpi-val" style="color:#EF8220">${totalHoras}h</div><div class="kpi-lab">Horas atendimento</div></div>
            <div class="kpi" style="background:#f59e0b22"><div class="kpi-val" style="color:#f59e0b">${Math.round(totalHDesloc*10)/10}h</div><div class="kpi-lab">Horas deslocamento</div></div>
            <div class="kpi" style="background:#22c55e22"><div class="kpi-val" style="color:#22c55e">R$ ${totalPagar.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div><div class="kpi-lab">Total a pagar</div></div>
          </div>
          <table style="width:100%;border-collapse:collapse;font-size:11px;margin-bottom:10px">
            <tr style="background:#f8f9fa"><td style="padding:6px;border:1px solid #eee">Atendimentos (${totalHoras}h × R$ ${c.valorHoraAtendimento}/h)</td><td style="padding:6px;border:1px solid #eee;text-align:right"><b>R$ ${totalAtend.toLocaleString("pt-BR",{minimumFractionDigits:2})}</b></td></tr>
            ${totalDesloc > 0 ? `<tr><td style="padding:6px;border:1px solid #eee">Deslocamento (${Math.round(totalHDesloc*10)/10}h × R$ ${c.valorHoraDeslocamento}/h)</td><td style="padding:6px;border:1px solid #eee;text-align:right"><b>R$ ${totalDesloc.toLocaleString("pt-BR",{minimumFractionDigits:2})}</b></td></tr>` : ""}
            ${totalDespesas > 0 ? `<tr><td style="padding:6px;border:1px solid #eee">Despesas de viagem</td><td style="padding:6px;border:1px solid #eee;text-align:right"><b>R$ ${totalDespesas.toLocaleString("pt-BR",{minimumFractionDigits:2})}</b></td></tr>` : ""}
          </table>
          <table style="width:100%;border-collapse:collapse;font-size:11px">
            <thead><tr><th style="background:#F44D19;color:white;padding:6px;text-align:left">Data</th><th style="background:#F44D19;color:white;padding:6px;text-align:left">Cliente</th><th style="background:#F44D19;color:white;padding:6px;text-align:left">Tipo</th><th style="background:#F44D19;color:white;padding:6px;text-align:left">Horas</th><th style="background:#F44D19;color:white;padding:6px;text-align:left">Despesas</th></tr></thead>
            <tbody>${visitasC.sort((a,b) => a.data?.localeCompare(b.data)).map(v => {
              const cli = clientes.find(c2 => c2.id === v.clienteId);
              const desp = (v.despesaViagem || []).reduce((s, d) => s + (Number(d.valor) || 0), 0);
              return `<tr><td style="padding:5px;border-bottom:1px solid #f0f0f0">${fmtDate(v.data)}</td><td style="padding:5px;border-bottom:1px solid #f0f0f0">${cli?.nome || "—"}</td><td style="padding:5px;border-bottom:1px solid #f0f0f0">${v.tipo}</td><td style="padding:5px;border-bottom:1px solid #f0f0f0">${v.duracao}h</td><td style="padding:5px;border-bottom:1px solid #f0f0f0">${desp > 0 ? "R$ " + desp.toLocaleString("pt-BR",{minimumFractionDigits:2}) : "—"}</td></tr>`;
            }).join("")}</tbody>
          </table>
        </div>`;
    }).join("")}`;
  abrirRelatorio("Fechamento de Consultores", html);
}

// ─── GERAR PDF DMG ────────────────────────────────────────────────────────────
function gerarPDFDmg(cliente, scores, analise, scoreGeral) {
  const nivelLabel = (s) => s >= 75 ? "AVANÇADO" : s >= 60 ? "BOM" : s >= 40 ? "REGULAR" : "CRÍTICO";
  const nivelCor = (s) => s >= 75 ? "#22c55e" : s >= 60 ? "#EF8220" : s >= 40 ? "#f59e0b" : "#ef4444";

  // Gera SVG do radar
  const gerarRadarSVG = (scores) => {
    const cx = 240, cy = 240, r = 150;
    const n = scores.length;
    const angulo = (i) => (Math.PI * 2 * i / n) - Math.PI / 2;
    const ponto = (i, val) => {
      const a = angulo(i);
      const dist = (val / 100) * r;
      return { x: cx + dist * Math.cos(a), y: cy + dist * Math.sin(a) };
    };
    const pontoLabel = (i) => {
      const a = angulo(i);
      return { x: cx + (r + 36) * Math.cos(a), y: cy + (r + 36) * Math.sin(a) };
    };

    const gradeLinhas = [25, 50, 75, 100].map(pct => {
      const pts = scores.map((_, i) => {
        const a = angulo(i);
        const d = (pct / 100) * r;
        return `${cx + d * Math.cos(a)},${cy + d * Math.sin(a)}`;
      }).join(" ");
      return `<polygon points="${pts}" fill="none" stroke="#ccc" stroke-width="1"/>`;
    }).join("");

    const eixos = scores.map((_, i) => {
      const a = angulo(i);
      return `<line x1="${cx}" y1="${cy}" x2="${cx + r * Math.cos(a)}" y2="${cy + r * Math.sin(a)}" stroke="#ccc" stroke-width="1"/>`;
    }).join("");

    const pts = scores.map((s, i) => { const p = ponto(i, s.score); return `${p.x},${p.y}`; }).join(" ");
    const poligono = `<polygon points="${pts}" fill="#F44D1933" stroke="#F44D19" stroke-width="2.5"/>`;

    const labels = scores.map((s, i) => {
      const p = pontoLabel(i);
      const label = (DMG_PERGUNTAS[s.pilar]?.label || s.pilar).replace("Informação e Conhecimento", "Info. e Conhec.");
      const cor = nivelCor(s.score);
      const anchor = p.x < cx - 10 ? "end" : p.x > cx + 10 ? "start" : "middle";
      return `
        <text x="${p.x}" y="${p.y - 5}" text-anchor="${anchor}" font-size="11" font-weight="700" fill="#333" font-family="Arial">${label}</text>
        <text x="${p.x}" y="${p.y + 11}" text-anchor="${anchor}" font-size="12" font-weight="900" fill="${cor}" font-family="Arial">${s.score}%</text>`;
    }).join("");

    const pontos = scores.map((s, i) => {
      const p = ponto(i, s.score);
      return `<circle cx="${p.x}" cy="${p.y}" r="5" fill="${nivelCor(s.score)}" stroke="#fff" stroke-width="2"/>`;
    }).join("");

    return `<svg xmlns="http://www.w3.org/2000/svg" width="440" height="440" viewBox="0 0 480 480" style="display:block">
      ${gradeLinhas}${eixos}${poligono}${pontos}${labels}
    </svg>`;
  };

  const radarSVG = gerarRadarSVG(scores);

  const html = `<!DOCTYPE html>
<html lang="pt-BR"><head><meta charset="UTF-8">
<title>DMG — ${cliente?.nome}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Segoe UI',Arial,sans-serif;color:#212121;background:#fff}
.header{background:linear-gradient(135deg,#F44D19,#EF8220);padding:24px 40px;color:white;display:flex;align-items:center;gap:24px}
.header-info{flex:1}
.header-title{font-size:20px;font-weight:700;margin-bottom:3px}
.header-sub{font-size:12px;opacity:.9}
.content{padding:32px 40px}
.radar-section{display:flex;align-items:center;justify-content:center;gap:40px;margin-bottom:28px;background:#f8f9fa;border-radius:12px;padding:24px 32px;border:2px solid #F44D1922}
.score-box{text-align:center;min-width:160px;flex-shrink:0}
.score-num{font-size:64px;font-weight:900;line-height:1}
.score-label{font-size:13px;color:#6c757d;margin-top:4px}
.nivel-badge{display:inline-block;padding:4px 16px;border-radius:20px;font-size:13px;font-weight:700;margin-top:8px}
.pilares{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:28px}
.pilar{background:#f8f9fa;border-radius:8px;padding:12px 14px;display:flex;align-items:center;gap:10px}
.pilar-bar-wrap{flex:1;height:6px;background:#e9ecef;border-radius:3px;margin-top:4px}
.pilar-bar{height:100%;border-radius:3px}
.pilar-score{font-size:14px;font-weight:900;min-width:40px;text-align:right}
.section{margin-bottom:24px}
.section-title{font-size:13px;font-weight:800;color:#F44D19;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;padding-bottom:6px;border-bottom:2px solid #F44D1922}
.section-text{font-size:13px;line-height:1.8;color:#333;white-space:pre-wrap}
.footer{margin-top:40px;padding:18px 40px;background:#f8f9fa;border-top:2px solid #F44D1922;display:flex;justify-content:space-between;align-items:center}
.footer-lema{font-size:12px;color:#F44D19;font-weight:700}
.footer-info{font-size:11px;color:#6c757d}
@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}
</style></head><body>
<div class="header">
  <img src="${LOGO_LUMEN}" alt="Lumen Instituto" style="height:62px;display:block;flex-shrink:0"/>
  <div class="header-info">
    <div class="header-title">Diagnóstico de Maturidade da Gestão</div>
    <div class="header-sub">${cliente?.nome} · ${cliente?.segmento} · ${new Date().toLocaleDateString("pt-BR")}</div>
  </div>
</div>
<div class="content">
  <!-- Radar + Score lado a lado -->
  <div class="radar-section">
    <div>${radarSVG}</div>
    <div class="score-box">
      <div class="score-num" style="color:${nivelCor(scoreGeral)}">${scoreGeral}%</div>
      <div class="score-label">Score Geral de Maturidade</div>
      <div class="nivel-badge" style="background:${nivelCor(scoreGeral)}22;color:${nivelCor(scoreGeral)}">${nivelLabel(scoreGeral)}</div>
    </div>
  </div>

  <!-- Barras dos pilares -->
  <div class="pilares">
    ${scores.map(s => `
      <div class="pilar">
        <span style="font-size:18px">${DMG_PERGUNTAS[s.pilar]?.icon || "📊"}</span>
        <div style="flex:1">
          <div style="font-size:12px;font-weight:700">${DMG_PERGUNTAS[s.pilar]?.label || s.pilar}</div>
          <div class="pilar-bar-wrap"><div class="pilar-bar" style="width:${s.score}%;background:${nivelCor(s.score)}"></div></div>
        </div>
        <div class="pilar-score" style="color:${nivelCor(s.score)}">${s.score}%</div>
      </div>`).join("")}
  </div>

  ${analise ? `
  <div class="section">
    <div class="section-title">🎯 Maturidade de Gestão Identificada</div>
    <div class="section-text">${analise.maturidade}</div>
  </div>
  <div class="section">
    <div class="section-title">✅ Pontos Positivos</div>
    <div class="section-text">${analise.positivos}</div>
  </div>
  <div class="section">
    <div class="section-title">🔧 Pontos de Melhoria</div>
    <div class="section-text">${analise.melhoria}</div>
  </div>
  <div class="section">
    <div class="section-title">🚀 Ponto Focal para Melhoria</div>
    <div class="section-text">${analise.focal}</div>
  </div>` : ""}
</div>
<div class="footer">
  <div class="footer-lema">Movidos pelo Resultado</div>
  <div class="footer-info">Lumen Instituto · Gerado em ${new Date().toLocaleDateString("pt-BR")}</div>
</div>
<script>window.onload=()=>window.print();</script>
</body></html>`;
  const win = window.open("", "_blank");
  if (win) { win.document.write(html); win.document.close(); }
}

// ─── PORTAL DO CLIENTE ────────────────────────────────────────────────────────
// ─── PORTAL DO CONSULTOR ─────────────────────────────────────────────────────
function PortalConsultor({ consultor, visitas, todasVisitasClientes, clientes, tarefas, especialistas, consultores, usuarioLogado, onLogout, showToast, onSaveVisita, onSaveTarefa, onDeleteVisita, setVisitas }) {
  const [aba, setAba] = useState("dashboard");
  const [clienteFiltroId, setClienteFiltroId] = useState(null);
  const [modalPC, setModalPC] = useState(null); // { type: "visita"|"tarefa", data: {} }
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";

  const handleSaveVisita = async (data) => {
    // Garante que o consultor fica vinculado
    const payload = { ...data, consultorId: usuarioLogado?.id };
    await onSaveVisita(payload);
    // Fecha modal e atualiza lista local
    setModalPC(null);
  };

  const handleSaveTarefa = async (data) => {
    await onSaveTarefa(data);
    setModalPC(null);
  };
  const hoje = new Date().toISOString().split("T")[0];

  const visitasRealizadas = visitas.filter(v => v.status === "Realizada");
  const totalHoras = visitasRealizadas.reduce((s, v) => s + (Number(v.duracao) || 0), 0);
  const totalAtend = (consultor?.valorHoraAtendimento || 0) * totalHoras;

  // Horas deslocamento remunerado (>1h)
  const totalHDesloc = visitasRealizadas.reduce((s, v) => {
    return s + (v.horarios || []).filter(h => h.deslocamento).reduce((a, h) => {
      if (!h.inicio || !h.fim) return a;
      const [ih, im] = h.inicio.split(":").map(Number);
      const [fh, fm] = h.fim.split(":").map(Number);
      const mins = (fh * 60 + fm) - (ih * 60 + im);
      return a + (mins > 60 ? mins / 60 : 0);
    }, 0);
  }, 0);
  const totalDesloc = (consultor?.valorHoraDeslocamento || 0) * totalHDesloc;
  const totalDespesas = visitasRealizadas.reduce((s, v) => s + (v.despesaViagem || []).reduce((a, d) => a + (Number(d.valor) || 0), 0), 0);
  const totalReceber = totalAtend + totalDesloc + totalDespesas;

  const nomeConsultor = consultor?.nome || usuarioLogado?.nome || "";
  const iniciais = nomeConsultor.split(" ").slice(0,2).map(n => n[0]).join("").toUpperCase();

  return (
    <div style={{ minHeight: "100vh", background: "#0f1623", display: "flex", flexDirection: "column", fontFamily: "'Segoe UI',system-ui,sans-serif" }}>
      <style>{`
        .pc-card { background: #1a2235; border: 1px solid #ffffff10; border-radius: 16px; }
        .pc-card-hover:hover { border-color: ${T.laranja}44; transform: translateY(-1px); transition: all .2s; }
        .pc-aba-btn { padding: 14px 20px; background: none; border: none; border-bottom: 2px solid transparent; font-size: 13px; font-weight: 500; cursor: pointer; transition: all .15s; color: #6b7a99; }
        .pc-aba-btn:hover { color: #c0c8e0; }
        .pc-aba-ativa { border-bottom-color: ${T.laranja} !important; color: ${T.laranja} !important; font-weight: 700 !important; }
      `}</style>

      {/* ── HEADER ── */}
      <div style={{ background: "linear-gradient(135deg, #12273d 0%, #1a3050 100%)", borderBottom: "1px solid #ffffff0d", padding: "16px 32px", display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, borderRadius: 12, padding: "8px 16px", flexShrink: 0 }}>
          <img src={LOGO_LUMEN} alt="Lumen" style={{ height: 32, display: "block" }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#ffffff", letterSpacing: "-0.3px" }}>{nomeConsultor}</div>
          <div style={{ fontSize: 11, color: "#6b7a99", marginTop: 2 }}>Portal do Consultor · {consultor?.especialidade || ""}</div>
        </div>
        <div style={{ width: 38, height: 38, borderRadius: "50%", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 14, color: "#fff", marginRight: 8 }}>{iniciais}</div>
        <button onClick={onLogout} style={{ padding: "8px 18px", borderRadius: 8, background: "#ffffff08", border: "1px solid #ffffff14", color: "#8899bb", fontSize: 12, cursor: "pointer", transition: "all .15s" }}>Sair →</button>
      </div>

      {/* ── ABAS ── */}
      <div style={{ background: "#151e2e", borderBottom: "1px solid #ffffff0a", padding: "0 32px", display: "flex", gap: 0, alignItems: "center" }}>
        <div style={{ display: "flex", flex: 1 }}>
          {[
            { id: "dashboard", label: "Dashboard", icon: "◈" },
            { id: "atendimentos", label: "Meus Atendimentos", icon: "◎" },
            { id: "historico", label: "Histórico dos Clientes", icon: "◐" },
            { id: "projetos", label: "Projetos", icon: "◉" },
          ].map(a => (
            <button key={a.id} onClick={() => setAba(a.id)} className={`pc-aba-btn${aba === a.id ? " pc-aba-ativa" : ""}`}>
              <span style={{ marginRight: 6, opacity: 0.7 }}>{a.icon}</span>{a.label}
            </button>
          ))}
        </div>
        {/* Botão de ação contextual */}
        <div style={{ padding: "0 0 0 16px" }}>
          {(aba === "atendimentos" || aba === "dashboard") && (
            <button onClick={() => setModalPC({ type: "visita", data: { consultorId: usuarioLogado?.id, data: new Date().toISOString().split("T")[0], status: "Agendada" } })}
              style={{ padding: "7px 16px", borderRadius: 8, background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              + Nova Visita
            </button>
          )}
          {aba === "historico" && (
            <button onClick={() => setModalPC({ type: "visita", data: { consultorId: usuarioLogado?.id, data: new Date().toISOString().split("T")[0], status: "Agendada", clienteId: clienteFiltroId || "" } })}
              style={{ padding: "7px 16px", borderRadius: 8, background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              + Agendar Visita
            </button>
          )}
        </div>
      </div>

      {/* ── CONTEÚDO ── */}
      <div style={{ padding: "28px 32px", maxWidth: 1080, margin: "0 auto", width: "100%" }}>

        {/* DASHBOARD */}
        {aba === "dashboard" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

            {/* Saudação */}
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#dce4f5", letterSpacing: "-0.5px" }}>
                  Olá, {nomeConsultor.split(" ")[0]}! 👋
                </div>
                <div style={{ fontSize: 12, color: "#6b7a99", marginTop: 2 }}>Aqui está um resumo da sua atuação</div>
              </div>
            </div>

            {/* KPI Cards */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14 }}>
              {[
                { label: "Atendimentos realizados", val: visitasRealizadas.length, icon: "◎", cor: T.azul, bg: `${T.azul}18` },
                { label: "Horas trabalhadas", val: `${totalHoras}h`, icon: "⏱", cor: T.laranjaM, bg: `${T.laranjaM}18` },
                { label: "Horas deslocamento", val: `${Math.round(totalHDesloc * 10) / 10}h`, icon: "🚗", cor: "#a78bfa", bg: "#a78bfa18" },
                { label: "Total a receber", val: fmtMoeda(totalReceber), icon: "💰", cor: T.success, bg: `${T.success}18` },
              ].map((k, i) => (
                <div key={i} style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: "20px 22px", position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", top: 14, right: 16, fontSize: 22, opacity: 0.15 }}>{k.icon}</div>
                  <div style={{ fontSize: 26, fontWeight: 900, color: k.cor, letterSpacing: "-1px", marginBottom: 6 }}>{k.val}</div>
                  <div style={{ fontSize: 11, color: "#6b7a99", fontWeight: 500 }}>{k.label}</div>
                  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: k.cor, opacity: 0.4, borderRadius: "0 0 16px 16px" }} />
                </div>
              ))}
            </div>

            {/* Layout 2 colunas */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>

              {/* Detalhamento financeiro */}
              <div style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: 24 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#dce4f5", marginBottom: 18, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ width: 28, height: 28, borderRadius: 8, background: `${T.success}20`, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>💰</span>
                  Detalhamento financeiro
                </div>
                {[
                  { label: "Horas de atendimento", sub: `${totalHoras}h × ${fmtMoeda(consultor?.valorHoraAtendimento || 0)}/h`, total: totalAtend },
                  { label: "Deslocamento remunerado", sub: `${Math.round(totalHDesloc * 10) / 10}h × ${fmtMoeda(consultor?.valorHoraDeslocamento || 0)}/h`, total: totalDesloc },
                  { label: "Despesas de viagem", sub: "", total: totalDespesas },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #ffffff08" }}>
                    <div>
                      <div style={{ fontSize: 12, color: "#c0c8e0" }}>{item.label}</div>
                      {item.sub && <div style={{ fontSize: 10, color: "#6b7a99", marginTop: 2 }}>{item.sub}</div>}
                    </div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: T.laranjaM }}>{fmtMoeda(item.total)}</div>
                  </div>
                ))}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 14, marginTop: 6 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#dce4f5" }}>Total</div>
                  <div style={{ fontSize: 20, fontWeight: 900, color: T.success }}>{fmtMoeda(totalReceber)}</div>
                </div>
              </div>

              {/* Próximos atendimentos */}
              <div style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: 24 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#dce4f5", marginBottom: 18, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ width: 28, height: 28, borderRadius: 8, background: `${T.azul}20`, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>📅</span>
                  Próximos atendimentos
                </div>
                {visitas.filter(v => v.data >= hoje && v.status !== "Cancelada").length === 0 ? (
                  <div style={{ textAlign: "center", padding: "24px 0", color: "#4a5568" }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>✅</div>
                    <div style={{ fontSize: 12 }}>Nenhum agendamento pendente</div>
                  </div>
                ) : visitas.filter(v => v.data >= hoje && v.status !== "Cancelada").slice(0, 5).map((v, i) => {
                  const cli = clientes.find(c => c.id === v.clienteId);
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #ffffff06" }}>
                      <div style={{ width: 40, height: 40, borderRadius: 10, background: `linear-gradient(135deg,${T.azul}33,${T.azul}11)`, border: `1px solid ${T.azul}33`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <div style={{ fontSize: 9, color: T.azul, fontWeight: 700, lineHeight: 1 }}>{fmtDate(v.data).slice(3,5)}</div>
                        <div style={{ fontSize: 13, color: T.azul, fontWeight: 900, lineHeight: 1 }}>{fmtDate(v.data).slice(0,2)}</div>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#dce4f5", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{cli?.nome || "—"}</div>
                        <div style={{ fontSize: 10, color: "#6b7a99", marginTop: 1 }}>{v.tipo} · {v.duracao}h</div>
                      </div>
                      <Badge label={v.status} color={statusColor(v.status)} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* ATENDIMENTOS */}
        {aba === "atendimentos" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#dce4f5", marginBottom: 4 }}>Meus Atendimentos</div>
            {visitas.length === 0 ? (
              <div style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: "40px 24px", textAlign: "center", color: "#4a5568" }}>
                <div style={{ fontSize: 32, marginBottom: 10 }}>◎</div>
                <div style={{ fontSize: 13 }}>Nenhum atendimento registrado.</div>
              </div>
            ) : [...visitas].sort((a, b) => b.data?.localeCompare(a.data)).map((v, i) => {
              const cli = clientes.find(c => c.id === v.clienteId);
              const despTotal = (v.despesaViagem || []).reduce((s, d) => s + (Number(d.valor) || 0), 0);
              return (
                <div key={i} style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 14, padding: "16px 20px", borderLeft: `4px solid ${statusColor(v.status)}`, transition: "all .2s" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: "#dce4f5" }}>{cli?.nome || "—"}</div>
                      <div style={{ fontSize: 11, color: "#6b7a99", marginTop: 3 }}>{fmtDate(v.data)} · {v.tipo} · {v.duracao}h</div>
                    </div>
                    <Badge label={v.status} color={statusColor(v.status)} />
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                    {despTotal > 0 ? (
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 4, background: `${T.laranjaM}15`, border: `1px solid ${T.laranjaM}30`, borderRadius: 6, padding: "3px 10px", fontSize: 11, color: T.laranjaM, fontWeight: 600 }}>
                        🧾 Despesas: {fmtMoeda(despTotal)}
                      </div>
                    ) : <div />}
                    <div style={{ display: "flex", gap: 8 }}>
                      <button onClick={() => setModalPC({ type: "tarefa", data: { clienteId: v.clienteId, visitaId: v.id } })}
                        style={{ padding: "4px 12px", borderRadius: 6, background: `${T.azul}20`, border: `1px solid ${T.azul}33`, color: T.azul, fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                        + Ação
                      </button>
                      <button onClick={() => setModalPC({ type: "visita", data: v })}
                        style={{ padding: "4px 12px", borderRadius: 6, background: `${T.laranja}18`, border: `1px solid ${T.laranja}33`, color: T.laranja, fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
                        ✏️ Editar
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* HISTÓRICO DOS CLIENTES */}
        {aba === "historico" && (() => {
          const projetosComVisita = clientes.filter(c =>
            (todasVisitasClientes || []).some(v => v.clienteId === c.id && v.consultorId === usuarioLogado?.id)
          );
          const projetoSelecionado = clienteFiltroId
            ? projetosComVisita.filter(c => c.id === clienteFiltroId)
            : projetosComVisita;

          if (projetosComVisita.length === 0) return (
            <div style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: "48px 24px", textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 12 }}>📂</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#dce4f5", marginBottom: 6 }}>Nenhum projeto com visita registrada</div>
              <div style={{ fontSize: 12, color: "#6b7a99" }}>Quando você for vinculado a uma visita como consultor, o histórico aparecerá aqui.</div>
            </div>
          );
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

              {/* Filtro por empresa */}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                <span style={{ fontSize: 11, color: "#6b7a99", fontWeight: 600, marginRight: 4 }}>Filtrar empresa:</span>
                <button
                  onClick={() => setClienteFiltroId(null)}
                  style={{
                    padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "none", transition: "all .15s",
                    background: !clienteFiltroId ? T.laranja : "#1a2235",
                    color: !clienteFiltroId ? "#fff" : "#6b7a99",
                    outline: !clienteFiltroId ? "none" : "1px solid #ffffff10",
                  }}>
                  Todas ({projetosComVisita.length})
                </button>
                {projetosComVisita.map(c => (
                  <button
                    key={c.id}
                    onClick={() => setClienteFiltroId(c.id === clienteFiltroId ? null : c.id)}
                    style={{
                      padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "none", transition: "all .15s",
                      background: clienteFiltroId === c.id ? T.laranja : "#1a2235",
                      color: clienteFiltroId === c.id ? "#fff" : "#a0aec0",
                      outline: clienteFiltroId === c.id ? "none" : "1px solid #ffffff10",
                    }}>
                    {c.nome}
                  </button>
                ))}
              </div>

              {/* Cards por empresa */}
              {projetoSelecionado.map(cliente => {
                const esp = especialistas.find(e => e.id === cliente.especialistaId);
                const todasVisitasProjeto = [...(todasVisitasClientes || [])]
                  .filter(v => v.clienteId === cliente.id)
                  .sort((a, b) => b.data?.localeCompare(a.data));
                const ultimas5 = todasVisitasProjeto.slice(0, 5);
                const totalVisitas = todasVisitasProjeto.length;
                const ultimaData = todasVisitasProjeto[0]?.data;
                return (
                  <div key={cliente.id} style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, overflow: "hidden" }}>
                    {/* Header do projeto */}
                    <div style={{ padding: "18px 24px", borderBottom: "1px solid #ffffff08", background: `linear-gradient(135deg, ${T.laranja}0d, transparent)`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: "#dce4f5", letterSpacing: "-0.3px" }}>{cliente.nome}</div>
                        <div style={{ fontSize: 11, color: "#6b7a99", marginTop: 3 }}>
                          {cliente.segmento || ""}{cliente.cidade ? ` · ${cliente.cidade}` : ""}{esp ? ` · Especialista: ${esp.nome.split(" ")[0]}` : ""}
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: 10, color: "#6b7a99", textTransform: "uppercase", letterSpacing: "0.5px" }}>Total visitas</div>
                          <div style={{ fontSize: 20, fontWeight: 900, color: T.laranja }}>{totalVisitas}</div>
                        </div>
                        {ultimaData && (
                          <div style={{ textAlign: "right" }}>
                            <div style={{ fontSize: 10, color: "#6b7a99", textTransform: "uppercase", letterSpacing: "0.5px" }}>Última visita</div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: "#dce4f5" }}>{new Date(ultimaData + "T12:00:00").toLocaleDateString("pt-BR")}</div>
                          </div>
                        )}
                        <Badge label={cliente.status} color={statusColor(cliente.status)} />
                      </div>
                    </div>

                    {/* Últimas 5 visitas */}
                    <div style={{ padding: "14px 24px", display: "flex", flexDirection: "column", gap: 10 }}>
                      {totalVisitas > 5 && (
                        <div style={{ fontSize: 10, color: "#6b7a99", textAlign: "right", marginBottom: 2 }}>
                          Exibindo as 5 mais recentes de {totalVisitas} visitas
                        </div>
                      )}
                      {ultimas5.map((v, i) => {
                        const respEsp = especialistas.find(e => e.id === v.especialistaId);
                        const foiEu = v.consultorId === usuarioLogado?.id;
                        return (
                          <div key={i} style={{
                            borderRadius: 12,
                            border: `1px solid ${foiEu ? T.laranja + "33" : "#ffffff08"}`,
                            borderLeft: `4px solid ${foiEu ? T.laranja : statusColor(v.status)}`,
                            background: foiEu ? `${T.laranja}0a` : "#12192a",
                            padding: "14px 16px",
                          }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                              <div style={{ flex: 1 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 6 }}>
                                  <span style={{ fontSize: 12, fontWeight: 700, color: "#dce4f5" }}>{new Date(v.data + "T12:00:00").toLocaleDateString("pt-BR")}</span>
                                  {v.tipo && <Badge label={v.tipo} color={T.azul} />}
                                  {v.tipoAgenda && <Badge label={v.tipoAgenda} color={v.tipoAgenda === "Estratégia" ? T.laranja : "#6b7a99"} />}
                                  {foiEu && <span style={{ fontSize: 9, fontWeight: 700, color: T.laranja, background: `${T.laranja}18`, border: `1px solid ${T.laranja}33`, borderRadius: 4, padding: "2px 6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Você esteve aqui</span>}
                                </div>
                                <div style={{ fontSize: 11, color: "#6b7a99", marginBottom: v.descricao || v.ata || (v.itensPauta||[]).length > 0 ? 8 : 0 }}>
                                  {respEsp ? `👤 ${respEsp.nome.split(" ")[0]}` : ""}{v.duracao ? ` · ${v.duracao}h` : ""}
                                </div>
                                {v.descricao && <div style={{ fontSize: 12, color: "#a0aec0", lineHeight: 1.6, fontStyle: "italic", marginBottom: v.itensPauta?.length || v.ata ? 8 : 0 }}>{v.descricao}</div>}
                                {(v.itensPauta || []).length > 0 && (
                                  <div style={{ marginBottom: v.ata ? 8 : 0 }}>
                                    <div style={{ fontSize: 10, color: "#6b7a99", fontWeight: 700, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.4px" }}>Pauta</div>
                                    {v.itensPauta.map((item, j) => (
                                      <div key={j} style={{ fontSize: 11, color: "#c0c8e0", padding: "2px 0", display: "flex", gap: 6 }}>
                                        <span style={{ color: T.laranja, flexShrink: 0 }}>›</span>
                                        <span>{item.titulo}{item.stakeholder ? ` — ${item.stakeholder}` : ""}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {v.ata && (
                                  <div style={{ background: `${T.azul}0d`, border: `1px solid ${T.azul}1a`, borderRadius: 8, padding: "10px 12px" }}>
                                    <div style={{ fontSize: 9, color: T.azul, fontWeight: 700, marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.5px" }}>ATA / Encaminhamentos</div>
                                    <div style={{ fontSize: 11, color: "#c0c8e0", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>{v.ata}</div>
                                  </div>
                                )}
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-end", flexShrink: 0 }}>
                                <Badge label={v.status} color={statusColor(v.status)} />
                                {foiEu && (
                                  <button onClick={() => setModalPC({ type: "visita", data: v })}
                                    style={{ padding: "3px 10px", borderRadius: 6, background: `${T.laranja}18`, border: `1px solid ${T.laranja}33`, color: T.laranja, fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
                                    ✏️ Editar
                                  </button>
                                )}
                                <button onClick={() => setModalPC({ type: "tarefa", data: { clienteId: v.clienteId, visitaId: v.id } })}
                                  style={{ padding: "3px 10px", borderRadius: 6, background: `${T.azul}18`, border: `1px solid ${T.azul}33`, color: T.azul, fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
                                  + Ação
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })()}

                {/* PROJETOS */}
        {aba === "projetos" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {clientes.length === 0 ? <div style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 14, padding: 22, color: "#6b7a99" }}>Nenhum projeto vinculado.</div> : clientes.map(c => {
              const minhasVisitasCliente = visitas.filter(v => v.clienteId === c.id);
              const esp = especialistas.find(e => e.id === c.especialistaId);
              return (
                <div key={c.id} style={{ background: "#1a2235", border: "1px solid #ffffff0d", borderRadius: 16, padding: 22, borderLeft: `4px solid ${statusColor(c.status)}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                    <div>
                      <div style={{ fontSize: 15, fontWeight: 800, color: "#dce4f5" }}>{c.nome}</div>
                      <div style={{ fontSize: 11, color: "#6b7a99" }}>{c.segmento} · {c.cidade}</div>
                    </div>
                    <Badge label={c.status} color={statusColor(c.status)} />
                  </div>
                  {esp && <div style={{ fontSize: 11, color: T.muted, marginBottom: 10 }}>👤 Especialista: {esp.nome}</div>}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                    {[
                      { label: "Atendimentos", val: minhasVisitasCliente.length },
                      { label: "Realizados", val: minhasVisitasCliente.filter(v => v.status === "Realizada").length },
                      { label: "Marcos", val: (c.marcosDoProjetoIds || []).length },
                    ].map((k, i) => (
                      <div key={i} style={{ background: T.cardL, borderRadius: 8, padding: "10px 12px", textAlign: "center" }}>
                        <div style={{ fontSize: 16, fontWeight: 800, color: T.laranja }}>{k.val}</div>
                        <div style={{ fontSize: 10, color: T.muted }}>{k.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ── MODAIS DO PORTAL CONSULTOR ── */}
      {modalPC?.type === "visita" && (
        <ModalWrap
          title={modalPC.data?.id ? "Editar Atendimento" : "Novo Agendamento"}
          onClose={() => setModalPC(null)}
          maxWidth={680}
        >
          <FormVisita
            data={modalPC.data}
            clientes={clientes}
            especialistas={especialistas}
            consultores={consultores || []}
            isAdmin={false}
            usuarioLogado={usuarioLogado}
            onDelete={modalPC.data?.id ? async (id) => { await onDeleteVisita(id); setModalPC(null); } : null}
            onSave={handleSaveVisita}
            onClose={() => setModalPC(null)}
          />
        </ModalWrap>
      )}
      {modalPC?.type === "tarefa" && (
        <ModalWrap
          title="Nova Ação"
          onClose={() => setModalPC(null)}
        >
          <FormTarefaConsultor
            data={modalPC.data}
            clientes={clientes}
            visitas={visitas}
            onSave={handleSaveTarefa}
            onClose={() => setModalPC(null)}
          />
        </ModalWrap>
      )}
    </div>
  );
}

function PortalCliente({ cliente, visitas, marcos, tarefas, dmg, especialistas, api, usuarioLogado, onLogout, onUpdateTarefaStatus, onConfirmarVisita, gerarPDFDmg, showToast }) {
  const [aba, setAba] = useState("projeto");
  const [comentarios, setComentarios] = useState([]);
  const [novoComentario, setNovoComentario] = useState({});

  useEffect(() => {
    if (api?.comentarios) {
      api.comentarios.list(cliente?.id).then(setComentarios).catch(() => {});
    }
  }, [cliente?.id, api]); // eslint-disable-line react-hooks/exhaustive-deps

  const calcMat = (d) => { if (!d) return 0; const v = Object.entries(d).filter(([k,val]) => k !== 'analiseIA' && k !== 'clienteId' && typeof val === 'number').map(([,val]) => val); if (!v.length) return 0; return Math.round(v.reduce((a, b) => a + b, 0) / v.length); };
  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "-";
  const hoje = new Date().toISOString().split("T")[0];
  const mat = calcMat(dmg);
  const especialistaNome = (id) => especialistas.find(e => e.id === id)?.nome || "—";

  const enviarComentario = async (tarefaId) => {
    const texto = novoComentario[tarefaId];
    if (!texto?.trim()) return;
    try {
      const novo = await api.comentarios.insert({ clienteId: cliente.id, tarefaId, autor: cliente.nome, texto });
      setComentarios(prev => [...prev, novo]);
      setNovoComentario(prev => ({ ...prev, [tarefaId]: "" }));
      showToast("Comentário enviado!");
    } catch (e) { showToast("Erro ao enviar comentário", "error"); }
  };

  const ABAS = [
    { id: "projeto", label: "📊 Projeto" },
    { id: "visitas", label: "📅 Atendimentos" },
    { id: "tarefas", label: "✅ Plano de Ação" },
    { id: "diagnostico", label: "🎯 Diagnóstico" },
  ];

  if (!cliente) return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", color: T.text, fontFamily: "'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>⚠️</div>
        <div style={{ fontSize: 16, fontWeight: 700 }}>Projeto não encontrado</div>
        <button onClick={onLogout} style={{ marginTop: 16, padding: "8px 20px", background: T.laranja, border: "none", borderRadius: 8, color: "#fff", cursor: "pointer", fontWeight: 700 }}>Sair</button>
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily: "'Segoe UI',system-ui,sans-serif", background: T.bg, minHeight: "100vh", color: T.text }}>
      <style>{`*{box-sizing:border-box}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:#1C3550;border-radius:4px}input::placeholder,textarea::placeholder{color:#6A90B8}`}</style>

      {/* HEADER */}
      <div style={{ background: T.marinho, borderBottom: `1px solid ${T.border}`, padding: "16px 28px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, borderRadius: 10, padding: "8px 14px" }}>
            <img src={LOGO_LUMEN} alt="Lumen Instituto" style={{ height: 34, display: "block" }} />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 800 }}>{cliente.nome}</div>
            <div style={{ fontSize: 11, color: T.muted }}>Portal do Cliente · {cliente.segmento}</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ fontSize: 12, color: T.muted }}>Olá, <b style={{ color: T.text }}>{usuarioLogado.nome}</b></div>
          <button onClick={onLogout} style={{ padding: "7px 14px", background: "transparent", border: `1px solid ${T.border}`, borderRadius: 8, color: T.muted, cursor: "pointer", fontSize: 12 }}>Sair</button>
        </div>
      </div>

      {/* ABAS */}
      <div style={{ background: T.marinho, borderBottom: `1px solid ${T.border}`, padding: "0 28px", display: "flex", gap: 4 }}>
        {ABAS.map(a => (
          <button key={a.id} onClick={() => setAba(a.id)} style={{ padding: "14px 20px", border: "none", borderBottom: `3px solid ${aba === a.id ? T.laranja : "transparent"}`, background: "transparent", color: aba === a.id ? T.laranja : T.muted, fontWeight: aba === a.id ? 700 : 400, fontSize: 13, cursor: "pointer" }}>{a.label}</button>
        ))}
      </div>

      <div style={{ padding: "24px 28px", maxWidth: 1000, margin: "0 auto" }}>

        {/* ABA PROJETO */}
        {aba === "projeto" && (
          <div>
            {/* Cards resumo */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 24 }}>
              {[
                { label: "Atendimentos realizados", val: visitas.filter(v => v.status === "Realizada").length, cor: T.laranja },
                { label: "Marcos concluídos", val: (cliente?.marcosDoProjetoIds || []).filter(m => m.status === "Concluído").length, cor: T.success },
                { label: "Tarefas abertas", val: tarefas.filter(t => t.status !== "Concluída").length, cor: T.warning },
                { label: "Maturidade DMG", val: mat > 0 ? `${mat}%` : "—", cor: mat > 70 ? T.success : mat > 50 ? T.laranjaM : T.danger },
              ].map((k, i) => (
                <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: "18px 20px" }}>
                  <div style={{ fontSize: 22, fontWeight: 900, color: k.cor }}>{k.val}</div>
                  <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>{k.label}</div>
                </div>
              ))}
            </div>

            {/* Equipe do projeto */}
            <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 22, marginBottom: 18 }}>
              <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 14 }}>👥 Equipe do seu projeto</div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                {/* Especialista e mentor do cadastro */}
                {[
                  { id: cliente.especialistaId, label: "Especialista responsável", cor: T.laranja },
                  { id: cliente.mentorId, label: "Mentor do projeto", cor: "#8b5cf6" },
                ].filter(e => e.id).map((e, i) => {
                  const esp = especialistas.find(x => x.id === e.id);
                  if (!esp) return null;
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}` }}>
                      <div style={{ width: 40, height: 40, borderRadius: "50%", background: `linear-gradient(135deg,${e.cor},${e.cor}88)`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 14, color: "#fff" }}>{esp.nome.split(" ").slice(0,2).map(n=>n[0]).join("")}</div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{esp.nome}</div>
                        <div style={{ fontSize: 10, color: T.muted }}>{e.label}</div>
                      </div>
                    </div>
                  );
                })}
                {/* Especialistas que já atenderam em alguma visita */}
                {[...new Set(visitas.map(v => v.especialistaId))]
                  .filter(id => id && id !== cliente.especialistaId && id !== cliente.mentorId)
                  .map(id => especialistas.find(e => e.id === id))
                  .filter(Boolean)
                  .map((esp, i) => (
                    <div key={`v-${i}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}` }}>
                      <div style={{ width: 40, height: 40, borderRadius: "50%", background: `linear-gradient(135deg,${T.azul},${T.azul}88)`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 14, color: "#fff" }}>{esp.nome.split(" ").slice(0,2).map(n=>n[0]).join("")}</div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{esp.nome}</div>
                        <div style={{ fontSize: 10, color: T.muted }}>Participou de atendimentos</div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>

            {/* Marcos */}
            <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 22 }}>
              <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 14 }}>🎯 Marcos do Projeto</div>
              {(cliente?.marcosDoProjetoIds || []).length === 0 && <div style={{ color: T.muted, fontSize: 13 }}>Nenhum marco definido ainda.</div>}
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {[...(cliente?.marcosDoProjetoIds || [])].sort((a, b) => (a.prazo || "9").localeCompare(b.prazo || "9")).map((m, idx) => {
                  const vencida = m.prazo && m.prazo < hoje && m.status !== "Concluído";
                  const corM = m.status === "Concluído" ? T.success : m.status === "Atrasado" ? T.danger : m.status === "Iniciado" ? T.laranjaM : T.azul;
                  return (
                    <div key={idx} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", background: T.cardL, borderRadius: 10, borderLeft: `4px solid ${corM}` }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 700 }}>{m.titulo}</div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                        {m.prazo && <span style={{ fontSize: 11, color: vencida ? T.danger : T.muted }}>📅 {fmtDate(m.prazo)}</span>}
                        <Badge label={m.prioridade || "Média"} color={prioColor(m.prioridade || "Média")} />
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: `${corM}22`, color: corM }}>{m.status || "A Iniciar"}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* ABA VISITAS */}
        {aba === "visitas" && (
          <div>
            {/* Próximas visitas agendadas */}
            {visitas.filter(v => v.status === "Agendada" || v.status === "Confirmada").length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 12, color: T.laranja }}>📅 Atendimentos Agendados</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {[...visitas].filter(v => v.status === "Agendada" || v.status === "Confirmada").sort((a, b) => a.data?.localeCompare(b.data)).map(v => (
                    <div key={v.id} style={{ background: T.card, border: `2px solid ${T.laranjaM}44`, borderRadius: 14, overflow: "hidden" }}>
                      {/* Header */}
                      <div style={{ padding: "14px 20px", background: `${T.laranjaM}18`, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ fontSize: 15, fontWeight: 900, color: T.laranja }}>📅 {fmtDate(v.data)}</div>
                          <span style={{ padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700, background: v.tipoAgenda === "Estratégia" ? `${T.laranja}22` : `${T.azul}22`, color: v.tipoAgenda === "Estratégia" ? T.laranja : T.azul }}>{v.tipoAgenda || "Projeto"}</span>
                          <span style={{ fontSize: 12, color: T.muted }}>⏱ {v.duracao}h</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 11, color: T.muted }}>👤 {especialistaNome(v.especialistaId).split(" ")[0]}</span>
                          {v.confirmadoCliente ? (() => {
                            const diasParaVisita = Math.ceil((new Date(v.data + "T12:00:00") - new Date()) / (1000 * 60 * 60 * 24));
                            const podeCanc = diasParaVisita >= 4;
                            return (
                              <div style={{ position: "relative", display: "inline-block" }} className="tooltip-wrap">
                                <button
                                  onClick={() => podeCanc && onConfirmarVisita && onConfirmarVisita(v.id, false)}
                                  style={{ padding: "6px 14px", background: `${T.success}22`, border: `1px solid ${T.success}44`, borderRadius: 8, color: T.success, fontSize: 12, fontWeight: 700, cursor: podeCanc ? "pointer" : "not-allowed", opacity: podeCanc ? 1 : 0.7 }}
                                  title={!podeCanc ? `Cancelamento não permitido — faltam apenas ${diasParaVisita} dia(s) para o atendimento. O prazo mínimo para cancelar é de 4 dias.` : "Clique para cancelar confirmação"}
                                >
                                  ✅ Confirmado
                                </button>
                              </div>
                            );
                          })() : (
                            <button
                              onClick={() => onConfirmarVisita && onConfirmarVisita(v.id, true)}
                              style={{ padding: "6px 14px", background: `linear-gradient(135deg,${T.success},#16a34a)`, border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                              ✅ Confirmar
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Detalhes da visita agendada */}
                      <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 14 }}>
                        {/* Tipo de atividade e agenda */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                          <div style={{ background: T.cardL, borderRadius: 10, padding: "10px 14px" }}>
                            <div style={{ fontSize: 10, color: T.muted, fontWeight: 600, marginBottom: 4 }}>TIPO DE ATIVIDADE</div>
                            <div style={{ fontSize: 13, fontWeight: 700 }}>{v.tipo || "—"}</div>
                          </div>
                          <div style={{ background: T.cardL, borderRadius: 10, padding: "10px 14px" }}>
                            <div style={{ fontSize: 10, color: T.muted, fontWeight: 600, marginBottom: 4 }}>TIPO DE AGENDA</div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: v.tipoAgenda === "Estratégia" ? T.laranja : T.azul }}>{v.tipoAgenda || "Projeto"}</div>
                          </div>
                        </div>

                        {/* Descrição geral */}
                        {v.descricao && (
                          <div style={{ background: T.cardL, borderRadius: 10, padding: "12px 14px" }}>
                            <div style={{ fontSize: 10, color: T.muted, fontWeight: 600, marginBottom: 6 }}>DESCRIÇÃO GERAL</div>
                            <div style={{ fontSize: 13, lineHeight: 1.6, color: T.text }}>{v.descricao}</div>
                          </div>
                        )}

                        {/* Itens de pauta */}
                        {(v.itensPauta || []).length > 0 && (
                          <div>
                            <div style={{ fontSize: 10, color: T.muted, fontWeight: 600, marginBottom: 8 }}>ITENS DE PAUTA</div>
                            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                              {/* Header */}
                              <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: 8, padding: "0 4px" }}>
                                <div style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>Item / Assunto</div>
                                <div style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>Stakeholder</div>
                              </div>
                              {v.itensPauta.map((item, idx) => (
                                <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: 8, padding: "8px 12px", background: T.cardL, borderRadius: 8, borderLeft: `3px solid ${T.laranja}` }}>
                                  <div style={{ fontSize: 12, fontWeight: 600 }}>{item.item}</div>
                                  <div style={{ fontSize: 12, color: T.muted }}>👤 {item.stakeholder || "—"}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Anexos se houver */}
                        {(v.anexos || []).length > 0 && (
                          <div>
                            <div style={{ fontSize: 10, color: T.muted, fontWeight: 600, marginBottom: 8 }}>ANEXOS</div>
                            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                              {v.anexos.map((a, idx) => (
                                <a key={idx} href={a.url} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 12px", background: T.cardL, borderRadius: 8, border: `1px solid ${T.border}`, color: T.azul, fontSize: 12, textDecoration: "none", fontWeight: 600 }}>
                                  {a.tipo === "application/pdf" ? "📄" : "🖼️"} {a.nome}
                                </a>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Atendimentos realizados */}
            {visitas.filter(v => v.status === "Realizada").length > 0 && (
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 12, color: T.muted }}>✅ Atendimentos Realizados</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  {[...visitas].filter(v => v.status === "Realizada").sort((a, b) => b.data?.localeCompare(a.data)).map(v => {
                    const tarefasVisita = tarefas.filter(t => t.visitaId === v.id);
                    return (
                    <div key={v.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}>
                      {/* Header */}
                      <div style={{ padding: "14px 20px", background: T.cardL, borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div style={{ fontSize: 14, fontWeight: 800 }}>{fmtDate(v.data)}</div>
                          <span style={{ padding: "2px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700, background: v.tipoAgenda === "Estratégia" ? `${T.laranja}22` : `${T.azul}22`, color: v.tipoAgenda === "Estratégia" ? T.laranja : T.azul }}>{v.tipoAgenda || "Projeto"}</span>
                          <span style={{ fontSize: 11, color: T.muted }}>{v.tipo} · {v.duracao}h</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ padding: "2px 10px", borderRadius: 6, fontSize: 10, fontWeight: 700, background: `${T.success}22`, color: T.success }}>✅ Realizada</span>
                          <button onClick={() => gerarPDFVisita(v, cliente, especialistas, tarefasVisita)} style={{ padding: "5px 12px", background: `${T.laranja}22`, border: `1px solid ${T.laranja}44`, borderRadius: 8, color: T.laranja, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>📄 Gerar PDF</button>
                        </div>
                      </div>

                      {/* Descrição */}
                      {v.descricao && <div style={{ padding: "12px 20px", fontSize: 13, color: T.muted, borderBottom: `1px solid ${T.border}` }}><b style={{ color: T.muted, fontSize: 10 }}>DESCRIÇÃO: </b>{v.descricao}</div>}

                      {/* Itens tratados */}
                      {(v.itensPauta || []).length > 0 && (
                        <div style={{ padding: "14px 20px", borderBottom: `1px solid ${T.border}` }}>
                          <div style={{ fontSize: 10, color: T.muted, fontWeight: 700, marginBottom: 8 }}>📋 ITENS TRATADOS</div>
                          {v.itensPauta.map((item, idx) => (
                            <div key={idx} style={{ display: "flex", gap: 8, fontSize: 12, padding: "5px 0", borderBottom: idx < v.itensPauta.length - 1 ? `1px solid ${T.border}22` : "none" }}>
                              <span style={{ color: T.laranja, fontWeight: 700 }}>·</span>
                              <span style={{ flex: 1 }}>{item.item}</span>
                              {item.stakeholder && <span style={{ color: T.muted }}>👤 {item.stakeholder}</span>}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Ata */}
                      {v.ata && (
                        <div style={{ padding: "14px 20px", borderBottom: `1px solid ${T.border}` }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: T.laranjaM, marginBottom: 8 }}>📝 ATA DA VISITA</div>
                          <div style={{ fontSize: 13, lineHeight: 1.8, color: T.text, whiteSpace: "pre-wrap" }}>{v.ata}</div>
                        </div>
                      )}

                      {/* Tarefas geradas */}
                      {tarefasVisita.length > 0 && (
                        <div style={{ padding: "14px 20px", borderBottom: `1px solid ${T.border}` }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: T.azul, marginBottom: 8 }}>📋 TAREFAS GERADAS NESTA VISITA</div>
                          {tarefasVisita.map((t, idx) => (
                            <div key={idx} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: idx < tarefasVisita.length - 1 ? `1px solid ${T.border}22` : "none" }}>
                              <span style={{ fontSize: 12, color: t.status === "Concluída" ? T.success : T.laranjaM }}>
                                {t.status === "Concluída" ? "✅" : "⏳"}
                              </span>
                              <span style={{ flex: 1, fontSize: 12, textDecoration: t.status === "Concluída" ? "line-through" : "none", color: t.status === "Concluída" ? T.muted : T.text }}>{t.titulo}</span>
                              {t.responsavel && <span style={{ fontSize: 11, color: T.muted }}>👤 {t.responsavel}</span>}
                              {t.prazo && <span style={{ fontSize: 11, color: T.muted }}>📅 {fmtDate(t.prazo)}</span>}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Ganhos */}
                      {(v.ganhos || []).length > 0 && (
                        <div style={{ padding: "14px 20px", borderBottom: `1px solid ${T.border}` }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: T.success, marginBottom: 8 }}>🏆 GANHOS DESTA VISITA</div>
                          {v.ganhos.map((g, idx) => (
                            <div key={idx} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, padding: "4px 0", borderBottom: idx < v.ganhos.length - 1 ? `1px solid ${T.border}22` : "none" }}>
                              <span>{g.tipo || "Ganho registrado"}</span>
                              <span style={{ fontWeight: 700, color: T.success }}>{g.unidade === "R$" ? `R$ ${Number(g.valor).toLocaleString("pt-BR")}` : `${g.valor} ${g.unidade}`}</span>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Anexos */}
                      {(v.anexos || []).length > 0 && (
                        <div style={{ padding: "12px 20px", display: "flex", gap: 8, flexWrap: "wrap" }}>
                          {v.anexos.map((a, idx) => (
                            <a key={idx} href={a.url} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 10px", background: T.cardL, borderRadius: 6, border: `1px solid ${T.border}`, color: T.azul, fontSize: 11, textDecoration: "none" }}>
                              {a.tipo === "application/pdf" ? "📄" : "🖼️"} {a.nome}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  )})}
                </div>
              </div>
            )}

            {visitas.length === 0 && (
              <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 32, textAlign: "center", color: T.muted }}>Nenhuma visita registrada ainda.</div>
            )}
          </div>
        )}

        {/* ABA TAREFAS / PLANO DE AÇÃO */}
        {aba === "tarefas" && (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
              {[
                { label: "Pendentes", val: tarefas.filter(t => t.status === "Pendente").length, cor: T.azul },
                { label: "Em andamento", val: tarefas.filter(t => t.status === "Em andamento").length, cor: T.laranjaM },
                { label: "Concluídas", val: tarefas.filter(t => t.status === "Concluída").length, cor: T.success },
              ].map((s, i) => (
                <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: "14px 18px", textAlign: "center" }}>
                  <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                  <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                </div>
              ))}
            </div>

            {tarefas.length === 0 && <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 32, textAlign: "center", color: T.muted }}>Nenhuma tarefa cadastrada ainda.</div>}

            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[...tarefas].sort((a, b) => a.prazo?.localeCompare(b.prazo || "9")).map(t => {
                const vencida = t.prazo && t.prazo < hoje && t.status !== "Concluída";
                const corStatus = t.status === "Concluída" ? T.success : t.status === "Em andamento" ? T.laranjaM : T.azul;
                const meusComs = comentarios.filter(c => c.tarefaId === t.id);
                return (
                  <div key={t.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden", borderLeft: `4px solid ${corStatus}` }}>
                    <div style={{ padding: "14px 20px" }}>
                      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 14, fontWeight: 700, textDecoration: t.status === "Concluída" ? "line-through" : "none", color: t.status === "Concluída" ? T.muted : T.text }}>{t.titulo}</div>
                          <div style={{ fontSize: 11, color: T.muted, marginTop: 4, display: "flex", gap: 12, flexWrap: "wrap" }}>
                            {t.responsavel && <span>👤 {t.responsavel}</span>}
                            {t.prazo && <span style={{ color: vencida ? T.danger : T.muted }}>{vencida ? "⚠️" : "📅"} {fmtDate(t.prazo)}</span>}
                            {t.obs && <span>💬 {t.obs}</span>}
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                          <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: `${corStatus}22`, color: corStatus }}>{t.status}</span>
                          {/* Cliente pode marcar como concluída */}
                          {t.status !== "Concluída" && (
                            <button onClick={() => onUpdateTarefaStatus(t.id, "Concluída")} style={{ padding: "5px 12px", background: `${T.success}22`, border: `1px solid ${T.success}44`, borderRadius: 8, color: T.success, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                              ✓ Marcar concluída
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Comentários */}
                    <div style={{ borderTop: `1px solid ${T.border}`, padding: "12px 20px" }}>
                      {meusComs.length > 0 && (
                        <div style={{ marginBottom: 10 }}>
                          {meusComs.map((c, i) => (
                            <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                              <div style={{ width: 28, height: 28, borderRadius: "50%", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 800, color: "#fff", flexShrink: 0 }}>{c.autor?.substring(0,2).toUpperCase()}</div>
                              <div style={{ flex: 1, background: T.cardL, borderRadius: 8, padding: "8px 12px" }}>
                                <div style={{ fontSize: 10, fontWeight: 700, color: T.laranjaM, marginBottom: 2 }}>{c.autor}</div>
                                <div style={{ fontSize: 12, color: T.text }}>{c.texto}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      <div style={{ display: "flex", gap: 8 }}>
                        <input
                          value={novoComentario[t.id] || ""}
                          onChange={e => setNovoComentario(prev => ({ ...prev, [t.id]: e.target.value }))}
                          onKeyDown={e => e.key === "Enter" && enviarComentario(t.id)}
                          placeholder="Deixe um comentário ou dúvida..."
                          style={{ flex: 1, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 12px", fontSize: 12, outline: "none" }}
                        />
                        <button onClick={() => enviarComentario(t.id)} style={{ padding: "8px 14px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Enviar</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {/* ABA DIAGNÓSTICO */}
        {aba === "diagnostico" && (
          <div>
            {!dmg ? (
              <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 48, textAlign: "center" }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
                <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Diagnóstico ainda não realizado</div>
                <div style={{ fontSize: 13, color: T.muted }}>O seu diagnóstico de maturidade será disponibilizado aqui após a primeira avaliação.</div>
              </div>
            ) : (() => {
              const calcMat = (d) => { if (!d) return 0; const v = Object.entries(d).filter(([k,val]) => k !== 'analiseIA' && k !== 'clienteId' && typeof val === 'number').map(([,val]) => val); if (!v.length) return 0; return Math.round(v.reduce((a, b) => a + b, 0) / v.length); };
              const mat = calcMat(dmg);
              const nivelLabel = (s) => s >= 75 ? "AVANÇADO" : s >= 60 ? "BOM" : s >= 40 ? "REGULAR" : "CRÍTICO";
              const nivelCor = (s) => s >= 75 ? T.success : s >= 60 ? T.laranjaM : s >= 40 ? T.warning : T.danger;
              const rd = DMG_PILARES.map(p => ({ pilar: DMG_PERGUNTAS[p].label, val: dmg[p] || 0, icon: DMG_PERGUNTAS[p].icon }));
              // Busca análise salva do banco via dmg data
              const analise = dmg?.analiseIA || null;

              return (
                <div>
                  {/* Score geral */}
                  <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 24, marginBottom: 18, display: "flex", alignItems: "center", gap: 24 }}>
                    <div style={{ textAlign: "center", flexShrink: 0 }}>
                      <div style={{ fontSize: 52, fontWeight: 900, color: nivelCor(mat), lineHeight: 1 }}>{mat}%</div>
                      <div style={{ fontSize: 12, color: T.muted, marginTop: 4 }}>Maturidade Geral</div>
                      <span style={{ padding: "3px 12px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: `${nivelCor(mat)}22`, color: nivelCor(mat), border: `1px solid ${nivelCor(mat)}44`, marginTop: 6, display: "inline-block" }}>{nivelLabel(mat)}</span>
                    </div>
                    <div style={{ flex: 1 }}>
                      <ResponsiveContainer width="100%" height={180}>
                        <RadarChart data={rd}>
                          <PolarGrid stroke={T.border} />
                          <PolarAngleAxis dataKey="pilar" tick={{ fill: T.muted, fontSize: 10 }} />
                          <Radar dataKey="val" stroke={T.laranja} fill={T.laranja} fillOpacity={0.25} strokeWidth={2} />
                        </RadarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* Pilares */}
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 10, marginBottom: 18 }}>
                    {rd.map((r, i) => (
                      <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: "12px 14px", display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 20 }}>{r.icon}</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 700 }}>{r.pilar}</div>
                          <div style={{ height: 4, background: T.border, borderRadius: 3, marginTop: 5 }}>
                            <div style={{ height: "100%", width: `${r.val}%`, background: nivelCor(r.val), borderRadius: 3 }} />
                          </div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: 14, fontWeight: 900, color: nivelCor(r.val) }}>{r.val}%</div>
                          <div style={{ fontSize: 9, color: nivelCor(r.val), fontWeight: 600 }}>{nivelLabel(r.val)}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Análise IA */}
                  {analise && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 18 }}>
                      {[
                        { key: "maturidade", label: "🎯 Maturidade de Gestão Identificada", cor: T.azul },
                        { key: "positivos", label: "✅ Pontos Positivos", cor: T.success },
                        { key: "melhoria", label: "🔧 Pontos de Melhoria", cor: T.warning },
                        { key: "focal", label: "🚀 Ponto Focal para Melhoria", cor: T.laranja },
                      ].map(t => (
                        <div key={t.key} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 18px", borderLeft: `4px solid ${t.cor}` }}>
                          <div style={{ fontSize: 13, fontWeight: 800, color: t.cor, marginBottom: 10 }}>{t.label}</div>
                          <div style={{ fontSize: 13, lineHeight: 1.8, color: T.text, whiteSpace: "pre-wrap" }}>{analise[t.key]}</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Botão PDF */}
                  {analise && (
                    <button onClick={() => {
                      const scores = DMG_PILARES.map(p => ({ pilar: p, score: dmg[p] || 0 }));
                      gerarPDFDmg(cliente, scores, analise, mat);
                    }} style={{ width: "100%", padding: "12px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 10, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
                      📄 Baixar Relatório de Diagnóstico PDF
                    </button>
                  )}

                  {!analise && (
                    <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 12, padding: "16px 20px", textAlign: "center", color: T.muted, fontSize: 13 }}>
                      A análise detalhada será disponibilizada em breve pelo seu especialista Lumen.
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
}
function PlanoAcaoModule({ tarefas, clientes, visitas, onUpdateStatus, onDelete, onEdit }) {
  const [filtroProjeto, setFiltroProjeto] = useState("todos");
  const [filtroStatus, setFiltroStatus] = useState("abertas");

  const hoje = new Date().toISOString().split("T")[0];

  const tarefasFilt = tarefas
    .filter(t => filtroProjeto === "todos" || t.clienteId === filtroProjeto)
    .filter(t => filtroStatus === "todas" || (filtroStatus === "abertas" ? t.status !== "Concluída" : t.status === "Concluída"));

  const vencidas = tarefas.filter(t => t.prazo && t.prazo < hoje && t.status !== "Concluída").length;
  const venceHoje = tarefas.filter(t => t.prazo === hoje && t.status !== "Concluída").length;

  const clienteNome = (id) => clientes.find(c => c.id === id)?.nome || "—";
  const visitaLabel = (id) => {
    const v = visitas.find(v => v.id === id);
    if (!v) return "Manual";
    return `${fmtDate(v.data)} · ${clienteNome(v.clienteId)}`;
  };

  const porCliente = clientes
    .filter(c => filtroProjeto === "todos" || c.id === filtroProjeto)
    .map(c => ({ cliente: c, tarefas: tarefasFilt.filter(t => t.clienteId === c.id) }))
    .filter(g => g.tarefas.length > 0);

  return (
    <div className="fade">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Tarefas abertas", val: tarefas.filter(t => t.status !== "Concluída").length, cor: T.azul },
          { label: "Vencidas", val: vencidas, cor: T.danger },
          { label: "Vencem hoje", val: venceHoje, cor: T.warning },
          { label: "Concluídas", val: tarefas.filter(t => t.status === "Concluída").length, cor: T.success },
        ].map((s, i) => (
          <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
            <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
          </Card>
        ))}
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap", alignItems: "center" }}>
        <select value={filtroProjeto} onChange={e => setFiltroProjeto(e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "7px 12px", fontSize: 12, outline: "none" }}>
          <option value="todos">Todos os projetos</option>
          {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
        <div style={{ display: "flex", background: T.card, borderRadius: 8, border: `1px solid ${T.border}`, overflow: "hidden" }}>
          {[{ id: "abertas", label: "Em aberto" }, { id: "todas", label: "Todas" }, { id: "concluidas", label: "Concluídas" }].map(f => (
            <button key={f.id} onClick={() => setFiltroStatus(f.id)} style={{ padding: "7px 14px", border: "none", background: filtroStatus === f.id ? `linear-gradient(135deg,${T.laranja},${T.laranjaM})` : "transparent", color: filtroStatus === f.id ? "#fff" : T.muted, fontSize: 12, fontWeight: filtroStatus === f.id ? 700 : 400, cursor: "pointer" }}>{f.label}</button>
          ))}
        </div>
        {vencidas > 0 && <div style={{ padding: "6px 14px", background: `${T.danger}22`, border: `1px solid ${T.danger}44`, borderRadius: 8, color: T.danger, fontSize: 12, fontWeight: 700 }}>⚠️ {vencidas} vencida{vencidas > 1 ? "s" : ""}</div>}
      </div>

      {porCliente.length === 0 ? (
        <Card style={{ textAlign: "center", padding: 48 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>✅</div>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>Nenhuma tarefa encontrada</div>
          <div style={{ fontSize: 13, color: T.muted }}>As tarefas criadas nas atas de visita ou manualmente aparecerão aqui, agrupadas por projeto.</div>
        </Card>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          {porCliente.map(({ cliente, tarefas: tCliente }) => {
            const abertas = tCliente.filter(t => t.status !== "Concluída").length;
            const pct = Math.round(((tCliente.length - abertas) / Math.max(tCliente.length, 1)) * 100);
            return (
              <Card key={cliente.id} style={{ padding: 0, overflow: "hidden" }}>
                <div style={{ padding: "14px 20px", background: T.cardL, borderBottom: `1px solid ${T.border}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 34, height: 34, borderRadius: 8, background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 12, color: "#fff" }}>{iniciais(cliente.nome)}</div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 800 }}>{cliente.nome}</div>
                      <div style={{ fontSize: 11, color: T.muted }}>{cliente.segmento} · {abertas} em aberto · {tCliente.length} total</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 100, height: 6, background: T.border, borderRadius: 3 }}>
                      <div style={{ height: "100%", width: `${pct}%`, background: T.success, borderRadius: 3, transition: "width 0.4s" }} />
                    </div>
                    <span style={{ fontSize: 12, fontWeight: 800, color: T.success, minWidth: 36 }}>{pct}%</span>
                  </div>
                </div>

                <div style={{ padding: "6px 0" }}>
                  {tCliente.map((t, idx) => {
                    const vencida = t.prazo && t.prazo < hoje && t.status !== "Concluída";
                    const venceHj = t.prazo === hoje && t.status !== "Concluída";
                    return (
                      <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 20px", borderBottom: idx < tCliente.length - 1 ? `1px solid ${T.border}22` : "none", background: vencida ? `${T.danger}08` : "transparent" }}>
                        <button onClick={() => onUpdateStatus(t.id, t.status === "Concluída" ? "Pendente" : "Concluída")} style={{ width: 20, height: 20, borderRadius: 5, border: `2px solid ${t.status === "Concluída" ? T.success : T.border}`, background: t.status === "Concluída" ? T.success : "transparent", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#fff", fontSize: 11, transition: "all 0.15s" }}>
                          {t.status === "Concluída" ? "✓" : ""}
                        </button>
                        <div style={{ flex: 1, opacity: t.status === "Concluída" ? 0.5 : 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, textDecoration: t.status === "Concluída" ? "line-through" : "none", color: t.status === "Concluída" ? T.muted : T.text }}>{t.titulo}</div>
                          <div style={{ fontSize: 11, color: T.muted, marginTop: 2, display: "flex", gap: 12, flexWrap: "wrap" }}>
                            {t.responsavel && <span>👤 {t.responsavel}</span>}
                            {t.visitaId ? <span style={{ color: T.azul }}>🔗 {visitaLabel(t.visitaId)}</span> : <span>✏️ Manual</span>}
                            {t.obs && <span>💬 {t.obs}</span>}
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                          {t.prazo && (
                            <span style={{ fontSize: 11, fontWeight: 600, color: vencida ? T.danger : venceHj ? T.warning : T.muted, whiteSpace: "nowrap" }}>
                              {vencida ? "⚠️" : venceHj ? "🔔" : "📅"} {fmtDate(t.prazo)}
                            </span>
                          )}
                          <Badge label={t.prioridade || "Média"} color={prioColor(t.prioridade || "Média")} />
                          <select value={t.status} onChange={e => onUpdateStatus(t.id, e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: t.status === "Concluída" ? T.success : t.status === "Em andamento" ? T.laranjaM : T.azul, padding: "4px 8px", fontSize: 11, cursor: "pointer", outline: "none", fontWeight: 600 }}>
                            {["Pendente", "Em andamento", "Concluída"].map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                          <Btn small variant="ghost" onClick={() => onEdit(t)}>✏️</Btn>
                          <button onClick={() => { onDelete(t.id); }} style={{ width: 28, height: 28, borderRadius: 6, background: `${T.danger}18`, border: "none", color: T.danger, cursor: "pointer", fontSize: 12 }}>🗑</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}

function FormTarefaConsultor({ data, clientes, visitas, onSave, onClose }) {
  // Versão simplificada do FormTarefa para o consultor
  // clienteId e visitaId já vêm pré-preenchidos
  const fmtDateLocal = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";
  const [f, setF] = useState({
    clienteId: "", titulo: "", responsavel: "", prazo: "",
    prioridade: "Média", status: "Pendente", visitaId: "", obs: "",
    ...(data || {})
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  const visitasDoCliente = visitas.filter(v => v.status === "Realizada" && v.clienteId === f.clienteId);
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        {/* Cliente — bloqueado se já veio pré-selecionado */}
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Cliente *</label>
          <select value={f.clienteId} onChange={e => s("clienteId")(e.target.value)} disabled={!!data?.clienteId}
            style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none", opacity: data?.clienteId ? 0.7 : 1 }}>
            <option value="">Selecionar...</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        {/* Visita vinculada */}
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Visita de origem *</label>
          <select value={f.visitaId} onChange={e => s("visitaId")(e.target.value)} disabled={!!data?.visitaId}
            style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none", opacity: data?.visitaId ? 0.7 : 1 }}>
            <option value="">Selecionar visita...</option>
            {visitasDoCliente.map(v => (
              <option key={v.id} value={v.id}>{fmtDateLocal(v.data)} · {v.tipo}</option>
            ))}
          </select>
          {visitasDoCliente.length === 0 && f.clienteId && (
            <div style={{ fontSize: 10, color: T.warning, marginTop: 4 }}>Nenhuma visita realizada neste cliente ainda.</div>
          )}
        </div>
        <div style={{ gridColumn: "1/-1" }}><Field label="Tarefa / O que fazer *" value={f.titulo} onChange={s("titulo")} required placeholder="Ex: Implantar kardex, Organizar DRE, Treinar equipe..." /></div>
        <Field label="Responsável no cliente" value={f.responsavel} onChange={s("responsavel")} placeholder="Nome de quem vai executar" />
        <Field label="Prazo" value={f.prazo} onChange={s("prazo")} type="date" />
        <Field label="Prioridade" value={f.prioridade} onChange={s("prioridade")} options={["Alta", "Média", "Baixa"]} />
        <Field label="Status" value={f.status} onChange={s("status")} options={["Pendente", "Em andamento", "Concluída"]} />
        <div style={{ gridColumn: "1/-1" }}><Field label="Observações" value={f.obs} onChange={s("obs")} placeholder="Contexto adicional, referências, detalhes..." /></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => { if (!f.titulo || !f.clienteId || !f.visitaId) return; onSave(f); }}>✅ Salvar Ação</Btn>
      </div>
    </>
  );
}

function FormTarefa({ data, clientes, visitas, onSave, onClose }) {
  const [f, setF] = useState({ clienteId: "", titulo: "", responsavel: "", prazo: "", prioridade: "Média", status: "Pendente", visitaId: "", obs: "", ...(data || {}) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Cliente *</label>
          <select value={f.clienteId} onChange={e => s("clienteId")(e.target.value)} style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Selecionar...</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <div style={{ gridColumn: "1/-1" }}><Field label="Tarefa / O que fazer" value={f.titulo} onChange={s("titulo")} required placeholder="Ex: Implantar kardex, Organizar DRE, Treinar equipe..." /></div>
        <Field label="Responsável no cliente" value={f.responsavel} onChange={s("responsavel")} placeholder="Nome de quem vai executar" />
        <Field label="Prazo" value={f.prazo} onChange={s("prazo")} type="date" />
        <Field label="Prioridade" value={f.prioridade} onChange={s("prioridade")} options={["Alta", "Média", "Baixa"]} />
        <Field label="Status" value={f.status} onChange={s("status")} options={["Pendente", "Em andamento", "Concluída"]} />
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Visita de origem</label>
          <select value={f.visitaId} onChange={e => s("visitaId")(e.target.value)} style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Manual (sem visita vinculada)</option>
            {visitas.filter(v => v.status === "Realizada" && (!f.clienteId || v.clienteId === f.clienteId)).map(v => (
              <option key={v.id} value={v.id}>{fmtDate(v.data)} · {clientes.find(c => c.id === v.clienteId)?.nome} · {v.tipo}</option>
            ))}
          </select>
        </div>
        <div style={{ gridColumn: "1/-1" }}><Field label="Observações" value={f.obs} onChange={s("obs")} placeholder="Contexto adicional, referências, detalhes..." /></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}

// ─── CALENDÁRIO ──────────────────────────────────────────────────────────────
const CORES_ESPECIALISTAS = ["#F44D19","#EF8220","#0075EA","#22c55e","#8b5cf6","#f59e0b","#06b6d4","#ec4899"];
const DIAS_SEMANA = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
const MESES = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];

// ─── EXPORTAR ICS (OUTLOOK / GOOGLE CALENDAR) ────────────────────────────────
function exportarICS(eventos, clientes, especialistas) {
  const fmtICS = (dataStr, horaStr = "080000") => {
    // dataStr = "2026-05-15", horaStr = "080000"
    return dataStr.replace(/-/g, "") + "T" + horaStr + "Z";
  };

  const escapar = (str) => (str || "").replace(/,/g, "\\,").replace(/;/g, "\\;").replace(/\n/g, "\\n");

  const linhas = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Lumen Instituto//Lumen360//PT",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "X-WR-CALNAME:Lumen 360 — Agenda",
    "X-WR-TIMEZONE:America/Sao_Paulo",
  ];

  eventos.forEach(ev => {
    if (!ev.data) return;
    const uid = `${ev.id || Date.now()}@lumen360`;
    const dtStamp = fmtICS(new Date().toISOString().split("T")[0]);

    if (ev.tipo === "visita") {
      const cliente = clientes.find(c => c.id === ev.raw?.clienteId);
      const esp = especialistas.find(e => e.id === ev.raw?.especialistaId);
      const horarios = ev.raw?.horarios || [];
      
      if (horarios.length > 0) {
        // Cria um evento para cada período de horário
        horarios.forEach((h, idx) => {
          if (!h.inicio || !h.fim) return;
          const dtStart = fmtICS(ev.data, h.inicio.replace(":", "") + "00");
          const dtEnd = fmtICS(ev.data, h.fim.replace(":", "") + "00");
          linhas.push(
            "BEGIN:VEVENT",
            `UID:${uid}-${idx}`,
            `DTSTAMP:${dtStamp}`,
            `DTSTART:${dtStart}`,
            `DTEND:${dtEnd}`,
            `SUMMARY:${escapar(cliente?.nome || ev.titulo)} — ${escapar(ev.raw?.tipo || "Consultoria")}`,
            `DESCRIPTION:${escapar(`Especialista: ${esp?.nome || "—"}\\nTipo: ${ev.raw?.tipo || "—"}\\nStatus: ${ev.status || "—"}`)}`,
            `STATUS:${ev.status === "Realizada" ? "CONFIRMED" : ev.status === "Cancelada" ? "CANCELLED" : "TENTATIVE"}`,
            `CATEGORIES:Lumen 360`,
            "END:VEVENT"
          );
        });
      } else {
        // Sem horário definido — evento dia inteiro
        linhas.push(
          "BEGIN:VEVENT",
          `UID:${uid}`,
          `DTSTAMP:${dtStamp}`,
          `DTSTART;VALUE=DATE:${ev.data.replace(/-/g, "")}`,
          `DTEND;VALUE=DATE:${ev.data.replace(/-/g, "")}`,
          `SUMMARY:${escapar(cliente?.nome || ev.titulo)} — ${escapar(ev.raw?.tipo || "Consultoria")}`,
          `DESCRIPTION:${escapar(`Especialista: ${esp?.nome || "—"}\\nTipo: ${ev.raw?.tipo || "—"}\\nStatus: ${ev.status || "—"}`)}`,
          `STATUS:${ev.status === "Realizada" ? "CONFIRMED" : ev.status === "Cancelada" ? "CANCELLED" : "TENTATIVE"}`,
          `CATEGORIES:Lumen 360`,
          "END:VEVENT"
        );
      }
    } else if (ev.tipo === "tarefa") {
      // Tarefas como eventos dia inteiro
      linhas.push(
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${dtStamp}`,
        `DTSTART;VALUE=DATE:${ev.data.replace(/-/g, "")}`,
        `DTEND;VALUE=DATE:${ev.data.replace(/-/g, "")}`,
        `SUMMARY:✅ ${escapar(ev.titulo)}`,
        `DESCRIPTION:${escapar(`Cliente: ${ev.sub || "—"}\\nStatus: ${ev.status || "—"}`)}`,
        `CATEGORIES:Plano de Ação`,
        "END:VEVENT"
      );
    }
  });

  linhas.push("END:VCALENDAR");

  const conteudo = linhas.join("\r\n");
  const blob = new Blob([conteudo], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `lumen360-agenda-${new Date().toISOString().split("T")[0]}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}

function CalendarioModule({ visitas, tarefas, clientes, especialistas, isAdmin, usuarioLogado, onNovaVisita, onEditVisita }) {
  const hoje = new Date();
  const [ano, setAno] = useState(hoje.getFullYear());
  const [mes, setMes] = useState(hoje.getMonth());
  const [view, setView] = useState("mes");
  const [filtroEsp, setFiltroEsp] = useState("todos");
  const [filtroProjeto, setFiltroProjeto] = useState("todos");
  const [filtroTipoAgenda, setFiltroTipoAgenda] = useState("todos");
  const [diaDetalhe, setDiaDetalhe] = useState(null);

  const corEsp = (id) => {
    const idx = especialistas.findIndex(e => e.id === id);
    return CORES_ESPECIALISTAS[idx % CORES_ESPECIALISTAS.length] || T.laranja;
  };

  const corTarefa = (t) => t.status === "Concluída" ? T.success : t.status === "Em andamento" ? T.laranjaM : t.prioridade === "Alta" ? T.danger : T.azul;

  // Todos os eventos = visitas + tarefas do plano de ação (pelo prazo)
  const todosEventos = [
    ...visitas.map(v => ({
      id: v.id, tipo: "visita", data: v.data,
      titulo: clientes.find(c => c.id === v.clienteId)?.nome || "—",
      sub: `${v.tipo} · ${especialistas.find(e => e.id === v.especialistaId)?.nome?.split(" ")[0] || "—"}`,
      cor: corEsp(v.especialistaId),
      status: v.status, especialistaId: v.especialistaId, raw: v,
    })),
    ...(tarefas || []).filter(t => t.prazo && t.status !== "Concluída").map(t => ({
      id: t.id, tipo: "tarefa", data: t.prazo,
      titulo: t.titulo,
      sub: `✅ ${clientes.find(c => c.id === t.clienteId)?.nome || "—"}`,
      cor: corTarefa(t),
      status: t.status, especialistaId: null, raw: t,
    })),
  ];

  const eventosFiltrados = todosEventos
    .filter(e => filtroEsp === "todos" || e.especialistaId === filtroEsp || e.tipo === "tarefa")
    .filter(e => filtroProjeto === "todos" || (e.tipo === "visita" && clientes.find(c => c.id === e.raw?.clienteId)?.id === filtroProjeto) || e.tipo === "tarefa")
    .filter(e => filtroTipoAgenda === "todos" || (e.tipo === "visita" && (e.raw?.tipoAgenda || "Projeto") === filtroTipoAgenda) || e.tipo === "tarefa");

  const eventosNoDia = (dataStr) => eventosFiltrados.filter(e => e.data === dataStr);

  // Navegar mês
  const navMes = (dir) => {
    let nm = mes + dir; let na = ano;
    if (nm < 0) { nm = 11; na--; } else if (nm > 11) { nm = 0; na++; }
    setMes(nm); setAno(na); setDiaDetalhe(null);
  };

  // Grid do mês
  const primeiroDia = new Date(ano, mes, 1).getDay();
  const diasNoMes = new Date(ano, mes + 1, 0).getDate();
  const celulas = Array.from({ length: primeiroDia + diasNoMes }, (_, i) => i < primeiroDia ? null : i - primeiroDia + 1);
  while (celulas.length % 7 !== 0) celulas.push(null);

  const fmt2 = (n) => String(n).padStart(2, "0");
  const dataStr = (d) => d ? `${ano}-${fmt2(mes + 1)}-${fmt2(d)}` : null;
  const isHoje = (d) => d && ano === hoje.getFullYear() && mes === hoje.getMonth() && d === hoje.getDate();

  // Semana atual
  const inicioSemana = new Date(hoje); inicioSemana.setDate(hoje.getDate() - hoje.getDay());
  const diasSemana = Array.from({ length: 7 }, (_, i) => { const d = new Date(inicioSemana); d.setDate(inicioSemana.getDate() + i); return d; });

  // Próximos eventos (lista)
  const proximos = [...eventosFiltrados].filter(e => e.data >= hoje.toISOString().split("T")[0]).sort((a, b) => a.data.localeCompare(b.data));
  const passados = [...eventosFiltrados].filter(e => e.data < hoje.toISOString().split("T")[0]).sort((a, b) => b.data.localeCompare(a.data));

  // Detalhe do dia selecionado
  const eventosDia = diaDetalhe ? eventosNoDia(diaDetalhe) : [];

  return (
    <div className="fade">
      {/* Header do calendário */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => navMes(-1)} style={{ width: 34, height: 34, borderRadius: 8, border: `1px solid ${T.border}`, background: "transparent", color: T.text, cursor: "pointer", fontSize: 16 }}>‹</button>
          <div style={{ fontSize: 18, fontWeight: 800, minWidth: 200, textAlign: "center" }}>{MESES[mes]} {ano}</div>
          <button onClick={() => navMes(1)} style={{ width: 34, height: 34, borderRadius: 8, border: `1px solid ${T.border}`, background: "transparent", color: T.text, cursor: "pointer", fontSize: 16 }}>›</button>
          <button onClick={() => { setMes(hoje.getMonth()); setAno(hoje.getFullYear()); }} style={{ padding: "6px 14px", borderRadius: 8, border: `1px solid ${T.border}`, background: "transparent", color: T.muted, cursor: "pointer", fontSize: 12 }}>Hoje</button>
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          {/* Filtro especialista */}
          {isAdmin && (
            <select value={filtroEsp} onChange={e => setFiltroEsp(e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "7px 12px", fontSize: 12, outline: "none", cursor: "pointer" }}>
              <option value="todos">Todos especialistas</option>
              {especialistas.filter(e => e.status !== "Inativo").map(e => <option key={e.id} value={e.id}>{e.nome.split(" ")[0]} {e.nome.split(" ").slice(-1)}</option>)}
            </select>
          )}
          {/* Filtro projeto */}
          <select value={filtroProjeto} onChange={e => setFiltroProjeto(e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "7px 12px", fontSize: 12, outline: "none", cursor: "pointer" }}>
            <option value="todos">Todos os projetos</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
          {/* Filtro tipo agenda */}
          <select value={filtroTipoAgenda} onChange={e => setFiltroTipoAgenda(e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, color: filtroTipoAgenda === "Estratégia" ? T.laranja : filtroTipoAgenda === "Projeto" ? T.azul : T.text, padding: "7px 12px", fontSize: 12, outline: "none", cursor: "pointer", fontWeight: filtroTipoAgenda !== "todos" ? 700 : 400 }}>
            <option value="todos">Estratégia + Projeto</option>
            <option value="Estratégia">🔶 Somente Estratégia</option>
            <option value="Projeto">🔵 Somente Projeto</option>
          </select>
          {/* Botão limpar filtros */}
          {(filtroEsp !== "todos" || filtroProjeto !== "todos" || filtroTipoAgenda !== "todos") && (
            <button onClick={() => { setFiltroEsp("todos"); setFiltroProjeto("todos"); setFiltroTipoAgenda("todos"); }} style={{ padding: "7px 12px", borderRadius: 8, border: `1px solid ${T.danger}44`, background: `${T.danger}18`, color: T.danger, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>✕ Limpar filtros</button>
          )}
          {/* Views */}
          <div style={{ display: "flex", background: T.card, borderRadius: 8, border: `1px solid ${T.border}`, overflow: "hidden" }}>
            {[{ id: "mes", label: "Mês" }, { id: "semana", label: "Semana" }, { id: "lista", label: "Lista" }].map(v => (
              <button key={v.id} onClick={() => setView(v.id)} style={{ padding: "7px 14px", border: "none", background: view === v.id ? `linear-gradient(135deg,${T.laranja},${T.laranjaM})` : "transparent", color: view === v.id ? "#fff" : T.muted, fontSize: 12, fontWeight: view === v.id ? 700 : 400, cursor: "pointer" }}>{v.label}</button>
            ))}
          </div>
          <button onClick={() => exportarICS(eventosFiltrados, clientes, especialistas)} style={{ padding: "7px 14px", borderRadius: 8, background: T.cardL, border: `1px solid ${T.border}`, color: T.muted, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>📅 Exportar Outlook</button>
          <button onClick={() => onNovaVisita(dataStr(hoje.getDate()))} style={{ padding: "7px 14px", borderRadius: 8, background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Agendar</button>
        </div>
      </div>

      {/* Legenda especialistas */}
      {isAdmin && (
        <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
          {especialistas.filter(e => e.status !== "Inativo").map(e => (
            <div key={e.id} onClick={() => setFiltroEsp(filtroEsp === e.id ? "todos" : e.id)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: 20, border: `1px solid ${filtroEsp === e.id ? corEsp(e.id) : T.border}`, background: filtroEsp === e.id ? `${corEsp(e.id)}22` : "transparent", cursor: "pointer", transition: "all 0.15s" }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: corEsp(e.id), flexShrink: 0 }} />
              <span style={{ fontSize: 11, color: filtroEsp === e.id ? corEsp(e.id) : T.muted, fontWeight: filtroEsp === e.id ? 700 : 400 }}>{e.nome.split(" ")[0]}</span>
            </div>
          ))}
          <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: 20, border: `1px solid ${T.border}` }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: T.danger, flexShrink: 0 }} />
            <span style={{ fontSize: 11, color: T.muted }}>Marco urgente</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: 20, border: `1px solid ${T.border}` }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: T.warning, flexShrink: 0 }} />
            <span style={{ fontSize: 11, color: T.muted }}>Marco prazo</span>
          </div>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: diaDetalhe ? "1fr 320px" : "1fr", gap: 18 }}>
        <div>
          {/* ── VIEW MÊS ── */}
          {view === "mes" && (
            <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}>
              {/* Cabeçalho dias */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", borderBottom: `1px solid ${T.border}` }}>
                {DIAS_SEMANA.map(d => (
                  <div key={d} style={{ padding: "10px 6px", textAlign: "center", fontSize: 11, fontWeight: 700, color: T.muted, borderRight: `1px solid ${T.border}22` }}>{d}</div>
                ))}
              </div>
              {/* Grid de dias */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)" }}>
                {celulas.map((dia, idx) => {
                  const ds = dataStr(dia);
                  const evs = dia ? eventosNoDia(ds) : [];
                  const selecionado = ds === diaDetalhe;
                  return (
                    <div key={idx} onClick={() => dia && setDiaDetalhe(selecionado ? null : ds)} style={{
                      minHeight: 90, padding: "6px 6px 4px", borderRight: `1px solid ${T.border}22`, borderBottom: `1px solid ${T.border}22`,
                      background: selecionado ? `${T.laranja}18` : isHoje(dia) ? `${T.azul}12` : "transparent",
                      cursor: dia ? "pointer" : "default", transition: "background 0.15s",
                    }}>
                      {dia && (
                        <>
                          <div style={{ fontSize: 12, fontWeight: isHoje(dia) ? 900 : 500, color: isHoje(dia) ? T.laranja : selecionado ? T.laranjaM : T.text, width: 24, height: 24, borderRadius: "50%", background: isHoje(dia) ? `${T.laranja}22` : "transparent", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>{dia}</div>
                          <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            {evs.slice(0, 3).map((ev, i) => (
                              <div key={i} style={{ background: `${ev.cor}33`, borderLeft: `2px solid ${ev.cor}`, borderRadius: "0 4px 4px 0", padding: "2px 4px", fontSize: 10, fontWeight: 600, color: ev.cor, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {ev.tipo === "tarefa" ? "✅ " : ""}{ev.titulo}
                              </div>
                            ))}
                            {evs.length > 3 && <div style={{ fontSize: 10, color: T.muted, paddingLeft: 4 }}>+{evs.length - 3} mais</div>}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ── VIEW SEMANA ── */}
          {view === "semana" && (
            <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", borderBottom: `1px solid ${T.border}` }}>
                {diasSemana.map((d, i) => {
                  const ds = d.toISOString().split("T")[0];
                  const isH = ds === hoje.toISOString().split("T")[0];
                  return (
                    <div key={i} style={{ padding: "12px 8px", textAlign: "center", borderRight: `1px solid ${T.border}22`, background: isH ? `${T.azul}12` : "transparent" }}>
                      <div style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>{DIAS_SEMANA[i]}</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: isH ? T.laranja : T.text }}>{d.getDate()}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", minHeight: 300 }}>
                {diasSemana.map((d, i) => {
                  const ds = d.toISOString().split("T")[0];
                  const evs = eventosFiltrados.filter(e => e.data === ds);
                  const isH = ds === hoje.toISOString().split("T")[0];
                  return (
                    <div key={i} onClick={() => setDiaDetalhe(diaDetalhe === ds ? null : ds)} style={{ padding: "8px 6px", borderRight: `1px solid ${T.border}22`, background: isH ? `${T.azul}08` : "transparent", cursor: "pointer", minHeight: 120 }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {evs.map((ev, j) => (
                          <div key={j} style={{ background: `${ev.cor}28`, border: `1px solid ${ev.cor}44`, borderRadius: 6, padding: "5px 7px" }}>
                            <div style={{ fontSize: 10, fontWeight: 700, color: ev.cor, marginBottom: 2 }}>{ev.tipo === "tarefa" ? "✅" : "📅"} {ev.titulo}</div>
                            <div style={{ fontSize: 9, color: T.muted }}>{ev.sub}</div>
                          </div>
                        ))}
                        {evs.length === 0 && <div style={{ fontSize: 10, color: `${T.muted}44`, textAlign: "center", marginTop: 20 }}>—</div>}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ── VIEW LISTA ── */}
          {view === "lista" && (
            <div>
              {proximos.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: T.laranja }}>📅 Próximos eventos ({proximos.length})</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {proximos.map(ev => (
                      <div key={ev.id} onClick={() => ev.tipo === "visita" && onEditVisita(ev.raw)} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, borderLeft: `4px solid ${ev.cor}`, cursor: ev.tipo === "visita" ? "pointer" : "default" }}>
                        <div style={{ textAlign: "center", minWidth: 44 }}>
                          <div style={{ fontSize: 18, fontWeight: 900, color: ev.cor }}>{new Date(ev.data + "T12:00:00").getDate()}</div>
                          <div style={{ fontSize: 9, color: T.muted }}>{MESES[new Date(ev.data + "T12:00:00").getMonth()].substring(0, 3)}</div>
                        </div>
                        <div style={{ width: 1, height: 36, background: T.border }} />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 700 }}>{ev.titulo}</div>
                          <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{ev.sub}</div>
                        </div>
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                          <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 4, background: `${ev.cor}22`, color: ev.cor, fontWeight: 700 }}>{ev.tipo === "tarefa" ? "Tarefa" : ev.raw?.tipo}</span>
                          {ev.tipo === "visita" && <span style={{ fontSize: 10, color: T.muted }}>{fmtDate(ev.data)}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {passados.length > 0 && (
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: T.muted }}>✅ Realizados ({passados.length})</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {passados.slice(0, 10).map(ev => (
                      <div key={ev.id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "10px 16px", background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, opacity: 0.7 }}>
                        <div style={{ fontSize: 11, color: T.muted, minWidth: 70 }}>{fmtDate(ev.data)}</div>
                        <div style={{ width: 6, height: 6, borderRadius: "50%", background: ev.cor, flexShrink: 0 }} />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 600 }}>{ev.titulo}</div>
                          <div style={{ fontSize: 10, color: T.muted }}>{ev.sub}</div>
                        </div>
                        <span style={{ fontSize: 10, color: T.success }}>✓</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {proximos.length === 0 && passados.length === 0 && (
                <div style={{ textAlign: "center", padding: 48, color: T.muted, fontSize: 13 }}>Nenhum evento encontrado.</div>
              )}
            </div>
          )}

          {/* Resumo do mês */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginTop: 18 }}>
            {[
            { label: "Atendimentos no mês", val: eventosFiltrados.filter(e => e.tipo === "visita" && e.data?.startsWith(`${ano}-${fmt2(mes + 1)}`)).length, cor: T.laranja },
              { label: "Estratégia", val: eventosFiltrados.filter(e => e.tipo === "visita" && e.data?.startsWith(`${ano}-${fmt2(mes + 1)}`) && e.raw?.tipoAgenda === "Estratégia").length, cor: T.laranjaM },
              { label: "Projeto", val: eventosFiltrados.filter(e => e.tipo === "visita" && e.data?.startsWith(`${ano}-${fmt2(mes + 1)}`) && (e.raw?.tipoAgenda === "Projeto" || !e.raw?.tipoAgenda)).length, cor: T.azul },
              { label: "Tarefas no mês", val: eventosFiltrados.filter(e => e.tipo === "tarefa" && e.data?.startsWith(`${ano}-${fmt2(mes + 1)}`)).length, cor: T.warning },
            ].map((s, i) => (
              <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: "12px 16px", textAlign: "center" }}>
                <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ── PAINEL DETALHE DO DIA ── */}
        {diaDetalhe && (
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 20, height: "fit-content", position: "sticky", top: 80 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800 }}>{new Date(diaDetalhe + "T12:00:00").toLocaleDateString("pt-BR", { weekday: "long" })}</div>
                <div style={{ fontSize: 12, color: T.muted }}>{fmtDate(diaDetalhe)}</div>
              </div>
              <button onClick={() => setDiaDetalhe(null)} style={{ background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 16 }}>✕</button>
            </div>

            {eventosDia.length === 0 ? (
              <div style={{ textAlign: "center", padding: "24px 0", color: T.muted, fontSize: 13 }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>📭</div>
                Nenhum evento neste dia
                <div style={{ marginTop: 14 }}>
                  <button onClick={() => onNovaVisita(diaDetalhe)} style={{ padding: "8px 16px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Agendar visita</button>
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {eventosDia.map(ev => (
                  <div key={ev.id} onClick={() => ev.tipo === "visita" && onEditVisita(ev.raw)} style={{ padding: "12px 14px", background: T.cardL, borderRadius: 10, borderLeft: `3px solid ${ev.cor}`, cursor: ev.tipo === "visita" ? "pointer" : "default" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                      <div style={{ fontSize: 12, fontWeight: 800, color: ev.cor }}>{ev.tipo === "tarefa" ? "✅" : "📅"} {ev.titulo}</div>
                      <span style={{ fontSize: 9, padding: "2px 6px", borderRadius: 4, background: `${ev.cor}22`, color: ev.cor, fontWeight: 700, flexShrink: 0, marginLeft: 6 }}>{ev.tipo === "visita" ? ev.raw?.tipo : "Marco"}</span>
                    </div>
                    <div style={{ fontSize: 11, color: T.muted }}>{ev.sub}</div>
                    {ev.tipo === "visita" && (
                      <div style={{ marginTop: 6, display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 10, padding: "2px 7px", borderRadius: 4, background: ev.raw?.tipoAgenda === "Estratégia" ? `${T.laranja}22` : `${T.azul}22`, color: ev.raw?.tipoAgenda === "Estratégia" ? T.laranja : T.azul, fontWeight: 700 }}>{ev.raw?.tipoAgenda || "Projeto"}</span>
                        <span style={{ fontSize: 10, color: T.muted }}>⏱ {ev.raw?.duracao}h</span>
                        <span style={{ fontSize: 10, color: ev.raw?.status === "Realizada" ? T.success : T.laranjaM, fontWeight: 600 }}>{ev.raw?.status}</span>
                      </div>
                    )}
                    {ev.tipo === "tarefa" && (
                      <div style={{ marginTop: 6 }}>
                        <span style={{ fontSize: 10, color: ev.cor, fontWeight: 600 }}>{ev.raw?.status} · {ev.raw?.responsavel || ""}</span>
                      </div>
                    )}
                  </div>
                ))}
                <button onClick={() => onNovaVisita(diaDetalhe)} style={{ padding: "8px", background: "transparent", border: `1px dashed ${T.border}`, borderRadius: 8, color: T.muted, fontSize: 12, cursor: "pointer", marginTop: 4 }}>+ Agendar visita neste dia</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── DMG MODULE ───────────────────────────────────────────────────────────────
// ─── DPS — DIAGNÓSTICO DE PERFORMANCE SETORIAL ───────────────────────────────
const DPS_PILARES = [
  "Liderança", "Comunicação", "Planejamento", "Organização",
  "Integração", "Tecnologia", "Desenvolvimento", "Gestão e Melhoria"
];

const DPS_CORES = {
  1: "#ef4444", 2: "#f97316", 3: "#eab308", 4: "#22c55e", 5: "#3b82f6"
};

const DPS_NIVEL_LABEL = {
  1: "Inicial", 2: "Em desenvolvimento", 3: "Funcional", 4: "Avançado", 5: "Referência"
};

function DPSModule({ clientes, dpsData, especialistas, consultores, usuarioLogado, onSave, onDelete, isGestor }) {
  const [clienteSel, setClienteSel] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [modalRelatorio, setModalRelatorio] = useState(null); // { clienteId, apps }

  const aplicacoesDoCli = (cliId) => (dpsData || []).filter(d => d.clienteId === cliId).sort((a, b) => b.data?.localeCompare(a.data));
  const clientesComDps = clientes.filter(c => aplicacoesDoCli(c.id).length > 0);
  const clientesFiltrados_ = filtroCliente ? clientes.filter(c => c.id === filtroCliente) : clientesComDps;

  const mediaGeral = (apps) => {
    if (!apps.length) return 0;
    const scores = apps.map(a => {
      const pilares = a.pilares || {};
      const vals = DPS_PILARES.map(p => pilares[p]?.nivel || 0).filter(v => v > 0);
      return vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : 0;
    });
    return Math.round((scores.reduce((s, v) => s + v, 0) / scores.length) * 10) / 10;
  };

  const corNivel = (n) => DPS_CORES[n] || T.muted;
  const labelNivel = (n) => DPS_NIVEL_LABEL[n] || "—";



  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 800 }}>◈ Diagnóstico de Performance Setorial</div>
          <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>Avalie a maturidade dos setores em 8 pilares — acompanhe a evolução ao longo do projeto</div>
        </div>
        <Btn onClick={() => { setEditando(null); setClienteSel(""); setShowForm(true); }}>+ Nova Aplicação</Btn>
      </div>

      {/* Filtro por cliente */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Empresa:</span>
        <button onClick={() => setFiltroCliente("")}
          style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "none",
            background: !filtroCliente ? T.laranja : T.cardL, color: !filtroCliente ? "#fff" : T.muted }}>
          Todas ({clientesComDps.length})
        </button>
        {clientesComDps.map(c => (
          <button key={c.id} onClick={() => setFiltroCliente(c.id === filtroCliente ? "" : c.id)}
            style={{ padding: "5px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "none",
              background: filtroCliente === c.id ? T.laranja : T.cardL, color: filtroCliente === c.id ? "#fff" : T.muted }}>
            {c.nome}
          </button>
        ))}
      </div>

      {/* Modal form DPS */}
      {showForm && (
        <ModalWrap title={editando?.id ? "Editar Aplicação DPS" : "Nova Aplicação DPS"} onClose={() => { setShowForm(false); setEditando(null); }} maxWidth={780}>
          <FormDPS
            data={editando}
            clientes={clientes}
            clientePreSel={clienteSel}
            especialistas={especialistas}
            consultores={consultores}
            usuarioLogado={usuarioLogado}
            onSave={async (d) => { await onSave(d); setShowForm(false); setEditando(null); }}
            onClose={() => { setShowForm(false); setEditando(null); }}
          />
        </ModalWrap>
      )}

      {/* Modal de relatório */}
      {modalRelatorio && (
        <ModalRelDPS
          cliente={clientes.find(c => c.id === modalRelatorio.clienteId)}
          apps={modalRelatorio.apps}
          especialistas={especialistas}
          consultores={consultores}
          onClose={() => setModalRelatorio(null)}
        />
      )}

      {/* Lista de clientes com aplicações */}
      {clientesFiltrados_.length === 0 ? (
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: "48px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>◈</div>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>Nenhuma aplicação ainda</div>
          <div style={{ fontSize: 12, color: T.muted, marginBottom: 20 }}>Aplique o DPS em um setor do cliente para começar a acompanhar a evolução.</div>
          <Btn onClick={() => { setEditando(null); setClienteSel(""); setShowForm(true); }}>+ Nova Aplicação</Btn>
        </div>
      ) : clientesFiltrados_.map(cliente => {
        const apps = aplicacoesDoCli(cliente.id);
        const setores = [...new Set(apps.map(a => a.setor).filter(Boolean))];
        const ultimaApp = apps[0];
        const media = mediaGeral(apps);

        return (
          <div key={cliente.id} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, overflow: "hidden" }}>
            {/* Header cliente */}
            <div style={{ padding: "16px 22px", borderBottom: `1px solid ${T.border}`, background: `${T.laranja}08`,
              display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800 }}>{cliente.nome}</div>
                <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>
                  {apps.length} aplicação(ões) · {setores.length} setor(es) avaliado(s)
                  {ultimaApp ? ` · Última: ${new Date(ultimaApp.data + "T12:00:00").toLocaleDateString("pt-BR")}` : ""}
                </div>
              </div>
              <div style={{ display: "flex", gap: 12, alignItems: "center", flexShrink: 0 }}>
                {media > 0 && (
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 10, color: T.muted, textTransform: "uppercase", letterSpacing: "0.5px" }}>MÉDIA GERAL</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: corNivel(Math.round(media)) }}>{media.toFixed(1)}</div>
                  </div>
                )}
                <button onClick={() => setModalRelatorio({ clienteId: cliente.id, apps })}
                  style={{ padding: "7px 14px", borderRadius: 8, background: "#0F2035", border: "2px solid #0075EA",
                    color: "#0075EA", fontSize: 12, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }}>
                  📊 Relatório
                </button>
                <Btn small onClick={() => { setClienteSel(cliente.id); setEditando(null); setShowForm(true); }}>+ Aplicar</Btn>
              </div>
            </div>

            {/* Aplicações por setor */}
            <div style={{ padding: "14px 22px", display: "flex", flexDirection: "column", gap: 12 }}>
              {setores.map(setor => {
                const appsSetor = apps.filter(a => a.setor === setor);
                return (
                  <div key={setor}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: T.laranjaM, marginBottom: 8 }}>📂 {setor}</div>
                    {appsSetor.map((app, i) => {
                      const pilares = app.pilares || {};
                      const mediaPilares = DPS_PILARES.map(p => pilares[p]?.nivel || 0).filter(v => v > 0);
                      const mediaApp = mediaPilares.length ? (mediaPilares.reduce((s, v) => s + v, 0) / mediaPilares.length) : 0;
                      const resp = especialistas.find(e => e.id === app.especialistaId) ||
                                   consultores.find(c => c.id === app.consultorId);
                      return (
                        <div key={i} style={{ background: T.cardL, borderRadius: 10, padding: "12px 16px", marginBottom: 8,
                          borderLeft: `4px solid ${corNivel(Math.round(mediaApp))}` }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                                <span style={{ fontSize: 12, fontWeight: 700 }}>
                                  {new Date(app.data + "T12:00:00").toLocaleDateString("pt-BR")}
                                </span>
                                {mediaApp > 0 && (
                                  <span style={{ fontSize: 11, fontWeight: 800, color: corNivel(Math.round(mediaApp)),
                                    background: `${corNivel(Math.round(mediaApp))}18`, borderRadius: 6, padding: "2px 8px" }}>
                                    Média {mediaApp.toFixed(1)} — {labelNivel(Math.round(mediaApp))}
                                  </span>
                                )}
                                {resp && <span style={{ fontSize: 11, color: T.muted }}>👤 {resp.nome.split(" ")[0]}</span>}
                              </div>
                              {/* Radar compacto em linha */}
                              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                {DPS_PILARES.map(p => {
                                  const n = pilares[p]?.nivel || 0;
                                  return (
                                    <div key={p} title={`${p}: Nível ${n} — ${labelNivel(n)}`}
                                      style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                                      <div style={{ width: 28, height: 28, borderRadius: 6, background: n ? corNivel(n) : T.border,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: 12, fontWeight: 900, color: n ? "#fff" : T.muted }}>
                                        {n || "—"}
                                      </div>
                                      <div style={{ fontSize: 8, color: T.muted, textAlign: "center", maxWidth: 32, lineHeight: 1.1 }}>
                                        {p.split(" ")[0]}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              {/* Evolução do setor se houver mais de 1 aplicação */}
                              {appsSetor.length > 1 && i === 0 && (() => {
                                const appAnterior = appsSetor[1];
                                const pilaresAnt = appAnterior.pilares || {};
                                const mediaAnt = DPS_PILARES.map(p => pilaresAnt[p]?.nivel || 0).filter(v => v > 0);
                                const mediaAntVal = mediaAnt.length ? mediaAnt.reduce((s, v) => s + v, 0) / mediaAnt.length : 0;
                                const delta = mediaApp - mediaAntVal;
                                if (delta !== 0) return (
                                  <div style={{ marginTop: 6, fontSize: 11, color: delta > 0 ? T.success : T.danger, fontWeight: 700 }}>
                                    {delta > 0 ? "▲" : "▼"} {Math.abs(delta).toFixed(1)} ponto(s) em relação à aplicação anterior
                                  </div>
                                );
                                return null;
                              })()}
                            </div>
                            <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                              <Btn small variant="ghost" onClick={() => { setEditando(app); setShowForm(true); }}>✏️</Btn>
                              {isGestor && <Btn small variant="ghost" style={{ color: T.danger }} onClick={() => onDelete(app.id)}>🗑️</Btn>}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function FormDPS({ data, clientes, clientePreSel, especialistas, consultores, usuarioLogado, onSave, onClose }) {
  const hoje = new Date().toISOString().split("T")[0];
  const [f, setF] = useState({
    clienteId: clientePreSel || "",
    setor: "",
    data: hoje,
    especialistaId: usuarioLogado?.id || "",
    consultorId: null,
    pilares: {},
    obs: "",
    ...(data || {})
  });
  const [salvando, setSalvando] = useState(false);
  const [pilarAtivo, setPilarAtivo] = useState(DPS_PILARES[0]);

  const setPilarNivel = (pilar, nivel) => setF(p => ({
    ...p, pilares: { ...p.pilares, [pilar]: { ...(p.pilares[pilar] || {}), nivel } }
  }));
  const setPilarCampo = (pilar, campo, val) => setF(p => ({
    ...p, pilares: { ...p.pilares, [pilar]: { ...(p.pilares[pilar] || {}), [campo]: val } }
  }));

  const pilaresCompletos = DPS_PILARES.filter(p => f.pilares[p]?.nivel).length;

  const DPS_NIVEL_DESC = {
    1: "Situação inicial, sem estrutura ou práticas consistentes.",
    2: "Algumas práticas existem, mas ainda inconsistentes.",
    3: "Funcional — atende a rotina com poucos problemas.",
    4: "Avançado — estruturado, com autonomia e bons resultados.",
    5: "Referência — cultura consolidada, melhoria contínua presente."
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 800 }}>◈ {data?.id ? "Editar" : "Nova"} Aplicação DPS</div>
          <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{pilaresCompletos}/8 pilares avaliados</div>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {/* Indicadores de pilares */}
          {DPS_PILARES.map(p => {
            const n = f.pilares[p]?.nivel || 0;
            return (
              <div key={p} onClick={() => setPilarAtivo(p)} title={p} style={{ width: 24, height: 24, borderRadius: 6, cursor: "pointer",
                background: n ? DPS_CORES[n] : T.border, border: pilarAtivo === p ? `2px solid #fff` : "2px solid transparent",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 800, color: n ? "#fff" : T.muted }}>
                {n || ""}
              </div>
            );
          })}
        </div>
      </div>

      {/* Dados gerais */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 20 }}>
        <div style={{ gridColumn: "1/-1" }}>
          <Field label="Cliente *" value={f.clienteId} onChange={v => setF(p => ({ ...p, clienteId: v }))}
            options={[{ val: "", label: "Selecionar..." }, ...clientes.map(c => ({ val: c.id, label: c.nome }))]} />
        </div>
        <Field label="Setor / Área avaliada *" value={f.setor} onChange={v => setF(p => ({ ...p, setor: v }))}
          placeholder="Ex: Comercial, Financeiro, Logística..." />
        <Field label="Data da aplicação *" value={f.data} onChange={v => setF(p => ({ ...p, data: v }))} type="date" />
        <Field label="Especialista responsável" value={f.especialistaId}
          onChange={v => setF(p => ({ ...p, especialistaId: v }))}
          options={[{ val: "", label: "Selecionar..." }, ...especialistas.map(e => ({ val: e.id, label: e.nome }))]} />
        {consultores.length > 0 && (
          <Field label="Consultor" value={f.consultorId || ""}
            onChange={v => setF(p => ({ ...p, consultorId: v || null }))}
            options={[{ val: "", label: "Nenhum" }, ...consultores.map(c => ({ val: c.id, label: c.nome }))]} />
        )}
      </div>

      {/* Avaliação por pilar */}
      <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: 16, marginBottom: 20 }}>
        {/* Sidebar pilares */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {DPS_PILARES.map(p => {
            const n = f.pilares[p]?.nivel || 0;
            const ativo = pilarAtivo === p;
            return (
              <button key={p} onClick={() => setPilarAtivo(p)} style={{
                padding: "8px 12px", borderRadius: 8, border: `1px solid ${ativo ? T.laranja : T.border}`,
                background: ativo ? `${T.laranja}15` : T.cardL, cursor: "pointer", textAlign: "left",
                display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 22, height: 22, borderRadius: 5, background: n ? DPS_CORES[n] : T.border,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 11, fontWeight: 900, color: n ? "#fff" : T.muted, flexShrink: 0 }}>
                  {n || "?"}
                </div>
                <span style={{ fontSize: 12, fontWeight: ativo ? 700 : 400, color: ativo ? T.laranja : T.text }}>
                  {p}
                </span>
              </button>
            );
          })}
        </div>

        {/* Área de avaliação do pilar ativo */}
        <div style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 12, padding: 18 }}>
          <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 4 }}>{pilarAtivo}</div>
          <div style={{ fontSize: 11, color: T.muted, marginBottom: 16 }}>
            Avalie o nível de maturidade deste pilar no setor:
          </div>

          {/* Seleção de nível */}
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {[1, 2, 3, 4, 5].map(n => {
              const sel = f.pilares[pilarAtivo]?.nivel === n;
              return (
                <button key={n} onClick={() => setPilarNivel(pilarAtivo, n)} style={{
                  flex: 1, padding: "12px 6px", borderRadius: 10, border: `2px solid ${sel ? DPS_CORES[n] : T.border}`,
                  background: sel ? `${DPS_CORES[n]}20` : T.card, cursor: "pointer" }}>
                  <div style={{ fontSize: 20, fontWeight: 900, color: sel ? DPS_CORES[n] : T.muted }}>{n}</div>
                  <div style={{ fontSize: 9, color: sel ? DPS_CORES[n] : T.muted, fontWeight: sel ? 700 : 400 }}>
                    {DPS_NIVEL_LABEL[n]}
                  </div>
                </button>
              );
            })}
          </div>

          {/* Descrição do nível */}
          {f.pilares[pilarAtivo]?.nivel && (
            <div style={{ fontSize: 11, color: T.muted, background: `${DPS_CORES[f.pilares[pilarAtivo].nivel]}10`,
              borderRadius: 8, padding: "8px 12px", marginBottom: 14, fontStyle: "italic" }}>
              {DPS_NIVEL_DESC[f.pilares[pilarAtivo].nivel]}
            </div>
          )}

          {/* Campos de registro */}
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              { campo: "evidencias", label: "Evidências observadas", placeholder: "O que foi visto/ouvido que sustenta esta avaliação..." },
              { campo: "riscos", label: "Riscos identificados", placeholder: "O que pode piorar ou gerar problemas futuros..." },
              { campo: "oportunidades", label: "Oportunidades de melhoria", placeholder: "O que pode ser trabalhado para evoluir este pilar..." },
            ].map(({ campo, label, placeholder }) => (
              <div key={campo}>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 4 }}>{label}</label>
                <textarea
                  value={f.pilares[pilarAtivo]?.[campo] || ""}
                  onChange={e => setPilarCampo(pilarAtivo, campo, e.target.value)}
                  placeholder={placeholder}
                  rows={2}
                  style={{ width: "100%", background: T.card, border: `1px solid ${T.border}`, borderRadius: 8,
                    color: T.text, padding: "8px 12px", fontSize: 12, outline: "none", resize: "vertical",
                    fontFamily: "inherit" }}
                />
              </div>
            ))}
          </div>

          {/* Navegação entre pilares */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14 }}>
            <Btn small variant="secondary"
              onClick={() => { const i = DPS_PILARES.indexOf(pilarAtivo); if (i > 0) setPilarAtivo(DPS_PILARES[i-1]); }}
              disabled={DPS_PILARES.indexOf(pilarAtivo) === 0}>
              ← Anterior
            </Btn>
            <Btn small
              onClick={() => { const i = DPS_PILARES.indexOf(pilarAtivo); if (i < 7) setPilarAtivo(DPS_PILARES[i+1]); }}
              disabled={DPS_PILARES.indexOf(pilarAtivo) === 7}>
              Próximo →
            </Btn>
          </div>
        </div>
      </div>

      {/* Observações gerais */}
      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 6 }}>
          Observações gerais da aplicação
        </label>
        <textarea
          value={f.obs || ""}
          onChange={e => setF(p => ({ ...p, obs: e.target.value }))}
          placeholder="Contexto geral, percepções sobre a equipe, condições da visita..."
          rows={3}
          style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8,
            color: T.text, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit" }}
        />
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn
          disabled={salvando || !f.clienteId || !f.setor || !f.data}
          onClick={async () => {
            if (salvando) return;
            setSalvando(true);
            try { await onSave(f); } finally { setSalvando(false); }
          }}>
          {salvando ? "⏳ Salvando..." : `✅ Salvar DPS (${pilaresCompletos}/8 pilares)`}
        </Btn>
      </div>
    </>
  );
}


// ─── MODAL + RELATÓRIO DPS ────────────────────────────────────────────────────
function ModalRelDPS({ cliente, apps, especialistas, consultores, onClose }) {
  const setores = [...new Set(apps.map(a => a.setor).filter(Boolean))];
  const [setor, setSetor] = useState(setores[0] || "");
  const appsSetor = apps.filter(a => a.setor === setor).sort((a, b) => a.data?.localeCompare(b.data));

  const [idxA, setIdxA] = useState(0);
  const [idxB, setIdxB] = useState(Math.max(appsSetor.length - 1, 0));

  // Recalcular idxB quando mudar setor
  const appsSetorAtual = apps.filter(a => a.setor === setor).sort((a, b) => a.data?.localeCompare(b.data));
  const appA = appsSetorAtual[idxA];
  const appB = appsSetorAtual[idxB];

  const DPS_CORES_PDF = { 1: "#ef4444", 2: "#f97316", 3: "#eab308", 4: "#22c55e", 5: "#3b82f6" };
  const DPS_NIVEL_LABEL_PDF = { 1: "Inicial", 2: "Em desenvolvimento", 3: "Funcional", 4: "Avançado", 5: "Referência" };

  const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR") : "—";

  const mediaNivel = (app) => {
    if (!app) return 0;
    const vals = DPS_PILARES.map(p => app.pilares?.[p]?.nivel || 0).filter(v => v > 0);
    return vals.length ? Math.round((vals.reduce((s, v) => s + v, 0) / vals.length) * 10) / 10 : 0;
  };

  const descricaoNivel = (n) => {
    if (n >= 4.5) return "Excelente performance — o setor demonstra práticas consolidadas, com alto nível de autonomia e melhoria contínua.";
    if (n >= 3.5) return "Bom desempenho — processos bem estabelecidos com oportunidades pontuais de aprimoramento.";
    if (n >= 2.5) return "Performance em desenvolvimento — existem boas bases, mas ainda há inconsistências que precisam de atenção.";
    if (n >= 1.5) return "Nível inicial — o setor opera de forma reativa, com pouca estrutura e alto potencial de evolução.";
    return "Situação crítica — intervenção prioritária necessária para estabelecer práticas mínimas de gestão.";
  };

  const descricaoPilar = (pilar, nivelA, nivelB) => {
    const delta = nivelB - nivelA;
    const labelB = DPS_NIVEL_LABEL_PDF[Math.round(nivelB)] || "—";
    const base = nivelB >= 4 ? `Nível de referência em ${pilar.toLowerCase()}` :
                 nivelB >= 3 ? `Performance funcional em ${pilar.toLowerCase()}` :
                 nivelB >= 2 ? `${pilar} em desenvolvimento` :
                 `${pilar} em estágio inicial`;
    if (!nivelA) return `${base} (${labelB}).`;
    if (delta > 0) return `${base} — evolução de +${delta.toFixed(1)} ponto(s) em relação à avaliação anterior (${labelB}).`;
    if (delta < 0) return `${base} — queda de ${Math.abs(delta).toFixed(1)} ponto(s) em relação à avaliação anterior (${labelB}).`;
    return `${base} — desempenho estável em relação à avaliação anterior (${labelB}).`;
  };

  const gerarPDF = () => {
    if (!appB) return;
    const medA = appA ? mediaNivel(appA) : null;
    const medB = mediaNivel(appB);
    const respA = appA ? (especialistas.find(e => e.id === appA.especialistaId) || consultores.find(c => c.id === appA.consultorId)) : null;
    const respB = especialistas.find(e => e.id === appB.especialistaId) || consultores.find(c => c.id === appB.consultorId);

    // Gerar barras SVG comparativas
    const barWidth = 420;
    const barrasSVG = DPS_PILARES.map((p, i) => {
      const nA = appA ? (appA.pilares?.[p]?.nivel || 0) : null;
      const nB = appB.pilares?.[p]?.nivel || 0;
      const corA = nA ? DPS_CORES_PDF[nA] : "#e5e7eb";
      const corB = DPS_CORES_PDF[nB] || "#e5e7eb";
      const largA = nA ? (nA / 5) * barWidth : 0;
      const largB = (nB / 5) * barWidth;
      const y = i * 62;
      return `
        <g transform="translate(0,${y})">
          <text x="0" y="13" font-size="11" font-weight="600" fill="#374151">${p}</text>
          ${appA ? `
          <rect x="0" y="20" width="${largA}" height="14" fill="${corA}" rx="4" opacity="0.55"/>
          <text x="${largA + 6}" y="31" font-size="10" fill="${corA}" font-weight="700">${nA} — ${DPS_NIVEL_LABEL_PDF[nA] || ""}</text>
          ` : ""}
          <rect x="0" y="${appA ? 38 : 20}" width="${largB}" height="14" fill="${corB}" rx="4"/>
          <text x="${largB + 6}" y="${appA ? 49 : 31}" font-size="10" fill="${corB}" font-weight="700">${nB} — ${DPS_NIVEL_LABEL_PDF[nB] || ""}</text>
        </g>`;
    }).join("");

    const alturaGrafico = DPS_PILARES.length * 62 + 20;

    // Tabela de análise por pilar
    const tabelaPilares = DPS_PILARES.map(p => {
      const nA = appA ? (appA.pilares?.[p]?.nivel || 0) : null;
      const nB = appB.pilares?.[p]?.nivel || 0;
      const delta = nA ? nB - nA : null;
      const seta = delta === null ? "" : delta > 0 ? `<span style="color:#22c55e">▲ +${delta.toFixed(1)}</span>` :
                   delta < 0 ? `<span style="color:#ef4444">▼ ${delta.toFixed(1)}</span>` :
                   `<span style="color:#6b7280">= 0</span>`;
      const corB = DPS_CORES_PDF[nB] || "#9ca3af";
      const evA = nA ? `<b style="color:${DPS_CORES_PDF[nA]}">${nA}</b> ${DPS_NIVEL_LABEL_PDF[nA] || ""}` : "—";
      return `<tr>
        <td style="font-weight:600">${p}</td>
        <td style="text-align:center">${evA}</td>
        <td style="text-align:center"><b style="color:${corB}">${nB}</b> ${DPS_NIVEL_LABEL_PDF[nB] || ""}</td>
        <td style="text-align:center">${seta}</td>
        <td style="font-size:10px;color:#6b7280">${descricaoPilar(p, nA, nB)}</td>
      </tr>`;
    }).join("");

    // Seção de observações por pilar
    const obsSecoes = DPS_PILARES.filter(p => {
      const pil = appB.pilares?.[p];
      return pil && (pil.evidencias || pil.riscos || pil.oportunidades);
    }).map(p => {
      const pil = appB.pilares[p];
      const n = pil.nivel || 0;
      return `
        <div style="margin-bottom:16px;padding:14px;background:#f9fafb;border-radius:8px;border-left:4px solid ${DPS_CORES_PDF[n] || "#9ca3af"}">
          <div style="font-size:12px;font-weight:800;color:${DPS_CORES_PDF[n] || "#374151"};margin-bottom:8px">${p} — Nível ${n} (${DPS_NIVEL_LABEL_PDF[n] || ""})</div>
          ${pil.evidencias ? `<div style="margin-bottom:6px"><span style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase">Evidências</span><br/><span style="font-size:11px">${pil.evidencias}</span></div>` : ""}
          ${pil.riscos ? `<div style="margin-bottom:6px"><span style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase">Riscos</span><br/><span style="font-size:11px">${pil.riscos}</span></div>` : ""}
          ${pil.oportunidades ? `<div><span style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase">Oportunidades</span><br/><span style="font-size:11px">${pil.oportunidades}</span></div>` : ""}
        </div>`;
    }).join("");

    const html = `
      <!-- KPIs -->
      <div style="display:flex;gap:12px;margin-bottom:24px;flex-wrap:wrap">
        <div class="kpi" style="background:#f9fafb;border:1px solid #e5e7eb">
          <div class="kpi-val" style="color:#F44D19">${setor}</div>
          <div class="kpi-lab">Setor avaliado</div>
        </div>
        ${appA ? `<div class="kpi" style="background:#f9fafb;border:1px solid #e5e7eb">
          <div class="kpi-val" style="color:#6b7280">${medA?.toFixed(1)}</div>
          <div class="kpi-lab">Média — ${fmtDate(appA.data)}</div>
        </div>` : ""}
        <div class="kpi" style="background:#f9fafb;border:1px solid #e5e7eb">
          <div class="kpi-val" style="color:#F44D19">${medB.toFixed(1)}</div>
          <div class="kpi-lab">Média atual — ${fmtDate(appB.data)}</div>
        </div>
        ${appA && medA ? `<div class="kpi" style="background:${medB - medA >= 0 ? "#f0fdf4" : "#fef2f2"};border:1px solid ${medB - medA >= 0 ? "#bbf7d0" : "#fecaca"}">
          <div class="kpi-val" style="color:${medB - medA >= 0 ? "#22c55e" : "#ef4444"}">${medB - medA >= 0 ? "+" : ""}${(medB - medA).toFixed(1)}</div>
          <div class="kpi-lab">Variação</div>
        </div>` : ""}
      </div>

      <!-- Legenda do gráfico -->
      <div class="section-title">Desempenho por Pilar${appA ? " — Comparativo" : ""}</div>
      ${appA ? `<div style="display:flex;gap:20px;margin-bottom:10px;font-size:11px">
        <span><span style="display:inline-block;width:12px;height:12px;background:#9ca3af;border-radius:3px;opacity:0.55;margin-right:4px;vertical-align:middle"></span>${fmtDate(appA.data)} (anterior)</span>
        <span><span style="display:inline-block;width:12px;height:12px;background:#F44D19;border-radius:3px;margin-right:4px;vertical-align:middle"></span>${fmtDate(appB.data)} (atual)</span>
      </div>` : ""}

      <!-- Gráfico de barras SVG -->
      <div style="background:#f9fafb;border-radius:10px;padding:20px 24px;margin-bottom:24px;overflow:hidden">
        <svg width="100%" viewBox="0 0 680 ${alturaGrafico}" xmlns="http://www.w3.org/2000/svg">
          <!-- Linhas de grade -->
          ${[1,2,3,4,5].map(n => `
            <line x1="${(n/5)*barWidth}" y1="0" x2="${(n/5)*barWidth}" y2="${alturaGrafico}" stroke="#e5e7eb" stroke-width="1" stroke-dasharray="4,4"/>
            <text x="${(n/5)*barWidth}" y="${alturaGrafico - 2}" font-size="9" fill="#9ca3af" text-anchor="middle">${n}</text>
          `).join("")}
          <g transform="translate(0,0)">${barrasSVG}</g>
        </svg>
      </div>

      <!-- Tabela comparativa por pilar -->
      <div class="section-title">Análise Detalhada por Pilar</div>
      <table>
        <thead><tr>
          <th>Pilar</th>
          ${appA ? `<th style="text-align:center">Avaliação Anterior<br/><small style="font-weight:400;opacity:.8">${fmtDate(appA.data)}</small></th>` : ""}
          <th style="text-align:center">Avaliação Atual<br/><small style="font-weight:400;opacity:.8">${fmtDate(appB.data)}</small></th>
          ${appA ? `<th style="text-align:center">Variação</th>` : ""}
          <th>Diagnóstico</th>
        </tr></thead>
        <tbody>${tabelaPilares}</tbody>
      </table>

      <!-- Síntese final -->
      <div class="section-title">Síntese do Diagnóstico</div>
      <div style="background:#fff8f5;border-left:4px solid #F44D19;padding:16px 20px;border-radius:0 8px 8px 0;margin-bottom:20px;font-size:12px;line-height:1.7">
        <b>Performance geral do setor ${setor}:</b> ${descricaoNivel(medB)}
        ${appA && medA ? `<br/><br/><b>Evolução:</b> ${medB > medA ? `O setor avançou ${(medB - medA).toFixed(1)} ponto(s) desde a avaliação de ${fmtDate(appA.data)}, evidenciando que os direcionamentos da consultoria estão sendo incorporados à rotina da equipe.` :
          medB < medA ? `O setor recuou ${(medA - medB).toFixed(1)} ponto(s) desde a avaliação de ${fmtDate(appA.data)}. Este resultado merece atenção e pode indicar a necessidade de reforço nas orientações já realizadas.` :
          `O desempenho permaneceu estável desde a avaliação de ${fmtDate(appA.data)}, sugerindo consolidação das práticas atuais com espaço para avanços.`}` : ""}
        ${appB.obs ? `<br/><br/><b>Observações da aplicação:</b> ${appB.obs}` : ""}
      </div>

      <!-- Observações por pilar -->
      ${obsSecoes ? `<div class="section-title">Registros por Pilar — ${fmtDate(appB.data)}</div>${obsSecoes}` : ""}

      <!-- Rodapé de responsáveis -->
      <div style="margin-top:20px;font-size:11px;color:#6b7280;border-top:1px solid #e5e7eb;padding-top:12px">
        ${respB ? `Consultor responsável: <b>${respB.nome}</b>` : ""}
        ${respA && respA.id !== (respB?.id) ? ` · Avaliação anterior: <b>${respA.nome}</b>` : ""}
      </div>
    `;

    abrirRelatorio(`DPS — ${cliente?.nome} · ${setor}`, html);
  };

  return (
    <ModalWrap title={`Relatório DPS — ${cliente?.nome}`} onClose={onClose} maxWidth={560}>
      <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        {/* Seleção de setor */}
        {setores.length > 1 && (
          <div>
            <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 6 }}>Setor</label>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {setores.map(s => (
                <button key={s} onClick={() => { setSetor(s); setIdxA(0); setIdxB(Math.max(appsSetorAtual.length - 1, 0)); }}
                  style={{ padding: "6px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", border: "none",
                    background: setor === s ? T.laranja : T.cardL, color: setor === s ? "#fff" : T.muted }}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        {appsSetorAtual.length === 0 ? (
          <div style={{ color: T.muted, textAlign: "center", padding: 24 }}>Nenhuma aplicação neste setor.</div>
        ) : (
          <>
            {/* Seleção de aplicações */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <div>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 6 }}>
                  📅 Avaliação anterior (comparar com)
                </label>
                <select value={idxA} onChange={e => setIdxA(Number(e.target.value))}
                  style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8,
                    color: T.text, padding: "8px 12px", fontSize: 12, outline: "none" }}>
                  <option value={-1}>— Sem comparação —</option>
                  {appsSetorAtual.map((a, i) => (
                    <option key={i} value={i}>{fmtDate(a.data)} · Média {mediaNivel(a).toFixed(1)}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 6 }}>
                  📅 Avaliação atual (principal)
                </label>
                <select value={idxB} onChange={e => setIdxB(Number(e.target.value))}
                  style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8,
                    color: T.text, padding: "8px 12px", fontSize: 12, outline: "none" }}>
                  {appsSetorAtual.map((a, i) => (
                    <option key={i} value={i}>{fmtDate(a.data)} · Média {mediaNivel(a).toFixed(1)}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Preview das médias */}
            <div style={{ display: "flex", gap: 10 }}>
              {idxA >= 0 && appA && (
                <div style={{ flex: 1, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 10, padding: "12px 16px", textAlign: "center" }}>
                  <div style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>Anterior · {fmtDate(appA.data)}</div>
                  <div style={{ fontSize: 24, fontWeight: 900, color: DPS_CORES[Math.round(mediaNivel(appA))] || T.muted }}>{mediaNivel(appA).toFixed(1)}</div>
                  <div style={{ fontSize: 10, color: T.muted }}>{DPS_NIVEL_LABEL[Math.round(mediaNivel(appA))]}</div>
                </div>
              )}
              {appB && (
                <div style={{ flex: 1, background: `${T.laranja}10`, border: `1px solid ${T.laranja}44`, borderRadius: 10, padding: "12px 16px", textAlign: "center" }}>
                  <div style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>Atual · {fmtDate(appB?.data)}</div>
                  <div style={{ fontSize: 24, fontWeight: 900, color: DPS_CORES[Math.round(mediaNivel(appB))] || T.muted }}>{mediaNivel(appB).toFixed(1)}</div>
                  <div style={{ fontSize: 10, color: T.muted }}>{DPS_NIVEL_LABEL[Math.round(mediaNivel(appB))]}</div>
                </div>
              )}
              {idxA >= 0 && appA && appB && (
                <div style={{ flex: 1, background: (mediaNivel(appB) - mediaNivel(appA)) >= 0 ? "#f0fdf4" : "#fef2f2",
                  border: `1px solid ${(mediaNivel(appB) - mediaNivel(appA)) >= 0 ? "#bbf7d0" : "#fecaca"}`,
                  borderRadius: 10, padding: "12px 16px", textAlign: "center" }}>
                  <div style={{ fontSize: 10, color: T.muted, marginBottom: 4 }}>Variação</div>
                  <div style={{ fontSize: 24, fontWeight: 900, color: (mediaNivel(appB) - mediaNivel(appA)) >= 0 ? "#22c55e" : "#ef4444" }}>
                    {(mediaNivel(appB) - mediaNivel(appA)) >= 0 ? "+" : ""}{(mediaNivel(appB) - mediaNivel(appA)).toFixed(1)}
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
              <Btn onClick={gerarPDF}>📄 Gerar PDF</Btn>
            </div>
          </>
        )}
      </div>
    </ModalWrap>
  );
}


function DMGModule({ clientes, dmgData, onSaveDmg, onDeleteDmg }) {
  const [aba, setAba] = useState("painel");
  const [step, setStep] = useState(0);
  const [clienteSel, setClienteSel] = useState("");
  const [respostas, setRespostas] = useState({});
  const [analiseIA, setAnaliseIA] = useState(null);
  const [gerandoIA, setGerandoIA] = useState(false);
  const [analisesSalvas, setAnalisesSalvas] = useState({});

  const scorePilar = (p) => { const r = respostas[p] || {}; const vals = Object.values(r); if (!vals.length) return 0; return Math.round(vals.reduce((a, b) => a + b, 0) / DMG_PERGUNTAS[p].perguntas.length); };
  const scoreTotal = () => Math.round(DMG_PILARES.map(p => scorePilar(p)).reduce((a, b) => a + b, 0) / DMG_PILARES.length);
  const setResposta = (p, idx, val) => setRespostas(prev => ({ ...prev, [p]: { ...(prev[p] || {}), [idx]: val } }));

  const pilarAtual = step >= 1 && step <= 7 ? DMG_PILARES[step - 1] : null;
  const pilarInfo = pilarAtual ? DMG_PERGUNTAS[pilarAtual] : null;
  const respostasPilar = pilarAtual ? (respostas[pilarAtual] || {}) : {};
  const clienteComDmg = clientes.filter(c => dmgData[c.id]);

  // Carrega análises salvas do storage
  useEffect(() => {
    try {
      window.storage.get("lumen:dmg_analises").then(r => {
        if (r) setAnalisesSalvas(JSON.parse(r.value));
      }).catch(() => {});
    } catch {}
  }, []);

  const salvarAnalise = async (clienteId, analise) => {
    const updated = { ...analisesSalvas, [clienteId]: { ...analise, savedAt: new Date().toISOString() } };
    setAnalisesSalvas(updated);
    try { await window.storage.set("lumen:dmg_analises", JSON.stringify(updated)); } catch {}
  };

  const salvar = async () => {
    const scores = {}; DMG_PILARES.forEach(p => { scores[p] = scorePilar(p); });
    await onSaveDmg(clienteSel, scores, analiseIA);
    if (analiseIA) await salvarAnalise(clienteSel, { ...analiseIA, scores });
    setStep(0); setClienteSel(""); setRespostas({}); setAnaliseIA(null); setAba("painel");
  };

  const gerarAnaliseIA = async () => {
    setGerandoIA(true);
    const cliente = clientes.find(c => c.id === clienteSel);
    const scores = DMG_PILARES.map(p => ({ pilar: DMG_PERGUNTAS[p].label, score: scorePilar(p), nivel: scorePilar(p) >= 75 ? "AVANÇADO" : scorePilar(p) >= 60 ? "BOM" : scorePilar(p) >= 40 ? "REGULAR" : "CRÍTICO" }));
    const scoreGeral = scoreTotal();

    const prompt = `Você é um consultor especialista do Lumen Instituto, consultoria de gestão com o lema "Movidos pelo Resultado". Analise o resultado do Diagnóstico de Maturidade da Gestão (DMG) abaixo e gere um relatório em 4 tópicos com linguagem inspiradora, que provoca reflexão e orienta para a ação — como um consultor experiente falaria com o cliente.

EMPRESA: ${cliente?.nome || "Cliente"}
SEGMENTO: ${cliente?.segmento || ""}
SCORE GERAL: ${scoreGeral}% — ${scoreGeral >= 75 ? "AVANÇADO" : scoreGeral >= 60 ? "BOM" : scoreGeral >= 40 ? "REGULAR" : "CRÍTICO"}

SCORES POR PILAR:
${scores.map(s => `- ${s.pilar}: ${s.score}% (${s.nivel})`).join("\n")}

Gere exatamente 4 tópicos em JSON válido, sem markdown, no formato:
{
  "maturidade": "Texto do tópico MATURIDADE DE GESTÃO IDENTIFICADA (2-3 parágrafos, contextualiza o momento da empresa, o que o score revela sobre a cultura e a gestão)",
  "positivos": "Texto do tópico PONTOS POSITIVOS (destaque os 3-4 maiores pontos fortes identificados, com linguagem valorizadora e conectada aos pilares com maiores scores)",
  "melhoria": "Texto do tópico PONTOS DE MELHORIA (aponte as 3-4 principais lacunas de forma construtiva, sem julgamento, orientada para oportunidade)",
  "focal": "Texto do tópico PONTO FOCAL PARA MELHORIA (1 ponto prioritário — o que, se trabalhado agora, vai gerar maior impacto na evolução da gestão. Seja específico e inspirador)"
}`;

    try {
      const response = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_ANTHROPIC_API_KEY || "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",
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true",
        },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 4000,
          messages: [{ role: "user", content: prompt }]
        })
      });
      const data = await response.json();
      const texto = data.content?.map(i => i.text || "").join("") || "";
      const clean = texto.replace(/```json|```/g, "").trim();
      const parsed = JSON.parse(clean);
      setAnaliseIA(parsed);
    } catch (e) {
      setAnaliseIA({
        maturidade: "Não foi possível gerar a análise automaticamente. Verifique a conexão e tente novamente.",
        positivos: "", melhoria: "", focal: ""
      });
    }
    setGerandoIA(false);
  };

  const nivelLabel = (s) => s >= 75 ? "AVANÇADO" : s >= 60 ? "BOM" : s >= 40 ? "REGULAR" : "CRÍTICO";
  const nivelCor = (s) => s >= 75 ? T.success : s >= 60 ? T.laranjaM : s >= 40 ? T.warning : T.danger;

  return (
    <div className="fade">
      <div style={{ display: "flex", gap: 0, marginBottom: 24, background: T.card, borderRadius: 12, border: `1px solid ${T.border}`, padding: 4, width: "fit-content" }}>
        {[{ id: "painel", label: "📊 Painel de Diagnósticos" }, { id: "aplicar", label: "📋 Aplicar Diagnóstico" }].map(t => (
          <button key={t.id} onClick={() => { setAba(t.id); setStep(0); }} style={{ padding: "10px 22px", borderRadius: 9, border: "none", background: aba === t.id ? `linear-gradient(135deg,${T.laranja},${T.laranjaM})` : "transparent", color: aba === t.id ? "#fff" : T.muted, fontSize: 13, fontWeight: aba === t.id ? 700 : 400, cursor: "pointer" }}>{t.label}</button>
        ))}
      </div>

      {aba === "painel" && (
        clienteComDmg.length === 0 ? (
          <Card style={{ textAlign: "center", padding: 48 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Nenhum DMG aplicado ainda</div>
            <div style={{ fontSize: 13, color: T.muted, marginBottom: 20 }}>Aplique o primeiro diagnóstico para ver os gráficos</div>
            <Btn onClick={() => setAba("aplicar")}>Aplicar primeiro DMG →</Btn>
          </Card>
        ) : (
          <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
              {[
                { label: "DMGs aplicados", val: clienteComDmg.length, cor: T.azul },
                { label: "Maturidade média", val: `${Math.round(clienteComDmg.reduce((s, c) => s + calcMat(dmgData[c.id]), 0) / clienteComDmg.length)}%`, cor: T.laranjaM },
                { label: "Nível BOM+ (≥60%)", val: clienteComDmg.filter(c => calcMat(dmgData[c.id]) >= 60).length, cor: T.success },
                { label: "Nível CRÍTICO (<40%)", val: clienteComDmg.filter(c => calcMat(dmgData[c.id]) < 40).length, cor: T.danger },
              ].map((s, i) => (
                <Card key={i} style={{ padding: "14px 18px", textAlign: "center" }}>
                  <div style={{ fontSize: 22, fontWeight: 900, color: s.cor }}>{s.val}</div>
                  <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{s.label}</div>
                </Card>
              ))}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 16 }}>
              {clienteComDmg.map(c => {
                const dmg = dmgData[c.id]; const mat = calcMat(dmg);
                const rd = DMG_PILARES.map(p => ({ pilar: DMG_PERGUNTAS[p].label, val: dmg[p] || 0 }));
                const analise = dmg.analiseIA || analisesSalvas[c.id];
                return (
                  <Card key={c.id}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                      <div><div style={{ fontSize: 15, fontWeight: 800 }}>{c.nome}</div><div style={{ fontSize: 11, color: T.muted }}>{c.segmento}</div></div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 26, fontWeight: 900, color: nivelCor(mat) }}>{mat}%</div>
                        <Badge label={nivelLabel(mat)} color={nivelCor(mat)} />
                      </div>
                    </div>
                    <ResponsiveContainer width="100%" height={190}>
                      <RadarChart data={rd}>
                        <PolarGrid stroke={T.border} />
                        <PolarAngleAxis dataKey="pilar" tick={{ fill: T.muted, fontSize: 10 }} />
                        <Radar dataKey="val" stroke={T.laranja} fill={T.laranja} fillOpacity={0.25} strokeWidth={2} />
                      </RadarChart>
                    </ResponsiveContainer>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 5, marginTop: 8, marginBottom: 12 }}>
                      {rd.map((r, i) => (
                        <div key={i} style={{ background: T.cardL, borderRadius: 6, padding: "6px 6px", textAlign: "center" }}>
                          <div style={{ fontSize: 12, fontWeight: 800, color: nivelCor(r.val) }}>{r.val}%</div>
                          <div style={{ fontSize: 8, color: T.muted, marginTop: 1, lineHeight: 1.2 }}>{r.pilar}</div>
                        </div>
                      ))}
                    </div>

                    {/* Análise IA */}
                    <div style={{ marginBottom: 12, padding: "12px 14px", background: analise ? `${T.laranja}12` : T.cardL, borderRadius: 10, border: `1px solid ${analise ? T.laranja + "33" : T.border}` }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: analise ? T.laranja : T.muted, marginBottom: 8 }}>
                        {analise ? "🤖 Análise IA disponível" : "🤖 Análise IA não gerada"}
                      </div>
                      <div style={{ display: "flex", gap: 6 }}>
                        {analise && (
                          <button onClick={() => {
                            const scores = DMG_PILARES.map(p => ({ pilar: p, score: dmg[p] || 0 }));
                            gerarPDFDmg(c, scores, analise, mat);
                          }} style={{ flex: 1, padding: "6px", background: `${T.laranja}22`, border: `1px solid ${T.laranja}44`, borderRadius: 8, color: T.laranja, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>📄 PDF</button>
                        )}
                        {analise && (
                          <button onClick={() => setAnaliseIA(analise)} style={{ flex: 1, padding: "6px", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>👁️ Ver análise</button>
                        )}
                        {!analise && (
                          <div style={{ fontSize: 11, color: T.muted }}>Reaplicar o DMG e gerar análise para disponibilizar aqui.</div>
                        )}
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: 8 }}>
                      <Btn small variant="ghost" style={{ flex: 1 }} onClick={() => { setClienteSel(c.id); setAba("aplicar"); setStep(0); }}>🔄 Reaplicar DMG</Btn>
                      <Btn small variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => onDeleteDmg(c.id)}>🗑️</Btn>
                    </div>
                  </Card>
                );
              })}
            </div>
          </div>
        )
      )}

      {/* Modal de análise IA */}
      {analiseIA && aba === "painel" && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 16, width: "100%", maxWidth: 680, maxHeight: "90vh", overflow: "auto" }}>
            <div style={{ padding: "18px 24px", borderBottom: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, background: T.card }}>
              <div style={{ fontSize: 15, fontWeight: 800 }}>🤖 Análise IA — {clientes.find(c => c.id === clienteSel || analisesSalvas[c.id] === analiseIA)?.nome}</div>
              <button onClick={() => setAnaliseIA(null)} style={{ background: "none", border: "none", color: T.muted, fontSize: 20, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: 24, display: "flex", flexDirection: "column", gap: 20 }}>
              {[
                { key: "maturidade", label: "🎯 Maturidade de Gestão Identificada", cor: T.azul },
                { key: "positivos", label: "✅ Pontos Positivos", cor: T.success },
                { key: "melhoria", label: "🔧 Pontos de Melhoria", cor: T.warning },
                { key: "focal", label: "🚀 Ponto Focal para Melhoria", cor: T.laranja },
              ].map(t => (
                <div key={t.key} style={{ background: T.cardL, borderRadius: 12, padding: "16px 18px", borderLeft: `4px solid ${t.cor}` }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: t.cor, marginBottom: 10 }}>{t.label}</div>
                  <div style={{ fontSize: 13, lineHeight: 1.8, color: T.text, whiteSpace: "pre-wrap" }}>{analiseIA[t.key]}</div>
                </div>
              ))}
            </div>
            <div style={{ padding: "14px 24px", borderTop: `1px solid ${T.border}`, display: "flex", justifyContent: "flex-end" }}>
              <button onClick={() => setAnaliseIA(null)} style={{ padding: "8px 16px", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.muted, cursor: "pointer", fontSize: 12 }}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {aba === "aplicar" && (
        <div>
          {step === 0 && (
            <Card style={{ maxWidth: 520 }}>
              <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 6 }}>Aplicar novo DMG</div>
              <div style={{ fontSize: 13, color: T.muted, marginBottom: 22 }}>7 pilares · 7 perguntas cada · 49 perguntas no total. Tempo estimado: 20–30 minutos.</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 5, marginBottom: 20 }}>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Selecionar cliente *</label>
                <select value={clienteSel} onChange={e => setClienteSel(e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "10px 14px", fontSize: 14, outline: "none" }}>
                  <option value="">Selecionar cliente...</option>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}{dmgData[c.id] ? " (já possui DMG)" : ""}</option>)}
                </select>
              </div>
              {clienteSel && <div style={{ background: T.cardL, borderRadius: 10, padding: "12px 16px", marginBottom: 20 }}>
                <div style={{ fontSize: 12, color: T.muted, marginBottom: 4 }}>Diagnóstico para:</div>
                <div style={{ fontSize: 15, fontWeight: 800, color: T.laranja }}>{clientes.find(c => c.id === clienteSel)?.nome}</div>
                {dmgData[clienteSel] && <div style={{ fontSize: 11, color: T.warning, marginTop: 4 }}>⚠️ DMG existente será substituído</div>}
              </div>}
              <div style={{ display: "flex", gap: 10 }}>
                <Btn variant="secondary" onClick={() => setAba("painel")}>Cancelar</Btn>
                <Btn disabled={!clienteSel} onClick={() => { setRespostas({}); setAnaliseIA(null); setStep(1); }}>Iniciar →</Btn>
              </div>
            </Card>
          )}

          {step >= 1 && step <= 7 && pilarInfo && (
            <div>
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>{pilarInfo.icon} Pilar {step}/7 — {pilarInfo.label}</div>
                  <div style={{ fontSize: 12, color: T.muted }}>{clientes.find(c => c.id === clienteSel)?.nome}</div>
                </div>
                <div style={{ display: "flex", gap: 4 }}>
                  {DMG_PILARES.map((p, i) => <div key={p} style={{ flex: 1, height: 6, borderRadius: 3, background: i < step - 1 ? T.success : i === step - 1 ? T.laranja : T.border }} />)}
                </div>
                <div style={{ fontSize: 11, color: T.muted, marginTop: 5 }}>{Object.keys(respostasPilar).length}/{pilarInfo.perguntas.length} respondidas</div>
              </div>
              <Card>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, paddingBottom: 16, borderBottom: `1px solid ${T.border}` }}>
                  <div style={{ width: 44, height: 44, borderRadius: 10, background: `${pilarInfo.cor}22`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>{pilarInfo.icon}</div>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 800 }}>{pilarInfo.label}</div>
                    <div style={{ fontSize: 11, color: T.muted }}>Avalie cada afirmação de acordo com a realidade atual</div>
                  </div>
                </div>
                {pilarInfo.perguntas.map((pergunta, idx) => (
                  <div key={idx} style={{ marginBottom: 20, paddingBottom: 20, borderBottom: idx < pilarInfo.perguntas.length - 1 ? `1px solid ${T.border}` : "none" }}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, lineHeight: 1.5 }}><span style={{ color: T.laranjaM, fontWeight: 800, marginRight: 6 }}>{idx + 1}.</span>{pergunta}</div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {DMG_ESCALA.map(e => {
                        const sel = respostasPilar[idx] === e.val;
                        return <button key={e.val} onClick={() => setResposta(pilarAtual, idx, e.val)} style={{ padding: "8px 14px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 600, border: `2px solid ${sel ? e.cor : T.border}`, background: sel ? `${e.cor}22` : "transparent", color: sel ? e.cor : T.muted, transition: "all 0.15s" }}>{e.label}</button>;
                      })}
                    </div>
                  </div>
                ))}
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
                  <Btn variant="ghost" onClick={() => setStep(s => s - 1)}>{step > 1 ? "← Anterior" : "← Voltar"}</Btn>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ fontSize: 12, color: T.muted }}>Score: <span style={{ fontWeight: 800, color: T.laranja }}>{scorePilar(pilarAtual)}%</span></div>
                    <Btn onClick={() => setStep(s => s + 1)}>{step < 7 ? "Próximo →" : "Ver resultado →"}</Btn>
                  </div>
                </div>
              </Card>
            </div>
          )}

          {step === 8 && (
            <Card>
              <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 4 }}>Resultado — {clientes.find(c => c.id === clienteSel)?.nome}</div>
              <div style={{ fontSize: 13, color: T.muted, marginBottom: 20 }}>Revise antes de salvar</div>
              <div style={{ display: "flex", alignItems: "center", gap: 24, marginBottom: 24, padding: "20px", background: T.cardL, borderRadius: 12 }}>
                <div style={{ textAlign: "center", flexShrink: 0 }}>
                  <div style={{ fontSize: 52, fontWeight: 900, color: nivelCor(scoreTotal()), lineHeight: 1 }}>{scoreTotal()}%</div>
                  <div style={{ fontSize: 12, color: T.muted, marginTop: 4 }}>Score Geral</div>
                  <Badge label={nivelLabel(scoreTotal())} color={nivelCor(scoreTotal())} />
                </div>
                <div style={{ flex: 1 }}>
                  <ResponsiveContainer width="100%" height={180}>
                    <RadarChart data={DMG_PILARES.map(p => ({ pilar: DMG_PERGUNTAS[p].label, val: scorePilar(p) }))}>
                      <PolarGrid stroke={T.border} />
                      <PolarAngleAxis dataKey="pilar" tick={{ fill: T.muted, fontSize: 10 }} />
                      <Radar dataKey="val" stroke={T.laranja} fill={T.laranja} fillOpacity={0.25} strokeWidth={2} />
                    </RadarChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 10, marginBottom: 20 }}>
                {DMG_PILARES.map(p => {
                  const score = scorePilar(p); const info = DMG_PERGUNTAS[p];
                  return (
                    <div key={p} style={{ background: T.cardL, borderRadius: 10, padding: "12px 14px", display: "flex", alignItems: "center", gap: 12 }}>
                      <div style={{ fontSize: 20 }}>{info.icon}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 12, fontWeight: 700 }}>{info.label}</div>
                        <div style={{ height: 4, background: T.border, borderRadius: 4, marginTop: 6 }}><div style={{ height: "100%", width: `${score}%`, background: nivelCor(score), borderRadius: 4 }} /></div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 14, fontWeight: 900, color: nivelCor(score) }}>{score}%</div>
                        <div style={{ fontSize: 9, color: nivelCor(score), fontWeight: 600 }}>{nivelLabel(score)}</div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* ANÁLISE IA */}
              <div style={{ marginBottom: 20, padding: "16px", background: `${T.laranja}12`, borderRadius: 12, border: `1px solid ${T.laranja}33` }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: analiseIA ? 16 : 0 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 800, color: T.laranja }}>🤖 Análise Inteligente — Tom Lumen</div>
                    <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>A IA analisa os scores e gera os 4 tópicos do relatório</div>
                  </div>
                  <button onClick={gerarAnaliseIA} disabled={gerandoIA} style={{ padding: "8px 16px", background: `linear-gradient(135deg,${T.laranja},${T.laranjaM})`, border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: gerandoIA ? "not-allowed" : "pointer", opacity: gerandoIA ? 0.7 : 1 }}>
                    {gerandoIA ? "⏳ Gerando..." : analiseIA ? "🔄 Regenerar" : "✨ Gerar análise"}
                  </button>
                </div>
                {analiseIA && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    {[
                      { key: "maturidade", label: "🎯 Maturidade de Gestão Identificada", cor: T.azul },
                      { key: "positivos", label: "✅ Pontos Positivos", cor: T.success },
                      { key: "melhoria", label: "🔧 Pontos de Melhoria", cor: T.warning },
                      { key: "focal", label: "🚀 Ponto Focal para Melhoria", cor: T.laranja },
                    ].map(t => (
                      <div key={t.key} style={{ background: T.card, borderRadius: 10, padding: "14px 16px", borderLeft: `4px solid ${t.cor}` }}>
                        <div style={{ fontSize: 12, fontWeight: 800, color: t.cor, marginBottom: 8 }}>{t.label}</div>
                        <div style={{ fontSize: 12, lineHeight: 1.8, color: T.text, whiteSpace: "pre-wrap" }}>{analiseIA[t.key]}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                <Btn variant="ghost" onClick={() => setStep(7)}>← Revisar</Btn>
                <div style={{ display: "flex", gap: 8 }}>
                  {analiseIA && (
                    <Btn variant="ghost" style={{ color: T.laranja, borderColor: T.laranja }} onClick={() => {
                      const scores = DMG_PILARES.map(p => ({ pilar: p, score: scorePilar(p) }));
                      const cliente = clientes.find(c => c.id === clienteSel);
                      gerarPDFDmg(cliente, scores, analiseIA, scoreTotal());
                    }}>📄 Gerar PDF</Btn>
                  )}
                  <Btn onClick={salvar}>✅ Salvar DMG</Btn>
                </div>
              </div>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}

// ─── FORMS ───────────────────────────────────────────────────────────────────
// ─── FORM CONSULTOR ───────────────────────────────────────────────────────────
function FormConsultor({ data, isAdmin, usuarioLogado, onSave, onDelete, onClose }) {
  const podeEditarValor = isAdmin; // Gestor (isAdmin=true aqui) pode editar valores; Admin puro não

  const [f, setF] = useState({
    nome: "", email: "", telefone: "", especialidade: "", status: "Ativo",
    valorHoraAtendimento: 0, valorHoraDeslocamento: 0, bio: "",
    consultorEmail: "", consultorSenha: "",
    ...(data || {})
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}><Field label="Nome completo *" value={f.nome} onChange={s("nome")} required /></div>
        <Field label="E-mail" value={f.email} onChange={s("email")} type="email" />
        <Field label="Telefone" value={f.telefone} onChange={s("telefone")} />
        <Field label="Especialidade / Área" value={f.especialidade} onChange={s("especialidade")} />
        <Field label="Status" value={f.status} onChange={s("status")} options={["Ativo", "Inativo"]} />
        <div style={{ gridColumn: "1/-1" }}><Field label="Bio / Observações" value={f.bio} onChange={s("bio")} /></div>

        {/* Acesso do consultor */}
        <div style={{ gridColumn: "1/-1", padding: "16px", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 12 }}>🔐 Acesso do consultor ao portal</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <Field label="E-mail de acesso" value={f.consultorEmail} onChange={s("consultorEmail")} type="email" placeholder="email@consultor.com" />
            <Field label="Senha de acesso" value={f.consultorSenha} onChange={s("consultorSenha")} placeholder="Criar senha..." />
          </div>
        </div>

        {/* Valores hora — só Gestor vê */}
        {podeEditarValor && (
          <div style={{ gridColumn: "1/-1", padding: "16px", background: `${T.laranja}11`, borderRadius: 10, border: `1px solid ${T.laranja}44` }}>
            <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 12, color: T.laranja }}>
              💰 Valores de Pagamento
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Valor hora atendimento (R$)</label>
                <input type="number" step="0.01" value={f.valorHoraAtendimento} onChange={e => s("valorHoraAtendimento")(Number(e.target.value))}
                  style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Valor hora deslocamento (R$) *+1h</label>
                <input type="number" step="0.01" value={f.valorHoraDeslocamento} onChange={e => s("valorHoraDeslocamento")(Number(e.target.value))}
                  style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        {f.id && <Btn variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => onDelete(f.id)}>🗑️ Remover</Btn>}
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}

function FormEspecialista({ data, onSave, onClose }) {
  const [f, setF] = useState({ nome: "", email: "", senha: "", perfil: "Especialista", especialidade: "", status: "Ativo", telefone: "", bio: "", tipoAtuacao: [], ...(data || { tipoAtuacao: [] }) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  const [showSenha, setShowSenha] = useState(false);

  const toggleAtuacao = (tipo) => {
    setF(p => {
      const atual = p.tipoAtuacao || [];
      const jatem = atual.includes(tipo);
      return { ...p, tipoAtuacao: jatem ? atual.filter(t => t !== tipo) : [...atual, tipo] };
    });
  };

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}><Field label="Nome completo" value={f.nome} onChange={s("nome")} required /></div>
        <Field label="E-mail" value={f.email} onChange={s("email")} type="email" required />
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Senha {!data?.id && "*"}</label>
          <div style={{ position: "relative" }}>
            <input type={showSenha ? "text" : "password"} value={f.senha} onChange={e => s("senha")(e.target.value)} placeholder={data?.id ? "Deixe em branco para manter" : "Criar senha..."} style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 36px 9px 12px", fontSize: 13, outline: "none" }} />
            <button onClick={() => setShowSenha(v => !v)} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: T.muted, cursor: "pointer" }}>{showSenha ? "🙈" : "👁️"}</button>
          </div>
        </div>
        <Field label="Perfil de acesso" value={f.perfil} onChange={s("perfil")} options={["Admin", "Gestor", "Especialista"]} />
        <Field label="Status" value={f.status} onChange={s("status")} options={["Ativo", "Inativo", "Parceiro externo"]} />

        {/* Tipo de Atuação — múltipla escolha */}
        <div style={{ gridColumn: "1/-1", display: "flex", flexDirection: "column", gap: 8 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Tipo de Atuação</label>
          <div style={{ display: "flex", gap: 10 }}>
            {["Especialista", "Estratégico"].map(tipo => {
              const selecionado = (f.tipoAtuacao || []).includes(tipo);
              return (
                <button key={tipo} type="button" onClick={() => toggleAtuacao(tipo)} style={{
                  flex: 1, padding: "10px 16px", borderRadius: 10, cursor: "pointer",
                  border: `2px solid ${selecionado ? T.laranja : T.border}`,
                  background: selecionado ? `${T.laranja}22` : "transparent",
                  color: selecionado ? T.laranja : T.muted,
                  fontWeight: selecionado ? 700 : 400,
                  fontSize: 13, transition: "all 0.15s",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                }}>
                  <span style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${selecionado ? T.laranja : T.border}`, background: selecionado ? T.laranja : "transparent", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#fff", flexShrink: 0 }}>
                    {selecionado ? "✓" : ""}
                  </span>
                  {tipo}
                </button>
              );
            })}
          </div>
          {(f.tipoAtuacao || []).length > 0 && (
            <div style={{ fontSize: 11, color: T.laranjaM }}>
              ✅ Selecionado: {(f.tipoAtuacao || []).join(" + ")}
            </div>
          )}
        </div>

        <Field label="Especialidade" value={f.especialidade} onChange={s("especialidade")} />
        <Field label="Telefone" value={f.telefone} onChange={s("telefone")} />
        <div style={{ gridColumn: "1/-1" }}><Field label="Bio / Descrição" value={f.bio} onChange={s("bio")} /></div>
      </div>
      <div style={{ marginTop: 14, padding: "10px 14px", background: `${T.azul}18`, borderRadius: 8, fontSize: 11, color: T.muted }}>
        🔒 <b style={{ color: T.text }}>Acesso ao sistema:</b> O especialista fará login com o e-mail e senha cadastrados acima.
        {f.perfil === "Admin" ? " Perfil Admin tem acesso total à plataforma." : f.perfil === "Gestor" ? " Perfil Gestor tem acesso ao módulo de consultores e relatórios financeiros." : " Perfil Especialista vê apenas seus projetos e visitas."}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => { const salvar = { ...f }; if (!salvar.senha && data?.id) salvar.senha = data.senha; onSave(salvar); }}>✅ Salvar</Btn>
      </div>
    </>
  );
}

function FormCliente({ data, especialistas, tiposProjeto, marcosBase, onSave, onDelete, onClose }) {
  const [f, setF] = useState({ nome: "", segmento: "", especialistaId: "", mentorId: "", tipoProjetoId: "", status: "Ativo", contrato: "", valor: "", horasContratadas: "", telefone: "", email: "", cidade: "", clienteEmail: "", clienteSenha: "", marcosDoProjetoIds: [], ...(data || {}) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  const [showClienteSenha, setShowClienteSenha] = useState(false);

  const somenteEspecialistas = especialistas.filter(e => (e.tipoAtuacao || []).includes("Especialista"));
  const somenteEstrategicos = especialistas.filter(e => (e.tipoAtuacao || []).includes("Estratégico"));

  // Filtra marcos: Globais + Específicos do tipo selecionado
  const marcosDisponiveis = (marcosBase || []).filter(m =>
    m.tipoMarco === "Global" || !m.tipoMarco ||
    (m.tipoMarco === "Específico" && m.tipoProjetoId === f.tipoProjetoId)
  );

  const marcosDoProjetoIds = f.marcosDoProjetoIds || [];
  const marcosNaoProjeto = marcosDisponiveis.filter(m => !marcosDoProjetoIds.find(mp => mp.id === m.id));

  const addMarco = (marcoId) => {
    const marco = marcosDisponiveis.find(m => m.id === marcoId);
    if (!marco) return;
    setF(p => ({ ...p, marcosDoProjetoIds: [...(p.marcosDoProjetoIds || []), { id: marco.id, titulo: marco.titulo, prazo: "", prioridade: marco.prioridade || "Média", status: "A Iniciar" }] }));
  };
  const updateMarcoProj = (idx, campo, val) => setF(p => ({ ...p, marcosDoProjetoIds: p.marcosDoProjetoIds.map((m, i) => i === idx ? { ...m, [campo]: val } : m) }));
  const removeMarcoProj = (idx) => setF(p => ({ ...p, marcosDoProjetoIds: p.marcosDoProjetoIds.filter((_, i) => i !== idx) }));

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}><Field label="Nome do cliente" value={f.nome} onChange={s("nome")} required /></div>
        <Field label="Segmento" value={f.segmento} onChange={s("segmento")} options={SEGMENTOS} required />

        {/* Tipo de Projeto */}
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Tipo de Projeto</label>
          <select value={f.tipoProjetoId} onChange={e => { s("tipoProjetoId")(e.target.value); setF(p => ({ ...p, tipoProjetoId: e.target.value, marcosDoProjetoIds: [] })); }} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Selecionar...</option>
            {(tiposProjeto || []).map(t => <option key={t.id} value={t.id}>{t.tipo}</option>)}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Especialista responsável *</label>
          <select value={f.especialistaId} onChange={e => s("especialistaId")(e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Selecionar...</option>
            {(somenteEspecialistas.length > 0 ? somenteEspecialistas : especialistas).map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Mentor do projeto</label>
          <select value={f.mentorId} onChange={e => s("mentorId")(e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Selecionar...</option>
            {(somenteEstrategicos.length > 0 ? somenteEstrategicos : especialistas).map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
          </select>
        </div>

        <Field label="Status" value={f.status} onChange={s("status")} options={["Ativo", "Em andamento", "Novo", "Encerrado"]} />
        <Field label="Data do contrato" value={f.contrato} onChange={s("contrato")} type="date" />
        <Field label="Valor mensal (R$)" value={f.valor} onChange={s("valor")} type="number" />
        <Field label="Horas contratadas" value={f.horasContratadas} onChange={s("horasContratadas")} type="number" />
        <Field label="Telefone" value={f.telefone} onChange={s("telefone")} />
        <Field label="E-mail comercial" value={f.email} onChange={s("email")} type="email" />
        <div style={{ gridColumn: "1/-1" }}><Field label="Cidade/Estado" value={f.cidade} onChange={s("cidade")} /></div>

        {/* Grid de Marcos do Projeto */}
        <div style={{ gridColumn: "1/-1", marginTop: 8, paddingTop: 16, borderTop: `1px solid ${T.border}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800 }}>🎯 Marcos do Projeto</div>
              <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>Marcos Globais + Específicos do tipo selecionado</div>
            </div>
            {marcosNaoProjeto.length > 0 && (
              <select onChange={e => { if (e.target.value) { addMarco(e.target.value); e.target.value = ""; } }} style={{ background: T.cardL, border: `1px solid ${T.azul}`, borderRadius: 8, color: T.azul, padding: "6px 12px", fontSize: 12, outline: "none", cursor: "pointer" }}>
                <option value="">+ Adicionar marco...</option>
                {marcosNaoProjeto.map(m => <option key={m.id} value={m.id}>{m.titulo} {m.tipoMarco === "Específico" ? "🎯" : "🌐"}</option>)}
              </select>
            )}
          </div>
          {marcosDoProjetoIds.length === 0 ? (
            <div style={{ padding: "12px", border: `1px dashed ${T.border}`, borderRadius: 10, textAlign: "center", color: T.muted, fontSize: 12 }}>
              {!f.tipoProjetoId ? "Selecione o Tipo de Projeto para ver os marcos disponíveis" : "Nenhum marco adicionado — use o seletor acima"}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 120px 90px 100px 30px", gap: 8 }}>
                {["Marco", "Prazo", "Prioridade", "Status", ""].map(h => <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700, paddingLeft: 4 }}>{h}</div>)}
              </div>
              {marcosDoProjetoIds.map((mp, idx) => {
                const corSt = mp.status === "Concluído" ? T.success : mp.status === "Atrasado" ? T.danger : mp.status === "Iniciado" ? T.laranjaM : T.azul;
                return (
                <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 120px 90px 100px 30px", gap: 8, alignItems: "center", padding: "8px 10px", background: T.cardL, borderRadius: 8, borderLeft: `3px solid ${corSt}` }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>{mp.titulo}</div>
                  <input type="date" value={mp.prazo || ""} onChange={e => updateMarcoProj(idx, "prazo", e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "5px 8px", fontSize: 11, outline: "none" }} />
                  <select value={mp.prioridade || "Média"} onChange={e => updateMarcoProj(idx, "prioridade", e.target.value)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: prioColor(mp.prioridade || "Média"), padding: "5px 8px", fontSize: 11, outline: "none", fontWeight: 700 }}>
                    <option value="Alta">🔴 Alta</option>
                    <option value="Média">🟡 Média</option>
                    <option value="Baixa">🟢 Baixa</option>
                  </select>
                  <select value={mp.status || "A Iniciar"} onChange={e => updateMarcoProj(idx, "status", e.target.value)} style={{ background: T.card, border: `1px solid ${corSt}44`, borderRadius: 6, color: corSt, padding: "5px 8px", fontSize: 11, outline: "none", fontWeight: 700 }}>
                    {["A Iniciar","Iniciado","Atrasado","Concluído"].map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  <button onClick={() => removeMarcoProj(idx)} style={{ width: 28, height: 28, borderRadius: 6, background: `${T.danger}18`, border: "none", color: T.danger, cursor: "pointer", fontSize: 12 }}>✕</button>
                </div>
              )})}
            </div>
          )}
        </div>

        {/* Acesso do cliente */}
        <div style={{ gridColumn: "1/-1", marginTop: 8, paddingTop: 16, borderTop: `1px solid ${T.border}` }}>
          <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 4 }}>🔐 Acesso do cliente ao portal</div>
          <div style={{ fontSize: 11, color: T.muted, marginBottom: 14 }}>O cliente usará estas credenciais para acessar o painel do projeto</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <Field label="E-mail de acesso do cliente" value={f.clienteEmail} onChange={s("clienteEmail")} type="email" placeholder="email@empresa.com" />
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Senha de acesso</label>
              <div style={{ position: "relative" }}>
                <input type={showClienteSenha ? "text" : "password"} value={f.clienteSenha} onChange={e => s("clienteSenha")(e.target.value)} placeholder="Criar senha para o cliente..." style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 36px 9px 12px", fontSize: 13, outline: "none" }} />
                <button type="button" onClick={() => setShowClienteSenha(v => !v)} style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: T.muted, cursor: "pointer" }}>{showClienteSenha ? "🙈" : "👁️"}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        {f.id && <Btn variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => { onDelete(f.id); }}>🗑️ Remover</Btn>}
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}
function FormVisita({ data, clientes, especialistas, consultores, isAdmin, usuarioLogado, onSave, onDelete, onClose }) {
  const DRAFT_KEY = `lumen360_draft_visita_${data?.id || "nova"}`;

  // Recupera rascunho salvo (só para visitas novas ou edição sem dados críticos perdidos)
  const draftSalvo = (() => {
    try { const d = localStorage.getItem(DRAFT_KEY); return d ? JSON.parse(d) : null; } catch { return null; }
  })();

  const estadoInicial = {
    clienteId: "", especialistaId: usuarioLogado?.id || "", consultorId: null,
    tipoAgenda: "Projeto", tipo: "Consultoria", data: new Date().toISOString().split("T")[0],
    duracao: 0, descricao: "", status: "Agendada",
    itensPauta: [], ganhos: [], ata: "", tarefasGeradas: [], anexos: [], horarios: [],
    despesaViagem: [],
    ...(data || {}),
    ...(draftSalvo && !data?.id ? draftSalvo : {}), // aplica rascunho só em visitas NOVAS
  };

  const [f, setF] = useState(estadoInicial); // eslint-disable-line no-unused-vars
  const [salvando, setSalvando] = useState(false); // FIX 2: anti-duplicação
  const [draftRestaurado, setDraftRestaurado] = useState(!!(draftSalvo && !data?.id));

  // Autosave: salva rascunho no localStorage a cada alteração (só visitas novas)
  const setFComDraft = (updater) => {
    setF(prev => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (!data?.id) {
        try { localStorage.setItem(DRAFT_KEY, JSON.stringify(next)); } catch {}
      }
      return next;
    });
  };

  const s = k => v => setFComDraft(p => ({ ...p, [k]: v }));
  const [uploading, setUploading] = useState(false);

  const limparDraft = () => { try { localStorage.removeItem(DRAFT_KEY); } catch {} };

  // Itens de pauta + stakeholders
  const addItemPauta = () => setFComDraft(p => ({ ...p, itensPauta: [...(p.itensPauta || []), { item: "", stakeholder: "" }] }));
  const setItemPauta = (idx, campo, val) => setFComDraft(p => ({ ...p, itensPauta: p.itensPauta.map((x, i) => i === idx ? { ...x, [campo]: val } : x) }));
  const removeItemPauta = (idx) => setFComDraft(p => ({ ...p, itensPauta: p.itensPauta.filter((_, i) => i !== idx) }));

  // Ganhos
  const addGanho = () => setFComDraft(p => ({ ...p, ganhos: [...(p.ganhos || []), { tipo: "", valor: "", unidade: "R$" }] }));
  const setGanho = (idx, campo, val) => setFComDraft(p => ({ ...p, ganhos: p.ganhos.map((g, i) => i === idx ? { ...g, [campo]: val } : g) }));
  const removeGanho = (idx) => setFComDraft(p => ({ ...p, ganhos: p.ganhos.filter((_, i) => i !== idx) }));

  // Tarefas
  const addTarefa = () => setFComDraft(p => ({ ...p, tarefasGeradas: [...(p.tarefasGeradas || []), { titulo: "", responsavel: "", prazo: "", prioridade: "Média", status: "Pendente" }] }));
  const setTarefa = (idx, campo, val) => setFComDraft(p => ({ ...p, tarefasGeradas: p.tarefasGeradas.map((t, i) => i === idx ? { ...t, [campo]: val } : t) }));
  const removeTarefa = (idx) => setFComDraft(p => ({ ...p, tarefasGeradas: p.tarefasGeradas.filter((_, i) => i !== idx) }));

  // Upload de anexos para Supabase Storage
  const handleAnexo = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowed = ["application/pdf", "image/jpeg", "image/jpg"];
    if (!allowed.includes(file.type)) { alert("Apenas PDF ou JPEG são permitidos."); return; }
    if (file.size > 10 * 1024 * 1024) { alert("Arquivo muito grande. Máximo 10MB."); return; }
    setUploading(true);
    try {
      const { createClient } = await import("@supabase/supabase-js");
      const sb = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_ANON_KEY);
      const ext = file.name.split('.').pop().toLowerCase();
      const nomeBase = file.name.replace(/\.[^/.]+$/, ""); // remove extensão
      const nomeSeguro = nomeBase
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove acentos
        .replace(/[^a-zA-Z0-9]/g, "_") // substitui TUDO que não for letra/número por _
        .replace(/_+/g, "_") // remove underscores duplos
        .replace(/^_|_$/g, "") // remove _ do início e fim
        .substring(0, 50); // limita tamanho
      const nomeArquivo = `${Date.now()}_${nomeSeguro}.${ext}`;
      const { error } = await sb.storage.from("visitas-anexos").upload(nomeArquivo, file);
      if (error) throw error;
      const { data: urlData } = sb.storage.from("visitas-anexos").getPublicUrl(nomeArquivo);
      const novoAnexo = { nome: file.name, url: urlData.publicUrl, tipo: file.type, tamanho: file.size };
      setFComDraft(p => ({ ...p, anexos: [...(p.anexos || []), novoAnexo] }));
    } catch (err) { alert("Erro ao fazer upload: " + err.message); }
    setUploading(false);
    e.target.value = "";
  };

  const removeAnexo = (idx) => setFComDraft(p => ({ ...p, anexos: p.anexos.filter((_, i) => i !== idx) }));

  const fmtBytes = (b) => b < 1024 * 1024 ? `${Math.round(b / 1024)}KB` : `${(b / (1024 * 1024)).toFixed(1)}MB`;

  return (
    <>
      {/* Indicador de autosave */}
      {!data?.id && (
        <div style={{ fontSize: 10, color: "#6b7a99", textAlign: "right", marginBottom: 6 }}>
          💾 Rascunho salvo automaticamente
        </div>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Cliente *</label>
          <select value={f.clienteId} onChange={e => s("clienteId")(e.target.value)} style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
            <option value="">Selecionar...</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Especialista *</label>
          <select value={f.especialistaId} onChange={e => s("especialistaId")(e.target.value)} disabled={!isAdmin} style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none", opacity: !isAdmin ? 0.7 : 1 }}>
            <option value="">Selecionar...</option>
            {especialistas.map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
          </select>
          {!isAdmin && <div style={{ fontSize: 10, color: T.muted, marginTop: 4 }}>A visita será registrada em seu nome.</div>}
        </div>

        {/* Consultor externo */}
        {(consultores || []).length > 0 && (
          <div style={{ gridColumn: "1/-1" }}>
            <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Consultor externo (opcional)</label>
            <select value={f.consultorId || ""} onChange={e => s("consultorId")(e.target.value || null)} style={{ width: "100%", marginTop: 5, background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
              <option value="">Nenhum consultor externo</option>
              {(consultores || []).filter(c => c.status === "Ativo").map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          </div>
        )}
        <Field label="Tipo de agenda" value={f.tipoAgenda} onChange={s("tipoAgenda")} options={["Estratégia", "Projeto"]} required />
        <Field label="Tipo de atividade" value={f.tipo} onChange={s("tipo")} options={TIPOS_VISITA} />
        <Field label="Data" value={f.data} onChange={s("data")} type="date" required />

        {/* Descrição geral expandida */}
        <div style={{ gridColumn: "1/-1", display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Descrição geral da visita</label>
          <textarea value={f.descricao} onChange={e => s("descricao")(e.target.value)}
            placeholder="Contexto geral, objetivo da visita, observações importantes..."
            rows={3}
            style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "10px 12px", fontSize: 13, outline: "none", resize: "vertical", lineHeight: 1.6 }}
          />
        </div>

        {/* Itens de pauta com stakeholders */}
        <div style={{ gridColumn: "1/-1", marginTop: 4 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800 }}>📋 Itens de Pauta</div>
              <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>Adicione cada item da pauta e o stakeholder envolvido</div>
            </div>
            <button onClick={addItemPauta} style={{ padding: "6px 14px", background: `${T.azul}22`, border: `1px solid ${T.azul}44`, borderRadius: 8, color: T.azul, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Adicionar item</button>
          </div>
          {(f.itensPauta || []).length === 0 ? (
            <div onClick={addItemPauta} style={{ padding: "12px", border: `1px dashed ${T.border}`, borderRadius: 10, textAlign: "center", color: T.muted, fontSize: 12, cursor: "pointer" }}>
              Clique para adicionar itens de pauta
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 180px 32px", gap: 8 }}>
                {["Item / Assunto a tratar", "Stakeholder envolvido", ""].map(h => (
                  <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700, paddingLeft: 4 }}>{h}</div>
                ))}
              </div>
              {(f.itensPauta || []).map((item, idx) => (
                <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 180px 32px", gap: 8, alignItems: "center" }}>
                  <input value={item.item} onChange={e => setItemPauta(idx, "item", e.target.value)}
                    placeholder="Ex: Revisão do DRE, Treinamento equipe, Alinhamento estratégico..."
                    style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                  <input value={item.stakeholder} onChange={e => setItemPauta(idx, "stakeholder", e.target.value)}
                    placeholder="Nome do participante"
                    style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                  <button onClick={() => removeItemPauta(idx)} style={{ width: 32, height: 32, borderRadius: 6, background: `${T.danger}18`, border: `1px solid ${T.danger}33`, color: T.danger, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ gridColumn: "1/-1" }}>
          <Field label="Status" value={f.status} onChange={s("status")} options={["Agendada", "Confirmada", "Realizada", "Cancelada"]} />
        </div>
      </div>

      {/* ANEXOS — aparece sempre (Agendada, Confirmada ou Realizada) */}
      {(f.status === "Agendada" || f.status === "Confirmada" || f.status === "Realizada") && (
        <div style={{ marginTop: 20, paddingTop: 20, borderTop: `1px solid ${T.border}` }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800 }}>📎 Anexos</div>
              <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>PDF ou JPEG · Máximo 10MB por arquivo</div>
            </div>
            <label style={{ padding: "6px 14px", background: `${T.laranjaM}22`, border: `1px solid ${T.laranjaM}44`, borderRadius: 8, color: T.laranjaM, fontSize: 12, fontWeight: 700, cursor: uploading ? "not-allowed" : "pointer" }}>
              {uploading ? "⏳ Enviando..." : "📤 Anexar arquivo"}
              <input type="file" accept=".pdf,.jpg,.jpeg" onChange={handleAnexo} style={{ display: "none" }} disabled={uploading} />
            </label>
          </div>
          {(f.anexos || []).length === 0 ? (
            <div style={{ padding: "12px", border: `1px dashed ${T.border}`, borderRadius: 10, textAlign: "center", color: T.muted, fontSize: 12 }}>
              Nenhum anexo adicionado
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {(f.anexos || []).map((a, idx) => (
                <div key={idx} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: T.cardL, borderRadius: 8, border: `1px solid ${T.border}` }}>
                  <span style={{ fontSize: 18 }}>{a.tipo === "application/pdf" ? "📄" : "🖼️"}</span>
                  <div style={{ flex: 1 }}>
                    <a href={a.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, fontWeight: 600, color: T.azul, textDecoration: "none" }}>{a.nome}</a>
                    <div style={{ fontSize: 10, color: T.muted }}>{fmtBytes(a.tamanho)}</div>
                  </div>
                  <button onClick={() => removeAnexo(idx)} style={{ background: "none", border: "none", color: T.danger, cursor: "pointer", fontSize: 14 }}>✕</button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ATA — aparece quando Realizada */}
      {f.status === "Realizada" && (
        <>
          <div style={{ marginTop: 20, paddingTop: 20, borderTop: `1px solid ${T.border}` }}>
            <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 4 }}>📝 Ata do Atendimento</div>
            <div style={{ fontSize: 11, color: T.muted, marginBottom: 10 }}>Registre o que foi realizado, discutido e decidido nesta visita</div>
            <textarea value={f.ata} onChange={e => s("ata")(e.target.value)}
              placeholder="Descreva o que foi feito, principais discussões, decisões tomadas, alinhamentos realizados..."
              rows={5}
              style={{ width: "100%", background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 10, color: T.text, padding: "12px 14px", fontSize: 13, outline: "none", resize: "vertical", lineHeight: 1.6 }}
            />
          </div>

          <div style={{ marginTop: 20, paddingTop: 20, borderTop: `1px solid ${T.border}` }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 800 }}>📋 Tarefas deixadas ao cliente</div>
                <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>Ações que o cliente deve executar até a próxima visita</div>
              </div>
              <button onClick={addTarefa} style={{ padding: "6px 14px", background: `${T.azul}22`, border: `1px solid ${T.azul}44`, borderRadius: 8, color: T.azul, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Adicionar tarefa</button>
            </div>
            {(f.tarefasGeradas || []).length === 0 ? (
              <div onClick={addTarefa} style={{ padding: "14px", border: `1px dashed ${T.border}`, borderRadius: 10, textAlign: "center", color: T.muted, fontSize: 12, cursor: "pointer" }}>
                Clique para adicionar tarefas ao cliente
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 120px 90px 32px", gap: 8 }}>
                  {["Tarefa / O que fazer", "Responsável no cliente", "Prazo", "Prioridade", ""].map(h => (
                    <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700, paddingLeft: 4 }}>{h}</div>
                  ))}
                </div>
                {(f.tarefasGeradas || []).map((t, idx) => (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 130px 120px 90px 32px", gap: 8, alignItems: "center" }}>
                    <input value={t.titulo} onChange={e => setTarefa(idx, "titulo", e.target.value)} placeholder="Ex: Organizar kardex, Implantar DRE..." style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                    <input value={t.responsavel} onChange={e => setTarefa(idx, "responsavel", e.target.value)} placeholder="Nome do responsável" style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                    <input type="date" value={t.prazo} onChange={e => setTarefa(idx, "prazo", e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                    <select value={t.prioridade} onChange={e => setTarefa(idx, "prioridade", e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: prioColor(t.prioridade), padding: "8px 8px", fontSize: 12, outline: "none", fontWeight: 700 }}>
                      <option value="Alta">🔴 Alta</option>
                      <option value="Média">🟡 Média</option>
                      <option value="Baixa">🟢 Baixa</option>
                    </select>
                    <button onClick={() => removeTarefa(idx)} style={{ width: 32, height: 32, borderRadius: 6, background: `${T.danger}18`, border: `1px solid ${T.danger}33`, color: T.danger, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                  </div>
                ))}
                <div style={{ fontSize: 11, color: T.azul, marginTop: 4 }}>💡 Essas tarefas serão criadas automaticamente no Plano de Ação do projeto.</div>
              </div>
            )}
          </div>

          <div style={{ marginTop: 20, paddingTop: 20, borderTop: `1px solid ${T.border}` }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 800 }}>🏆 Ganhos desta visita</div>
                <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>Registre os resultados e entregas gerados</div>
              </div>
              <button onClick={addGanho} style={{ padding: "6px 14px", background: `${T.success}22`, border: `1px solid ${T.success}44`, borderRadius: 8, color: T.success, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Adicionar ganho</button>
            </div>
            {(f.ganhos || []).length === 0 ? (
              <div onClick={addGanho} style={{ padding: "14px", border: `1px dashed ${T.border}`, borderRadius: 10, textAlign: "center", color: T.muted, fontSize: 12, cursor: "pointer" }}>
                Clique para registrar resultados desta visita
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 120px 100px 32px", gap: 8 }}>
                  {["Tipo de ganho / Descrição", "Valor", "Unidade", ""].map(h => (
                    <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700, paddingLeft: 4 }}>{h}</div>
                  ))}
                </div>
                {(f.ganhos || []).map((g, idx) => (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 120px 100px 32px", gap: 8, alignItems: "center" }}>
                    <input value={g.tipo} onChange={e => setGanho(idx, "tipo", e.target.value)} placeholder="Ex: Economia tributária, Horas reduzidas..." style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                    <input type="number" value={g.valor} onChange={e => setGanho(idx, "valor", e.target.value)} placeholder="0" style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }} />
                    <select value={g.unidade} onChange={e => setGanho(idx, "unidade", e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "8px 10px", fontSize: 12, outline: "none" }}>
                      <option value="R$">R$ (reais)</option>
                      <option value="hrs">hrs (horas)</option>
                      <option value="%">% (percentual)</option>
                      <option value="un">un (unidades)</option>
                      <option value="dias">dias</option>
                    </select>
                    <button onClick={() => removeGanho(idx)} style={{ width: 32, height: 32, borderRadius: 6, background: `${T.danger}18`, border: `1px solid ${T.danger}33`, color: T.danger, cursor: "pointer", fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                  </div>
                ))}
                {(f.ganhos || []).some(g => g.valor && g.unidade === "R$") && (
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
                    <div style={{ padding: "8px 14px", background: `${T.success}18`, border: `1px solid ${T.success}33`, borderRadius: 8, fontSize: 12 }}>
                      <span style={{ color: T.muted }}>Total em R$: </span>
                      <span style={{ fontWeight: 900, color: T.success }}>R$ {(f.ganhos || []).filter(g => g.unidade === "R$" && g.valor).reduce((s, g) => s + Number(g.valor), 0).toLocaleString("pt-BR")}</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}


        {/* Grid de Horários — controle logístico no final */}
        <div style={{ gridColumn: "1/-1", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}`, padding: "14px 16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700 }}>⏱ Horários de Atendimento</div>
              <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>Adicione um ou mais períodos (ex: manhã e tarde separadamente)</div>
            </div>
            <button type="button" onClick={() => setFComDraft(p => ({ ...p, horarios: [...(p.horarios || []), { inicio: "", fim: "", deslocamento: false }] }))}
              style={{ padding: "5px 12px", background: `${T.azul}22`, border: `1px solid ${T.azul}44`, borderRadius: 6, color: T.azul, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
              + Período
            </button>
          </div>

          {(f.horarios || []).length === 0 ? (
            <div style={{ textAlign: "center", padding: "12px 0", color: T.muted, fontSize: 12 }}>
              Nenhum período adicionado — clique em "+ Período"
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {/* Header */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 80px 32px", gap: 8 }}>
                {["Início", "Fim", "Total", ""].map(h => <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>{h}</div>)}
              </div>
              {(f.horarios || []).filter(h => !h.deslocamento).map((h, idx) => {
                // Calcula duração do período
                const calcDur = (ini, fim) => {
                  if (!ini || !fim) return null;
                  const [ih, im] = ini.split(":").map(Number);
                  const [fh, fm] = fim.split(":").map(Number);
                  const mins = (fh * 60 + fm) - (ih * 60 + im);
                  if (mins <= 0) return null;
                  const h = Math.floor(mins / 60);
                  const m = mins % 60;
                  return m > 0 ? `${h}h${m.toString().padStart(2,"0")}` : `${h}h`;
                };
                const dur = calcDur(h.inicio, h.fim);
                return (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 80px 32px", gap: 8, alignItems: "center" }}>
                    <input type="time" value={h.inicio} onChange={e => setFComDraft(p => ({ ...p, horarios: p.horarios.map((x, i) => i === idx ? { ...x, inicio: e.target.value } : x) }))}
                      style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 13, outline: "none" }} />
                    <input type="time" value={h.fim} onChange={e => setFComDraft(p => ({ ...p, horarios: p.horarios.map((x, i) => i === idx ? { ...x, fim: e.target.value } : x) }))}
                      style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 13, outline: "none" }} />
                    <div style={{ fontSize: 12, fontWeight: 700, color: dur ? T.success : T.muted, textAlign: "center" }}>{dur || "—"}</div>
                    <button type="button" onClick={() => setFComDraft(p => ({ ...p, horarios: p.horarios.filter((_, i) => i !== idx) }))}
                      style={{ width: 28, height: 28, borderRadius: 6, background: `${T.danger}18`, border: "none", color: T.danger, cursor: "pointer", fontSize: 13 }}>✕</button>
                  </div>
                );
              })}
              {/* Total geral */}
              {(f.horarios || []).filter(h => !h.deslocamento).length > 0 && (() => {
                const totalMins = (f.horarios || []).filter(h => !h.deslocamento).reduce((acc, h) => {
                  if (!h.inicio || !h.fim) return acc;
                  const [ih, im] = h.inicio.split(":").map(Number);
                  const [fh, fm] = h.fim.split(":").map(Number);
                  const mins = (fh * 60 + fm) - (ih * 60 + im);
                  return acc + (mins > 0 ? mins : 0);
                }, 0);
                const totalH = Math.floor(totalMins / 60);
                const totalM = totalMins % 60;
                const totalStr = totalM > 0 ? `${totalH}h${totalM.toString().padStart(2,"0")}` : `${totalH}h`;
                const totalDecimal = Math.round((totalMins / 60) * 10) / 10;
                // Atualiza duracao automaticamente
                if (f.duracao !== totalDecimal && totalDecimal > 0) {
                  setTimeout(() => setFComDraft(p => ({ ...p, duracao: totalDecimal })), 0);
                }
                return totalMins > 0 ? (
                  <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: 6, borderTop: `1px solid ${T.border}`, marginTop: 4 }}>
                    <span style={{ fontSize: 12, color: T.muted, marginRight: 8 }}>Total:</span>
                    <span style={{ fontSize: 13, fontWeight: 800, color: T.laranja }}>{totalStr}</span>
                  </div>
                ) : null;
              })()}
            </div>
          )}
        </div>

        {/* Grid de Deslocamento */}
        <div style={{ gridColumn: "1/-1", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}`, padding: "14px 16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700 }}>🚗 Deslocamento</div>
              <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>Registre saída/chegada — acima de 1h é remunerado ao consultor</div>
            </div>
            <button type="button" onClick={() => setFComDraft(p => ({ ...p, horarios: [...(p.horarios || []), { inicio: "", fim: "", deslocamento: true }] }))}
              style={{ padding: "5px 12px", background: `${T.laranjaM}22`, border: `1px solid ${T.laranjaM}44`, borderRadius: 6, color: T.laranjaM, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
              + Trecho
            </button>
          </div>
          {(f.horarios || []).filter(h => h.deslocamento).length === 0 ? (
            <div style={{ textAlign: "center", padding: "8px 0", color: T.muted, fontSize: 12 }}>Sem deslocamento — clique em "+ Trecho" se houver</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 90px 32px", gap: 8 }}>
                {["Saída", "Chegada", "Tempo", ""].map(hh => <div key={hh} style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>{hh}</div>)}
              </div>
              {(f.horarios || []).map((h, idx) => {
                if (!h.deslocamento) return null;
                const calcMins = (ini, fim) => { if (!ini || !fim) return 0; const [ih,im] = ini.split(":").map(Number); const [fh,fm] = fim.split(":").map(Number); return (fh*60+fm)-(ih*60+im); };
                const mins = calcMins(h.inicio, h.fim);
                const dur = mins > 0 ? `${Math.floor(mins/60)}h${(mins%60).toString().padStart(2,"0")}` : "—";
                const remunerado = mins > 60;
                return (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 90px 32px", gap: 8, alignItems: "center", padding: "6px 8px", background: remunerado ? `${T.laranja}11` : "transparent", borderRadius: 6 }}>
                    <input type="time" value={h.inicio} onChange={e => setFComDraft(p => ({ ...p, horarios: p.horarios.map((x, i) => i === idx ? { ...x, inicio: e.target.value } : x) }))}
                      style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 13, outline: "none" }} />
                    <input type="time" value={h.fim} onChange={e => setFComDraft(p => ({ ...p, horarios: p.horarios.map((x, i) => i === idx ? { ...x, fim: e.target.value } : x) }))}
                      style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 13, outline: "none" }} />
                    <div style={{ fontSize: 11, fontWeight: 700, color: remunerado ? T.laranja : T.muted, textAlign: "center" }}>
                      {dur}{remunerado ? " 💰" : ""}
                    </div>
                    <button type="button" onClick={() => setFComDraft(p => ({ ...p, horarios: p.horarios.filter((_, i) => i !== idx) }))}
                      style={{ width: 28, height: 28, borderRadius: 6, background: `${T.danger}18`, border: "none", color: T.danger, cursor: "pointer", fontSize: 13 }}>✕</button>
                  </div>
                );
              })}
              <div style={{ fontSize: 10, color: T.muted }}>💰 = deslocamento acima de 1h — será remunerado conforme valor hora deslocamento do consultor</div>
            </div>
          )}
        </div>


        {/* Despesa de viagem */}
        <div style={{ gridColumn: "1/-1", background: T.cardL, borderRadius: 10, border: `1px solid ${T.border}`, padding: "14px 16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700 }}>🧾 Despesas de Viagem</div>
              <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>Alimentação, hospedagem, transporte, etc.</div>
            </div>
            <button type="button" onClick={() => setFComDraft(p => ({ ...p, despesaViagem: [...(p.despesaViagem || []), { descricao: "", valor: "" }] }))}
              style={{ padding: "5px 12px", background: `${T.laranjaM}22`, border: `1px solid ${T.laranjaM}44`, borderRadius: 6, color: T.laranjaM, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
              + Despesa
            </button>
          </div>
          {(f.despesaViagem || []).length === 0 ? (
            <div style={{ textAlign: "center", padding: "8px 0", color: T.muted, fontSize: 12 }}>Nenhuma despesa — clique em "+ Despesa" se houver</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 120px 32px", gap: 8 }}>
                {["Descrição", "Valor (R$)", ""].map(h => <div key={h} style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>{h}</div>)}
              </div>
              {(f.despesaViagem || []).map((d, idx) => (
                <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 120px 32px", gap: 8, alignItems: "center" }}>
                  <input value={d.descricao} onChange={e => setFComDraft(p => ({ ...p, despesaViagem: p.despesaViagem.map((x, i) => i === idx ? { ...x, descricao: e.target.value } : x) }))}
                    placeholder="Ex: Almoço com cliente, Uber..."
                    style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 12, outline: "none" }} />
                  <input type="number" step="0.01" value={d.valor} onChange={e => setFComDraft(p => ({ ...p, despesaViagem: p.despesaViagem.map((x, i) => i === idx ? { ...x, valor: e.target.value } : x) }))}
                    placeholder="0,00"
                    style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 6, color: T.text, padding: "7px 10px", fontSize: 12, outline: "none" }} />
                  <button type="button" onClick={() => setFComDraft(p => ({ ...p, despesaViagem: p.despesaViagem.filter((_, i) => i !== idx) }))}
                    style={{ width: 28, height: 28, borderRadius: 6, background: `${T.danger}18`, border: "none", color: T.danger, cursor: "pointer", fontSize: 12 }}>✕</button>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: 6, borderTop: `1px solid ${T.border}` }}>
                <span style={{ fontSize: 11, color: T.muted, marginRight: 8 }}>Total:</span>
                <span style={{ fontSize: 13, fontWeight: 800, color: T.laranjaM }}>
                  {fmtMoeda((f.despesaViagem || []).reduce((s, d) => s + (Number(d.valor) || 0), 0))}
                </span>
              </div>
            </div>
          )}
        </div>

      {/* Aviso de rascunho restaurado */}
      {draftRestaurado && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: `${T.laranja}15`, border: `1px solid ${T.laranja}44`, borderRadius: 8, padding: "10px 14px", marginTop: 14 }}>
          <div style={{ fontSize: 12, color: T.laranja }}>
            📝 <strong>Rascunho restaurado</strong> — você tinha informações não salvas. Continue de onde parou!
          </div>
          <button onClick={() => { limparDraft(); setDraftRestaurado(false); setFComDraft({ clienteId: "", especialistaId: usuarioLogado?.id || "", consultorId: null, tipoAgenda: "Projeto", tipo: "Consultoria", data: new Date().toISOString().split("T")[0], duracao: 0, descricao: "", status: "Agendada", itensPauta: [], ganhos: [], ata: "", tarefasGeradas: [], anexos: [], horarios: [], despesaViagem: [] }); }}
            style={{ fontSize: 11, background: "none", border: `1px solid ${T.laranja}44`, borderRadius: 6, color: T.laranja, padding: "3px 10px", cursor: "pointer" }}>
            Descartar
          </button>
        </div>
      )}

      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        {onDelete && <Btn variant="ghost" style={{ color: T.danger, borderColor: T.danger, marginRight: "auto" }} onClick={() => onDelete(f.id)}>🗑️ Excluir</Btn>}
        <Btn variant="secondary" onClick={() => { limparDraft(); onClose(); }}>Cancelar</Btn>
        <Btn
          disabled={uploading || salvando}
          onClick={async () => {
            if (salvando) return; // FIX 2: bloqueia duplo clique
            setSalvando(true);
            try {
              await onSave(f);
              limparDraft(); // limpa rascunho após salvar com sucesso
            } finally {
              setSalvando(false);
            }
          }}>
          {salvando ? "⏳ Salvando..." : uploading ? "⏳ Aguarde..." : "✅ Salvar"}
        </Btn>
      </div>
    </>
  );
}

// ─── MODAL DE MARCOS DO PROJETO ──────────────────────────────────────────────
function MarcosProjetoModal({ cliente, onSave, onClose }) {
  const STATUS_MARCO = ["A Iniciar", "Iniciado", "Atrasado", "Concluído"];
  const corStatus = (s) => {
    if (s === "Concluído") return T.success;
    if (s === "Iniciado") return T.laranjaM;
    if (s === "Atrasado") return T.danger;
    return T.azul;
  };

  const [marcos, setMarcos] = useState(
    (cliente?.marcosDoProjetoIds || []).map(m => ({ ...m, status: m.status || "A Iniciar" }))
  );

  const updateStatus = (idx, status) => setMarcos(prev => prev.map((m, i) => i === idx ? { ...m, status } : m));

  const salvar = async () => {
    await onSave({ ...cliente, marcosDoProjetoIds: marcos });
    onClose();
  };

  return (
    <>
      {marcos.length === 0 ? (
        <div style={{ padding: "24px", textAlign: "center", color: T.muted, fontSize: 13 }}>
          Nenhum marco vinculado a este projeto.<br />
          <span style={{ fontSize: 11 }}>Edite o projeto para adicionar marcos.</span>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {/* Header */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 130px 130px", gap: 12, padding: "0 4px", marginBottom: 4 }}>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700 }}>Marco</div>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700 }}>Prazo</div>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700 }}>Status</div>
          </div>
          {marcos.map((m, idx) => {
            const vencido = m.prazo && m.prazo < new Date().toISOString().split("T")[0] && m.status !== "Concluído";
            return (
              <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 130px 130px", gap: 12, alignItems: "center", padding: "12px 14px", background: T.cardL, borderRadius: 10, borderLeft: `4px solid ${corStatus(m.status)}` }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>{m.titulo}</div>
                  <div style={{ fontSize: 10, color: T.muted, marginTop: 2 }}>
                    <Badge label={m.prioridade || "Média"} color={prioColor(m.prioridade || "Média")} />
                  </div>
                </div>
                <input
                  type="date"
                  value={m.prazo || ""}
                  onChange={e => setMarcos(prev => prev.map((x, i) => i === idx ? { ...x, prazo: e.target.value } : x))}
                  style={{ background: T.card, border: `1px solid ${vencido ? T.danger : T.border}`, borderRadius: 8, color: vencido ? T.danger : T.text, padding: "6px 8px", fontSize: 11, outline: "none" }}
                />
                <select
                  value={m.status || "A Iniciar"}
                  onChange={e => updateStatus(idx, e.target.value)}
                  style={{ background: T.card, border: `1px solid ${corStatus(m.status)}44`, borderRadius: 8, color: corStatus(m.status), padding: "6px 8px", fontSize: 11, fontWeight: 700, outline: "none", cursor: "pointer" }}
                >
                  {STATUS_MARCO.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            );
          })}
        </div>
      )}
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={salvar}>✅ Salvar</Btn>
      </div>
    </>
  );
}

// ─── FORM PROSPECT ────────────────────────────────────────────────────────────
function FormProspect({ data, onSave, onDelete, onClose }) {
  const [f, setF] = useState({
    nome: "", responsavel: "", segmento: "", telefone: "", cidade: "",
    emailResponsavel: "", obs: "", fase: "CONTRATANDO",
    ...(data || {})
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}><Field label="Nome da empresa *" value={f.nome} onChange={s("nome")} required /></div>
        <Field label="Responsável" value={f.responsavel} onChange={s("responsavel")} />
        <Field label="Segmento" value={f.segmento} onChange={s("segmento")} options={SEGMENTOS} />
        <Field label="Telefone" value={f.telefone} onChange={s("telefone")} />
        <Field label="Cidade/Estado" value={f.cidade} onChange={s("cidade")} />
        <div style={{ gridColumn: "1/-1" }}><Field label="E-mail do responsável" value={f.emailResponsavel} onChange={s("emailResponsavel")} type="email" /></div>
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 8 }}>Fase do Pipeline</label>
          <div style={{ display: "flex", gap: 8 }}>
            {FASES_PIPELINE.map(fase => (
              <button key={fase} type="button" onClick={() => s("fase")(fase)} style={{
                flex: 1, padding: "8px", borderRadius: 8, cursor: "pointer", fontSize: 11, fontWeight: 700,
                border: `2px solid ${f.fase === fase ? COR_FASE[fase] : T.border}`,
                background: f.fase === fase ? `${COR_FASE[fase]}22` : "transparent",
                color: f.fase === fase ? COR_FASE[fase] : T.muted,
              }}>{fase}</button>
            ))}
          </div>
        </div>
        <div style={{ gridColumn: "1/-1" }}><Field label="Observações" value={f.obs} onChange={s("obs")} /></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        {f.id && <Btn variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => onDelete(f.id)}>🗑️ Remover</Btn>}
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}

function FormTipoProjeto({ data, onSave, onDelete, onClose }) {
  const [f, setF] = useState({ tipo: "", descricao: "", ...(data || {}) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <Field label="Tipo *" value={f.tipo} onChange={s("tipo")} placeholder="Ex: Consultoria Lean, Gestão Financeira..." required />
        <Field label="Descrição" value={f.descricao} onChange={s("descricao")} placeholder="Descreva o escopo deste tipo de projeto..." />
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        {f.id && <Btn variant="ghost" style={{ color: T.danger, borderColor: T.danger }} onClick={() => onDelete(f.id)}>🗑️ Remover</Btn>}
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}

function FormMarco({ data, tiposProjeto, onSave, onClose }) {
  const [f, setF] = useState({ titulo: "", tipoMarco: "Global", descricao: "", tipoProjetoId: "", prioridade: "Média", ...(data || {}) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div style={{ gridColumn: "1/-1" }}><Field label="Título *" value={f.titulo} onChange={s("titulo")} required /></div>

        {/* Tipo de Marco */}
        <div style={{ gridColumn: "1/-1" }}>
          <label style={{ fontSize: 11, color: T.muted, fontWeight: 600, display: "block", marginBottom: 8 }}>Tipo de Marco *</label>
          <div style={{ display: "flex", gap: 10 }}>
            {["Global", "Específico"].map(tipo => {
              const sel = f.tipoMarco === tipo;
              return (
                <button key={tipo} type="button" onClick={() => s("tipoMarco")(tipo)} style={{
                  flex: 1, padding: "10px 16px", borderRadius: 10, cursor: "pointer",
                  border: `2px solid ${sel ? (tipo === "Global" ? T.azul : "#8b5cf6") : T.border}`,
                  background: sel ? `${tipo === "Global" ? T.azul : "#8b5cf6"}22` : "transparent",
                  color: sel ? (tipo === "Global" ? T.azul : "#8b5cf6") : T.muted,
                  fontWeight: sel ? 700 : 400, fontSize: 13,
                }}>
                  {tipo === "Global" ? "🌐 Global" : "🎯 Específico"}
                  <div style={{ fontSize: 10, marginTop: 2, fontWeight: 400 }}>
                    {tipo === "Global" ? "Aplica a todos os projetos" : "Exclusivo de um tipo de projeto"}
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Tipo de Projeto — só aparece quando Específico */}
        {f.tipoMarco === "Específico" && (
          <div style={{ gridColumn: "1/-1", display: "flex", flexDirection: "column", gap: 5 }}>
            <label style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Tipo de Projeto *</label>
            <select value={f.tipoProjetoId} onChange={e => s("tipoProjetoId")(e.target.value)} style={{ background: T.cardL, border: `1px solid ${T.border}`, borderRadius: 8, color: T.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
              <option value="">Selecionar tipo de projeto...</option>
              {tiposProjeto.map(t => <option key={t.id} value={t.id}>{t.tipo}</option>)}
            </select>
            {tiposProjeto.length === 0 && <div style={{ fontSize: 11, color: T.warning }}>⚠️ Nenhum tipo cadastrado. Cadastre primeiro em "Tipos de Projeto".</div>}
          </div>
        )}

        <div style={{ gridColumn: "1/-1" }}><Field label="Descrição" value={f.descricao} onChange={s("descricao")} /></div>
        <Field label="Prioridade" value={f.prioridade} onChange={s("prioridade")} options={["Alta", "Média", "Baixa"]} />
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20, justifyContent: "flex-end" }}>
        <Btn variant="secondary" onClick={onClose}>Cancelar</Btn>
        <Btn onClick={() => onSave(f)}>✅ Salvar</Btn>
      </div>
    </>
  );
}
